(function (global) {
  'use strict';

  if (global.KindredCustomBuildIntake && global.KindredCustomBuildIntake.version) {
    if (typeof document !== 'undefined') global.KindredCustomBuildIntake.mount(document);
    return;
  }

  var VERSION = '1.53.0';
  var ANALYTICS_EVENTS = {
    started: 'kindred_configurator_started',
    stepCompleted: 'kindred_configurator_step_completed',
    completed: 'kindred_configurator_completed',
    addedToCart: 'kindred_configurator_added_to_cart',
    consultationSent: 'kindred_configurator_consultation_sent'
  };
  var ANALYTICS_ALLOWED_FIELDS = {
    tool_name: true,
    tool_version: true,
    rules_version: true,
    product_id: true,
    product_handle: true,
    page_path: true,
    product_type: true,
    collection: true,
    shape: true,
    size: true,
    width_choice: true,
    construction: true,
    flex_pattern: true,
    artwork_level: true,
    requires_consultation: true,
    purchase_mode: true,
    consultation_type: true,
    step_name: true,
    step_number: true,
    value: true,
    currency: true
  };
  var analyticsPending = Object.create(null);
  var analyticsCompleted = Object.create(null);
  var analyticsInstanceCount = 0;

  function analyticsHash(value) {
    var source = String(value || 'default');
    var hash = 5381;
    for (var index = 0; index < source.length; index += 1) hash = ((hash << 5) + hash) ^ source.charCodeAt(index);
    return (hash >>> 0).toString(36);
  }

  function analyticsStorageKey(key) {
    return 'kindred-configurator-analytics:' + analyticsHash(key);
  }

  function analyticsWasPersisted(key) {
    try { return Boolean(global.sessionStorage && global.sessionStorage.getItem(analyticsStorageKey(key)) === '1'); }
    catch (error) { return false; }
  }

  function persistAnalyticsCompletion(key) {
    try { if (global.sessionStorage) global.sessionStorage.setItem(analyticsStorageKey(key), '1'); }
    catch (error) { /* In-memory deduplication remains available when storage is blocked. */ }
  }

  function analyticsString(value, maximumLength) {
    if (value === undefined || value === null) return '';
    var text = String(value).trim();
    return text ? text.slice(0, maximumLength || 120) : '';
  }

  function sanitizeAnalyticsPayload(eventName, payload) {
    var clean = {};
    Object.keys(payload || {}).forEach(function (key) {
      if (!ANALYTICS_ALLOWED_FIELDS[key]) return;
      if ((key === 'value' || key === 'currency') && eventName !== ANALYTICS_EVENTS.addedToCart) return;
      if (key === 'value') {
        var value = Number(payload[key]);
        if (Number.isFinite(value) && value >= 0) clean.value = Math.round(value * 100) / 100;
        return;
      }
      if (key === 'step_number') {
        var numeric = Number(payload[key]);
        if (Number.isFinite(numeric)) clean[key] = Math.round(numeric);
        return;
      }
      var text = analyticsString(payload[key], key === 'page_path' ? 240 : 120);
      if (text) clean[key] = key === 'currency' ? text.toUpperCase().slice(0, 3) : text;
    });
    return clean;
  }

  function analyticsContext(root, result, config) {
    var currentResult = result || root && root._kcbCurrentResult || {};
    var state = currentResult.state || {};
    var recommendation = currentResult.recommendation || {};
    var settings = config && config.shopify || {};
    var customShape = recommendation.isFullCustom || state.collection === 'custom_shape' || state.shape_choice === 'full_custom' || state.custom_shape === 'custom';
    var customArtwork = Boolean(state.artwork_level) && state.artwork_level !== 'stock_graphic';
    var requiresConsultation = Boolean(customShape || state.expert_specs || customArtwork);
    var selectedShape = customShape ? 'custom_shape' : analyticsString(state.shape_choice || recommendation.selectedShapeKey);
    var consultationType = '';
    if (requiresConsultation) {
      consultationType = customShape || state.expert_specs
        ? (customArtwork ? 'shape_spec_and_artwork' : 'shape_or_spec')
        : 'artwork';
    }
    var payload = {
      tool_name: 'kindred_custom_build_configurator',
      tool_version: VERSION,
      rules_version: config && config.rulesVersion,
      product_id: settings.productId,
      product_handle: settings.productHandle,
      page_path: global.location && global.location.pathname,
      product_type: state.product_type || state.custom_product_type,
      collection: state.collection,
      shape: selectedShape,
      size: customShape ? 'custom' : (selectedShape && recommendation.stockLength),
      width_choice: customShape ? 'custom' : state.waist_width_choice,
      construction: state.construction,
      flex_pattern: state.flex_pattern,
      artwork_level: state.artwork_level,
      requires_consultation: requiresConsultation,
      purchase_mode: requiresConsultation ? 'consultation' : 'online_purchase',
      consultation_type: consultationType
    };
    return sanitizeAnalyticsPayload('', payload);
  }

  function dispatchAnalytics(eventName, payload, attempt) {
    var analytics = global.Shopify && global.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') {
      if (attempt < 1) {
        return new Promise(function (resolve) {
          global.setTimeout(function () { resolve(dispatchAnalytics(eventName, payload, attempt + 1)); }, 200);
        });
      }
      return Promise.resolve(false);
    }
    try {
      return Promise.resolve(analytics.publish(eventName, payload)).then(function () { return true; }).catch(function () { return false; });
    } catch (error) {
      return Promise.resolve(false);
    }
  }

  function publishAnalyticsEvent(root, eventName, result, config, options) {
    if (Object.keys(ANALYTICS_EVENTS).every(function (key) { return ANALYTICS_EVENTS[key] !== eventName; })) return Promise.resolve(false);
    var settings = options || {};
    var instanceKey = root && root._kcbAnalyticsInstanceKey || 'global';
    var dedupeKey = eventName + '|' + analyticsString(settings.key || instanceKey, 240);
    if (analyticsCompleted[dedupeKey] || (settings.persist && analyticsWasPersisted(dedupeKey))) return Promise.resolve(true);
    if (analyticsPending[dedupeKey]) return analyticsPending[dedupeKey];
    var payload = Object.assign({}, analyticsContext(root, result, config), settings.extra || {});
    payload = sanitizeAnalyticsPayload(eventName, payload);
    var pending = dispatchAnalytics(eventName, payload, 0).then(function (sent) {
      delete analyticsPending[dedupeKey];
      if (sent) {
        analyticsCompleted[dedupeKey] = true;
        if (settings.persist) persistAnalyticsCompletion(dedupeKey);
      }
      return sent;
    });
    analyticsPending[dedupeKey] = pending;
    return pending;
  }

  function waitForAnalytics(promise, timeout) {
    return Promise.race([
      Promise.resolve(promise).catch(function () { return false; }),
      new Promise(function (resolve) { global.setTimeout(function () { resolve(false); }, Math.min(Number(timeout) || 500, 500)); })
    ]);
  }
  var DEFAULT_PRICES = {
    snowboard: 939,
    freeride_snowboard: 939,
    freestyle_snowboard: 939,
    carving_snowboard: 979,
    youth_snowboard: 599,
    splitboard: 1239,
    skis: 1269,
    customer_provided: 200,
    custom_print: 649,
    custom_marquetry: 949,
    base_colour_surcharge: 50,
    custom_snowboard: 1249,
    custom_splitboard: 1549,
    custom_ski: 1549,
    carbon: 199,
    titanal_fiberglass: 49,
    titanal_carbon: 249,
    race: 449
  };

  // Current CAD model prices from kindredsnowstore.com, verified 2026-09-05.
  var DEFAULT_SHAPE_PRICES = {
    snowboard: {
      'Tsitika': 999,
      'MRK5': 979,
      'Ukee': 979,
      'Arrowsmith': 939,
      'Tyee': 999,
      'ProCarve': 1099,
      'Black Creek': 939,
      'TR Twin': 939,
      'Nootka': 939,
      'Carmanah': 959,
      'One Eyed Jack': 1099,
      'Merville': 999,
      'Tofino': 959,
      'SBX': 1099,
      'BSL': 1099,
      'Delta': 1099,
      'FlowCarve': 1099,
      'Kidred': 599,
      'Elkhorn': 599
    },
    splitboard: {
      'Tsitika': 1299,
      'MRK5': 1279,
      'Ukee': 1279,
      'Arrowsmith': 1239,
      'Black Creek': 1239,
      'Nootka': 1239,
      'Tofino': 1259,
      'Merville': 1299,
      'Carmanah': 1259
    },
    skis: {
      'Tahsis': 1269,
      'Zeballos': 1269,
      '5040': 1299,
      'Ramblers': 1299
    }
  };

  var LABELS = {
    collection: {
      freeride_snowboard: 'Freeride Snowboard',
      freestyle_snowboard: 'Freestyle Snowboard',
      carving_snowboard: 'Carving Snowboard',
      youth_snowboard: 'Youth Snowboard',
      splitboard: 'Splitboard',
      ski: 'Ski',
      custom_shape: 'Custom Shape'
    },
    product_type: {
      snowboard: 'Snowboard',
      splitboard: 'Splitboard',
      skis: 'Skis'
    },
    ski_binding_style: {
      alpine: 'Alpine',
      alpine_pin_touring: 'Alpine Pin Touring',
      hybrid_touring: 'Hybrid Touring Binding'
    },
    ski_touring_notch: {
      no: 'No touring notch',
      yes: 'Add touring notch'
    },
    ability: {
      beginner: 'Beginner',
      novice: 'Novice',
      intermediate: 'Intermediate',
      advanced: 'Advanced',
      expert: 'Expert'
    },
    location: {
      pnw_bc_coast: 'PNW/BC Coast',
      interior_rockies_mountains: 'Interior/Rockies Mountains',
      east_coast_north_america: 'East Coast North America',
      europe_high_alpine: 'Europe/High Alpine',
      japan: 'Japan',
      multiple_regions: 'Multiple Regions'
    },
    boot_size_unit: {
      mens_us: "Men's US",
      womens_us: "Women's US",
      youth_us: 'Youth US',
      mondo: 'Mondo',
      eu: 'EU',
      uk: 'UK'
    },
    terrain: {
      groomers: 'Groomers',
      all_mountain: 'All mountain',
      trees: 'Trees & technical terrain',
      backcountry: 'Backcountry',
      park: 'Park & freestyle',
      slackcountry: 'Slackcountry',
      backcountry_trees: 'Below treeline',
      alpine_backcountry: 'Alpine backcountry',
      long_tours: 'Longer Day Tours / Multi-Day Trips'
    },
    snow: {
      firm: 'Firm',
      variable: 'Variable',
      soft: 'Soft',
      deep: 'Deep'
    },
    turn_style: {
      quick: 'Quick & tight',
      mixed: 'Mixed',
      long: 'Long & open'
    },
    responsiveness: {
      low: 'Forgiving',
      medium: 'Balanced',
      high: 'Immediate'
    },
    ride_feel: {
      playful: 'Playful',
      balanced: 'Balanced',
      powerful: 'Powerful'
    },
    camber_profile: {
      traditional_camber: 'Traditional camber',
      medium_rise: 'Medium rise',
      early_rise: 'Early rise',
      dual_camber: 'Dual camber',
      offset_camber: 'Offset camber',
      asym_camber: 'Asym camber',
      full_rocker: 'Full Rocker'
    },
    touring_focus: {
      uphill: 'Uphill efficiency',
      balanced: 'Balanced uphill and descent',
      descent: 'Descent first'
    },
    priorities: {
      versatility: 'Versatility',
      edge_hold: 'Edge hold',
      float: 'Float',
      maneuverability: 'Maneuverability',
      stability: 'Stability',
      freestyle: 'Freestyle',
      touring_efficiency: 'Touring efficiency'
    },
    construction: {
      fiberglass: 'Fiberglass',
      biaxial_fiberglass: 'Biaxial Fiberglass',
      triaxial_fiberglass: 'Triaxial Fiberglass',
      carbon: 'Carbon Fiber',
      titanal_fiberglass: 'Titanal Reinforced Fiberglass',
      titanal_carbon: 'Titanal Reinforced Carbon Fiber',
      race: 'Race construction'
    },
    flex_pattern: {
      extra_soft: 'Extra Soft',
      soft: 'Soft',
      standard: 'Standard',
      stiff: 'Stiff',
      extra_stiff: 'Extra Stiff'
    },
    artwork_level: {
      stock_graphic: 'Stock Graphic',
      custom_marquetry: 'Custom Marquetry Topsheet',
      custom_print: 'Custom Printed Design',
      customer_provided: 'Customer Provided Artwork'
    },
    base_colour: {
      black_on_red: 'Black on Red',
      red_on_black: 'Red on Black',
      black_on_blue: 'Black on Blue',
      blue_on_black: 'Blue on Black',
      black_on_green: 'Black on Green',
      green_on_black: 'Green on Black',
      black_on_grey: 'Black on Grey',
      grey_on_black: 'Grey on Black',
      black_on_white: 'Black on White',
      white_on_black: 'White on Black'
    },
    stock_graphic: {
      'night-watch': 'Night Watch',
      dusk: 'Dusk',
      tribute: 'Tribute',
      'moon-over-water': 'Moon Over Water',
      'mountain-sketch': 'Mountain Sketch',
      'karver-thunderbird': 'Karver Thunderbird',
      'karver-wolf': 'Karver Wolf',
      'karver-raven': 'Karver Raven',
      'island-sunset': 'Island Sunset',
      sunburst: 'Sunburst',
      'race-graphic-white': 'Race Graphic White',
      'race-graphic-black': 'Race Graphic Black',
      ambling: 'Ambling',
      'fire-in-the-sky': 'Fire in the Sky'
    },
    custom_shape: {
      standard: 'Tune a Kindred shape',
      custom: 'Explore a custom shape'
    },
    custom_spec_mode: {
      consult: 'Consult with a designer',
      specs: 'I have my own build specs'
    },
    shape_choice: {
      full_custom: 'Custom Shape'
    },
    waist_width_choice: {
      extra_narrow: 'Extra Narrow',
      narrow: 'Narrow',
      standard: 'Standard',
      wide: 'Wide',
      extra_wide: 'Extra Wide',
      custom: 'Custom width'
    }
  };

  var PROOF_SHAPE_SLUGS = {
    '5040': '5040',
    'Arrowsmith': 'arrowsmith',
    'Black Creek': 'black-creek',
    'BSL': 'bsl',
    'Carmanah': 'carmanah',
    'Delta': 'delta',
    'Elkhorn': 'elkhorn',
    'FlowCarve': 'flowcarve',
    'Kidred': 'kidred',
    'Merville': 'merville',
    'MRK5': 'mrk5',
    'Nootka': 'nootka',
    'One Eyed Jack': 'one-eyed-jack',
    'ProCarve': 'procarve',
    'Ramblers': 'rambler',
    'SBX': 'sbx',
    'Tahsis': 'tahsis',
    'Tofino': 'tofino',
    'TR Twin': 'tr-twin',
    'Tsitika': 'tsitika',
    'Tyee': 'tyee',
    'Ukee': 'ukee',
    'Zeballos': 'zeballos'
  };

  var PROOF_GRAPHIC_SLUGS = {
    'race-graphic-black': 'race-black',
    'race-graphic-white': 'race-white'
  };

  var ALL_CONSTRUCTION_OPTIONS = [
    'biaxial_fiberglass',
    'triaxial_fiberglass',
    'carbon',
    'titanal_fiberglass',
    'titanal_carbon',
    'race'
  ];

  var SHAPE_CONSTRUCTION_OPTIONS = {
    'Arrowsmith': ['biaxial_fiberglass', 'carbon'],
    'TR Twin': ['biaxial_fiberglass'],
    'Kidred': ['biaxial_fiberglass'],
    'Elkhorn': ['biaxial_fiberglass'],
    'Black Creek': ['triaxial_fiberglass', 'carbon'],
    'Carmanah': ['triaxial_fiberglass', 'carbon'],
    'Merville': ['triaxial_fiberglass', 'carbon'],
    'Nootka': ['triaxial_fiberglass', 'carbon'],
    'Tofino': ['triaxial_fiberglass', 'carbon'],
    'Ukee': ['triaxial_fiberglass', 'carbon'],
    '5040': ['triaxial_fiberglass', 'carbon'],
    'Ramblers': ['triaxial_fiberglass', 'carbon'],
    'Tahsis': ['triaxial_fiberglass', 'carbon'],
    'Zeballos': ['triaxial_fiberglass', 'carbon'],
    'MRK5': ['triaxial_fiberglass', 'carbon', 'race'],
    'Tyee': ['triaxial_fiberglass', 'carbon', 'race'],
    'Delta': ['triaxial_fiberglass', 'titanal_carbon', 'race'],
    'One Eyed Jack': ['triaxial_fiberglass', 'titanal_carbon', 'race'],
    'Tsitika': ['titanal_fiberglass', 'titanal_carbon', 'race'],
    'ProCarve': ['titanal_fiberglass', 'titanal_carbon', 'race'],
    'SBX': ['titanal_fiberglass', 'titanal_carbon', 'race'],
    'BSL': ['titanal_fiberglass', 'titanal_carbon', 'race'],
    'FlowCarve': ['titanal_fiberglass', 'titanal_carbon', 'race']
  };

  var CONSTRUCTION_ASSETS = {
    biaxial_fiberglass: 'kindred-biaxial-fiberglass-construction.webp',
    triaxial_fiberglass: 'kindred-triaxial-fiberglass-construction.webp',
    carbon: 'kindred-carbon-construction.webp',
    titanal_fiberglass: 'kindred-titanal-reinforced-fiberglass-construction.webp',
    titanal_carbon: 'kindred-titanal-reinforced-carbon-construction.webp',
    race: 'kindred-race-construction.webp'
  };

  function constructionOptionsForSelection(shapeChoice, isCustom, productType) {
    var options = isCustom || shapeChoice === 'full_custom'
      ? ALL_CONSTRUCTION_OPTIONS.slice()
      : (!shapeChoice
        ? ALL_CONSTRUCTION_OPTIONS.slice()
        : (SHAPE_CONSTRUCTION_OPTIONS[shapeChoice] || ['triaxial_fiberglass', 'carbon']).slice());
    var isSki = productType === 'skis' || Boolean(SKI_SHAPES[shapeChoice]);
    return isSki ? options.filter(function (key) { return key !== 'race'; }) : options;
  }

  function constructionOptionsForState(state) {
    var input = state || {};
    var custom = input.collection === 'custom_shape' || input.custom_shape === true || input.custom_shape === 'custom';
    return constructionOptionsForSelection(input.shape_choice || input.shape_selection || input.selected_shape || '', custom, input.product_type);
  }

  function compatibleConstructionKey(requested, allowedOptions) {
    var allowed = allowedOptions && allowedOptions.length ? allowedOptions : ALL_CONSTRUCTION_OPTIONS;
    var key = requested || 'fiberglass';
    if (allowed.indexOf(key) !== -1) return key;
    if (key === 'race') {
      return ['race', 'titanal_carbon', 'carbon', 'titanal_fiberglass', 'triaxial_fiberglass', 'biaxial_fiberglass'].find(function (option) {
        return allowed.indexOf(option) !== -1;
      }) || allowed[0];
    }
    if (key === 'carbon' || key === 'titanal_carbon') {
      return ['titanal_carbon', 'carbon', 'race', 'titanal_fiberglass', 'triaxial_fiberglass', 'biaxial_fiberglass'].find(function (option) {
        return allowed.indexOf(option) !== -1;
      }) || allowed[0];
    }
    return ['triaxial_fiberglass', 'biaxial_fiberglass', 'titanal_fiberglass', 'titanal_carbon', 'carbon', 'race'].find(function (option) {
      return allowed.indexOf(option) !== -1;
    }) || allowed[0];
  }

  var CONSTRUCTION_DETAILS = {
    biaxial_fiberglass: {
      key: 'biaxial_fiberglass',
      title: 'Biaxial Fiberglass',
      summary: 'A smooth, forgiving 0°/90° fiberglass layup with dependable damping and an easy flex progression.',
      factors: [
        { label: 'Ride quality', value: 'Smooth and forgiving' },
        { label: 'Responsiveness', value: 'Forgiving' },
        { label: 'Weight', value: 'Standard' },
        { label: 'Edge feel', value: 'Balanced and predictable' }
      ],
      best: 'Riders who value comfort, maneuverability and a calm, familiar flex that remains easy to trust.',
      tradeoff: 'Biaxial fiberglass feels less immediate and torsionally supportive than triaxial or carbon constructions.',
      note: 'Final laminate weight and flex are tuned to the selected shape and rider.'
    },
    triaxial_fiberglass: {
      key: 'triaxial_fiberglass',
      title: 'Triaxial Fiberglass',
      summary: 'A smooth, predictable fiberglass layup with added torsional support for confident edge engagement.',
      factors: [
        { label: 'Ride quality', value: 'Smooth and composed' },
        { label: 'Responsiveness', value: 'Balanced' },
        { label: 'Weight', value: 'Standard' },
        { label: 'Edge feel', value: 'Supportive and predictable' }
      ],
      best: 'Riders who value versatility, dependable edge hold and a familiar flex progression across varied snow.',
      tradeoff: 'Triaxial fiberglass carries more weight and feels less immediate than carbon, but remains smooth and composed.',
      note: 'Final fiberglass orientation, laminate weight and flex are tuned to the selected shape and rider.'
    },
    carbon: {
      key: 'carbon',
      title: 'Carbon fiber',
      summary: 'A lighter, livelier construction that responds quickly to rider input and returns more energy.',
      factors: [
        { label: 'Ride quality', value: 'Lively and precise' },
        { label: 'Responsiveness', value: 'Quick' },
        { label: 'Weight', value: '15% lighter' },
        { label: 'Edge feel', value: 'Direct and supportive' }
      ],
      best: 'Riders prioritizing agility, quick transitions or a more energetic feel. Carbon fiber’s lower swing weight also makes the build easier to move through turns and transitions.',
      tradeoff: 'Carbon fiber communicates terrain more directly and can feel less relaxed than fiberglass when comfort is the priority.',
      note: 'Carbon placement and flex are adjusted to avoid unnecessary stiffness for the rider and selected shape.'
    },
    titanal_fiberglass: {
      key: 'titanal_fiberglass',
      title: 'Titanal Reinforced Fiberglass',
      summary: 'A damp, direct fiberglass construction with Titanal reinforcement for stronger edge hold and stability.',
      factors: [
        { label: 'Ride quality', value: 'Damp and composed' },
        { label: 'Responsiveness', value: 'Direct' },
        { label: 'Weight', value: 'Structure prioritized' },
        { label: 'Edge feel', value: 'Powerful and planted' }
      ],
      best: 'Riders prioritizing stable carving, firm-snow grip and a planted feel without moving to a full carbon layup.',
      tradeoff: 'Titanal reinforced fiberglass carries more structure and feels less playful than an unreinforced fiberglass build.',
      note: 'Titanal placement, laminate weight and flex are matched to the selected shape and rider load.'
    },
    titanal_carbon: {
      key: 'titanal_carbon',
      title: 'Titanal Reinforced Carbon Fiber',
      summary: 'A light, quick carbon construction with Titanal reinforcement for damping, power and precise edge control.',
      factors: [
        { label: 'Ride quality', value: 'Lively yet damp' },
        { label: 'Responsiveness', value: 'Immediate' },
        { label: 'Weight', value: 'Lightweight performance' },
        { label: 'Edge feel', value: 'Powerful and precise' }
      ],
      best: 'Riders seeking low swing weight, quick response and authoritative edge hold in demanding carving or freeride shapes.',
      tradeoff: 'The reinforced carbon response is more direct and demanding than fiberglass, especially at relaxed speeds.',
      note: 'Carbon and Titanal placement are tuned together for the selected shape, rider load and intended use.'
    },
    race: {
      key: 'race',
      title: 'Race construction',
      summary: 'A performance-first construction focused on maximum edge authority, damping and precision at speed.',
      factors: [
        { label: 'Ride quality', value: 'Planted and damp' },
        { label: 'Responsiveness', value: 'Immediate' },
        { label: 'Weight', value: 'Structure prioritized' },
        { label: 'Edge feel', value: 'Maximum authority' }
      ],
      best: 'Strong riders seeking speed, powerful carving, firm-snow confidence and highly precise response.',
      tradeoff: 'Race construction is the most demanding option and may feel excessive for riders who prefer a relaxed, playful or forgiving ride.',
      note: 'The final race layup is matched to the shape, rider load and intended use before construction is confirmed.'
    }
  };

  var COLLECTION_PRODUCT_TYPES = {
    freeride_snowboard: 'snowboard',
    freestyle_snowboard: 'snowboard',
    carving_snowboard: 'snowboard',
    youth_snowboard: 'snowboard',
    splitboard: 'splitboard',
    ski: 'skis'
  };

  var COLLECTION_GOAL_PROFILES = {
    default: {
      hideTerrainQuestion: false,
      terrainOptions: ['groomers', 'all_mountain', 'trees', 'backcountry', 'park'],
      snowOptions: ['firm', 'variable', 'soft', 'deep'],
      priorityOptions: ['versatility', 'edge_hold', 'float', 'maneuverability', 'stability', 'freestyle'],
      terrainFallback: 'all_mountain',
      snowFallback: 'variable',
      priorityFallback: 'versatility'
    },
    splitboard: {
      hideTerrainQuestion: false,
      terrainOptions: ['slackcountry', 'backcountry_trees', 'alpine_backcountry', 'long_tours'],
      snowOptions: ['firm', 'variable', 'soft', 'deep'],
      priorityOptions: ['versatility', 'edge_hold', 'float', 'maneuverability', 'stability', 'freestyle', 'touring_efficiency'],
      terrainFallback: 'slackcountry',
      snowFallback: 'variable',
      priorityFallback: 'versatility'
    },
    ski: {
      hideTerrainQuestion: false,
      terrainOptions: ['groomers', 'all_mountain', 'trees', 'backcountry', 'park'],
      snowOptions: ['firm', 'variable', 'soft', 'deep'],
      priorityOptions: ['versatility', 'edge_hold', 'float', 'maneuverability', 'stability', 'freestyle', 'touring_efficiency'],
      terrainFallback: 'all_mountain',
      snowFallback: 'variable',
      priorityFallback: 'versatility'
    },
    carving_snowboard: {
      hideTerrainQuestion: true,
      terrainOptions: ['groomers', 'all_mountain', 'trees', 'backcountry', 'park'],
      snowOptions: ['firm', 'variable', 'soft'],
      priorityOptions: ['versatility', 'edge_hold', 'float', 'maneuverability', 'stability', 'freestyle'],
      terrainFallback: 'groomers',
      snowFallback: 'firm',
      priorityFallback: 'edge_hold'
    }
  };

  var COLLECTION_GOAL_COPY = {
    splitboard: {
      heading: 'What are you looking for in your new ride?',
      intro: 'Describe the access, snow and descent character you want for backcountry or slackcountry days.',
      questions: {
        terrain: { label: 'Primary touring terrain', help: 'Where will most of your backcountry or slackcountry riding take place?' },
        snow: { label: 'Primary backcountry snow', help: 'Choose the natural snow conditions you most want the splitboard to handle.' },
        turn_style: { label: 'Preferred Turn Shape', help: 'Think about the terrain and spaces you choose on the descent.' }
      },
      answers: {
        snow: {
          firm: { title: 'Firm & wind affected', description: 'Hard, textured, refrozen or wind-pressed natural snow' },
          variable: { title: 'Variable backcountry', description: 'Crust, powder pockets and changing snow in one tour' },
          soft: { title: 'Soft & fresh', description: 'Supportive storm snow and forgiving conditions' },
          deep: { title: 'Deep powder', description: 'Maximum float for storm cycles and deep days' }
        },
        turn_style: {
          quick: { title: 'Quick & technical', description: 'Fast initiation in trees, chutes and confined terrain' },
          mixed: { title: 'Mixed terrain', description: 'Adaptable turns as terrain and snow change' },
          long: { title: 'Open & fast', description: 'Longer arcs across alpine faces and open bowls' }
        }
      }
    },
    carving_snowboard: {
      heading: 'What are you looking for in your new ride?',
      intro: 'Choose the surface and arc you want the board to prioritize through each carve.',
      questions: {
        snow: { label: 'Carving snow conditions', help: 'Choose the surface you most want the board to hold and feel composed on.' },
        turn_style: { label: 'Preferred carve shape', help: 'Choose the arc you most want the sidecut to support.' }
      },
      answers: {
        snow: {
          firm: { title: 'Firm & icy', description: 'Hardpack, refrozen surfaces and firm morning snow' },
          variable: { title: 'Variable piste', description: 'Changing grip, tracked snow and mixed resort surfaces' },
          soft: { title: 'Soft groomers', description: 'Fresh corduroy and softer packed snow' }
        },
        turn_style: {
          quick: { title: 'Short & quick', description: 'Tighter arcs and rapid edge-to-edge transitions' },
          mixed: { title: 'Versatile arcs', description: 'A balance of short and longer carved turns' },
          long: { title: 'Long & open', description: 'Composed high-speed arcs with room to run' }
        }
      }
    }
  };

  function collectionGoalProfile(collection) {
    var source = COLLECTION_GOAL_PROFILES[collection] || COLLECTION_GOAL_PROFILES.default;
    return {
      hideTerrainQuestion: source.hideTerrainQuestion,
      terrainOptions: source.terrainOptions.slice(),
      snowOptions: source.snowOptions.slice(),
      priorityOptions: source.priorityOptions.slice(),
      terrainFallback: source.terrainFallback,
      snowFallback: source.snowFallback,
      priorityFallback: source.priorityFallback
    };
  }

  function goalProfileKey(collection, productType) {
    if (collection !== 'custom_shape') return collection;
    if (productType === 'skis') return 'ski';
    if (productType === 'splitboard') return 'splitboard';
    return 'default';
  }

  function terrainMatchKeys(terrain) {
    var aliases = {
      slackcountry: ['all_mountain', 'backcountry'],
      backcountry_trees: ['trees', 'backcountry'],
      alpine_backcountry: ['backcountry'],
      long_tours: ['backcountry', 'all_mountain']
    };
    return aliases[terrain] || [terrain];
  }

  function shapeMatchesTerrain(shape, terrain) {
    return terrainMatchKeys(terrain).some(function (key) { return shape.terrain.indexOf(key) !== -1; });
  }

  var SHAPE_PRIORITY_KEYS = ['versatility', 'edge_hold', 'float', 'maneuverability', 'stability', 'freestyle', 'touring_efficiency'];
  var RULES_SCHEMA_VERSION = 1;
  var RULE_PROFILE_SCORE_SECTIONS = ['snow', 'turn_style', 'responsiveness', 'ride_feel', 'touring_focus', 'ski_touring_notch', 'priorities'];
  var RULE_PROFILE_TERRAINS = ['groomers', 'all_mountain', 'trees', 'backcountry', 'park', 'slackcountry', 'backcountry_trees', 'alpine_backcountry', 'long_tours'];
  var RULE_PROFILE_SCORE_KEYS = {
    snow: ['firm', 'variable', 'soft', 'deep'],
    turn_style: ['quick', 'mixed', 'long'],
    responsiveness: ['low', 'medium', 'high'],
    ride_feel: ['playful', 'balanced', 'powerful'],
    touring_focus: ['uphill', 'balanced', 'descent'],
    ski_touring_notch: ['no', 'yes'],
    priorities: SHAPE_PRIORITY_KEYS
  };
  var RIDE_GOAL_PROFILE_OVERRIDES = {};
  var DEFAULT_QUESTION_WEIGHTS = {
    sizing_fit: 10,
    terrain: 7,
    snow: 7,
    turn_style: 5,
    responsiveness: 5,
    ride_feel: 5,
    touring_focus: 5,
    ski_touring_notch: 3,
    priorities: 4
  };
  var QUESTION_WEIGHTS = Object.assign({}, DEFAULT_QUESTION_WEIGHTS);
  var QUESTION_WEIGHT_COLLECTIONS = ['freeride_snowboard', 'freestyle_snowboard', 'carving_snowboard', 'youth_snowboard', 'splitboard', 'ski'];
  var COLLECTION_QUESTION_WEIGHTS = Object.fromEntries(QUESTION_WEIGHT_COLLECTIONS.map(function (collection) {
    return [collection, Object.assign({}, DEFAULT_QUESTION_WEIGHTS)];
  }));

  function normalizedQuestionWeights(overrides, fallback) {
    var source = overrides && typeof overrides === 'object' ? overrides : {};
    var defaults = fallback || DEFAULT_QUESTION_WEIGHTS;
    return Object.fromEntries(Object.keys(DEFAULT_QUESTION_WEIGHTS).map(function (key) {
      var value = number(source[key], defaults[key]);
      return [key, clamp(Math.round(value), 0, 10)];
    }));
  }

  function applyQuestionWeightOverrides(overrides) {
    QUESTION_WEIGHTS = normalizedQuestionWeights(overrides, DEFAULT_QUESTION_WEIGHTS);
    COLLECTION_QUESTION_WEIGHTS = Object.fromEntries(QUESTION_WEIGHT_COLLECTIONS.map(function (collection) {
      return [collection, Object.assign({}, QUESTION_WEIGHTS)];
    }));
  }

  function applyCollectionQuestionWeightOverrides(overrides) {
    var source = overrides && typeof overrides === 'object' ? overrides : {};
    COLLECTION_QUESTION_WEIGHTS = Object.fromEntries(QUESTION_WEIGHT_COLLECTIONS.map(function (collection) {
      return [collection, normalizedQuestionWeights(source[collection], QUESTION_WEIGHTS)];
    }));
  }

  function questionWeightsForState(state) {
    var collection = state.collection;
    if (collection === 'custom_shape') {
      collection = state.product_type === 'skis' ? 'ski' : (state.product_type === 'splitboard' ? 'splitboard' : 'freeride_snowboard');
    }
    return COLLECTION_QUESTION_WEIGHTS[collection] || QUESTION_WEIGHTS;
  }

  function applyRideGoalProfileOverrides(overrides) {
    if (!overrides || typeof overrides !== 'object') return;
    var nextProfiles = {};
    Object.keys(overrides).forEach(function (id) {
      var input = overrides[id];
      if (!input || typeof input !== 'object') return;
      nextProfiles[id] = JSON.parse(JSON.stringify(input));
    });
    RIDE_GOAL_PROFILE_OVERRIDES = nextProfiles;
  }

  function applyShapePriorityOverrides(overrides) {
    if (!overrides || typeof overrides !== 'object') return;
    Object.keys(overrides).forEach(function (name) {
      var shape = BOARD_SHAPES[name] || SKI_SHAPES[name];
      var values = asArray(overrides[name]).filter(function (priority, index, list) {
        return SHAPE_PRIORITY_KEYS.indexOf(priority) !== -1 && list.indexOf(priority) === index;
      });
      if (shape && values.length) shape.priorities = values;
    });
  }

  function isPlainObject(value) {
    return Boolean(value) && Object.prototype.toString.call(value) === '[object Object]';
  }

  function rulePayloadFailure(message) {
    return { ok: false, error: message };
  }

  function validateRuleWeightSet(weights, label) {
    if (!isPlainObject(weights)) return rulePayloadFailure(label + ' must be an object.');
    var keys = Object.keys(DEFAULT_QUESTION_WEIGHTS);
    for (var index = 0; index < keys.length; index += 1) {
      var key = keys[index];
      if (!Object.prototype.hasOwnProperty.call(weights, key)) return rulePayloadFailure(label + ' is missing ' + key + '.');
      if (typeof weights[key] !== 'number' || !Number.isFinite(weights[key]) || weights[key] < 0 || weights[key] > 10) {
        return rulePayloadFailure(label + '.' + key + ' must be a number from 0 to 10.');
      }
    }
    return { ok: true };
  }

  function validateRuleScoreMap(scores, section, label) {
    if (!isPlainObject(scores)) return rulePayloadFailure(label + ' must be an object.');
    var keys = Object.keys(scores);
    for (var index = 0; index < keys.length; index += 1) {
      var key = keys[index];
      var value = scores[key];
      if (RULE_PROFILE_SCORE_KEYS[section].indexOf(key) === -1) {
        return rulePayloadFailure(label + ' contains an unknown answer ID: ' + key + '.');
      }
      if (typeof value !== 'number' || !Number.isFinite(value) || value < 1 || value > 5) {
        return rulePayloadFailure(label + '.' + key + ' must be a number from 1 to 5.');
      }
    }
    return { ok: true };
  }

  function profileShape(profileId) {
    var separator = profileId.indexOf(':');
    if (separator <= 0 || separator === profileId.length - 1) return null;
    var category = profileId.slice(0, separator);
    var name = profileId.slice(separator + 1);
    if (category === 'ski') return SKI_SHAPES[name] || null;
    if (category === 'snowboard' || category === 'splitboard') return BOARD_SHAPES[name] || null;
    return null;
  }

  function validateRuleSizeFits(sizeFits, shape, label) {
    if (!isPlainObject(sizeFits)) return rulePayloadFailure(label + ' must be an object.');
    var lengths = Object.keys(sizeFits);
    for (var index = 0; index < lengths.length; index += 1) {
      var lengthKey = lengths[index];
      var length = Number(lengthKey);
      var fit = sizeFits[lengthKey];
      if (!Number.isFinite(length) || shape.lengths.indexOf(length) === -1) {
        return rulePayloadFailure(label + ' contains an unknown stock length: ' + lengthKey + '.');
      }
      if (!isPlainObject(fit)) return rulePayloadFailure(label + '.' + lengthKey + ' must be an object.');
      var optional = ['height_cm', 'weight_kg', 'foot_us', 'waist_mm', 'weight_min_kg', 'weight_max_kg'];
      for (var optionalIndex = 0; optionalIndex < optional.length; optionalIndex += 1) {
        var optionalKey = optional[optionalIndex];
        if (fit[optionalKey] !== undefined && (typeof fit[optionalKey] !== 'number' || !Number.isFinite(fit[optionalKey]))) {
          return rulePayloadFailure(label + '.' + lengthKey + '.' + optionalKey + ' must be a number.');
        }
      }
      if (fit.weight_min_kg !== undefined && fit.weight_max_kg !== undefined && fit.weight_min_kg >= fit.weight_max_kg) {
        return rulePayloadFailure(label + '.' + lengthKey + ' has an invalid weight range.');
      }
    }
    return { ok: true };
  }

  function validateRuleProfile(profileId, profile) {
    var shape = profileShape(profileId);
    if (!shape) return rulePayloadFailure('profiles contains an unknown profile ID: ' + profileId + '.');
    if (!isPlainObject(profile)) return rulePayloadFailure('profiles.' + profileId + ' must be an object.');
    if (!Number.isInteger(profile.scale_version) || profile.scale_version < 1) {
      return rulePayloadFailure('profiles.' + profileId + '.scale_version must be a positive integer.');
    }
    if (!Array.isArray(profile.terrain) || !profile.terrain.length || profile.terrain.some(function (value, index, values) {
      return typeof value !== 'string' || RULE_PROFILE_TERRAINS.indexOf(value) === -1 || values.indexOf(value) !== index;
    })) {
      return rulePayloadFailure('profiles.' + profileId + '.terrain must contain unique, known terrain IDs.');
    }
    var sizeFitsValidation = validateRuleSizeFits(profile.size_fits, shape, 'profiles.' + profileId + '.size_fits');
    if (!sizeFitsValidation.ok) return sizeFitsValidation;
    for (var index = 0; index < RULE_PROFILE_SCORE_SECTIONS.length; index += 1) {
      var section = RULE_PROFILE_SCORE_SECTIONS[index];
      var scoreValidation = validateRuleScoreMap(profile[section], section, 'profiles.' + profileId + '.' + section);
      if (!scoreValidation.ok) return scoreValidation;
    }
    return { ok: true };
  }

  function requiredProfileId(collection, shapeName) {
    if (collection === 'ski') return 'ski:' + shapeName;
    if (collection === 'splitboard') return 'splitboard:' + shapeName;
    return 'snowboard:' + shapeName;
  }

  function normalizeRulePayload(payload) {
    if (!isPlainObject(payload)) return rulePayloadFailure('The published rules must be a JSON object.');
    if (payload.schema_version !== RULES_SCHEMA_VERSION) {
      return rulePayloadFailure('Unsupported rules schema_version. Expected ' + RULES_SCHEMA_VERSION + '.');
    }
    if (payload.published_at !== undefined && payload.published_at !== null && typeof payload.published_at !== 'string') {
      return rulePayloadFailure('published_at must be a string when provided.');
    }
    if (payload.published_by !== undefined && payload.published_by !== null && typeof payload.published_by !== 'string') {
      return rulePayloadFailure('published_by must be a string when provided.');
    }
    if (!isPlainObject(payload.profiles)) return rulePayloadFailure('profiles must be an object.');
    if (!isPlainObject(payload.collection_shapes)) return rulePayloadFailure('collection_shapes must be an object.');
    if (!isPlainObject(payload.question_weights)) return rulePayloadFailure('question_weights must be an object.');
    if (!isPlainObject(payload.collection_question_weights)) return rulePayloadFailure('collection_question_weights must be an object.');

    var normalizedShapes = {};
    var collections = Object.keys(DEFAULT_COLLECTION_SHAPES);
    for (var collectionIndex = 0; collectionIndex < collections.length; collectionIndex += 1) {
      var collection = collections[collectionIndex];
      var names = payload.collection_shapes[collection];
      if (!Array.isArray(names) || !names.length) {
        return rulePayloadFailure('collection_shapes.' + collection + ' must be a non-empty array.');
      }
      var library = collectionShapeLibrary(collection);
      var seen = {};
      var shapes = [];
      for (var shapeIndex = 0; shapeIndex < names.length; shapeIndex += 1) {
        var name = names[shapeIndex];
        if (typeof name !== 'string' || !library[name]) {
          return rulePayloadFailure('collection_shapes.' + collection + ' contains an unknown shape.');
        }
        if (seen[name]) return rulePayloadFailure('collection_shapes.' + collection + ' contains a duplicate shape: ' + name + '.');
        seen[name] = true;
        shapes.push(library[name]);
      }
      normalizedShapes[collection] = shapes;
    }

    var normalizedProfiles = {};
    var profileIds = Object.keys(payload.profiles);
    for (var profileIndex = 0; profileIndex < profileIds.length; profileIndex += 1) {
      var profileId = profileIds[profileIndex];
      var profileValidation = validateRuleProfile(profileId, payload.profiles[profileId]);
      if (!profileValidation.ok) return profileValidation;
      normalizedProfiles[profileId] = JSON.parse(JSON.stringify(payload.profiles[profileId]));
    }
    for (var requiredCollectionIndex = 0; requiredCollectionIndex < collections.length; requiredCollectionIndex += 1) {
      var requiredCollection = collections[requiredCollectionIndex];
      var requiredNames = payload.collection_shapes[requiredCollection];
      for (var requiredShapeIndex = 0; requiredShapeIndex < requiredNames.length; requiredShapeIndex += 1) {
        var expectedProfileId = requiredProfileId(requiredCollection, requiredNames[requiredShapeIndex]);
        if (!normalizedProfiles[expectedProfileId]) {
          return rulePayloadFailure('profiles is missing ' + expectedProfileId + '.');
        }
      }
    }

    var globalWeightValidation = validateRuleWeightSet(payload.question_weights, 'question_weights');
    if (!globalWeightValidation.ok) return globalWeightValidation;
    var normalizedGlobalWeights = Object.fromEntries(Object.keys(DEFAULT_QUESTION_WEIGHTS).map(function (key) {
      return [key, payload.question_weights[key]];
    }));
    var normalizedCollectionWeights = {};
    for (var weightIndex = 0; weightIndex < QUESTION_WEIGHT_COLLECTIONS.length; weightIndex += 1) {
      var weightCollection = QUESTION_WEIGHT_COLLECTIONS[weightIndex];
      var collectionWeightValidation = validateRuleWeightSet(
        payload.collection_question_weights[weightCollection],
        'collection_question_weights.' + weightCollection
      );
      if (!collectionWeightValidation.ok) return collectionWeightValidation;
      normalizedCollectionWeights[weightCollection] = Object.fromEntries(Object.keys(DEFAULT_QUESTION_WEIGHTS).map(function (key) {
        return [key, payload.collection_question_weights[weightCollection][key]];
      }));
    }

    return {
      ok: true,
      value: {
        profiles: normalizedProfiles,
        collectionShapes: normalizedShapes,
        questionWeights: normalizedGlobalWeights,
        collectionQuestionWeights: normalizedCollectionWeights,
        publishedAt: payload.published_at || '',
        publishedBy: payload.published_by || ''
      }
    };
  }

  function applyRulePayload(payload) {
    var normalized = normalizeRulePayload(payload);
    if (!normalized.ok) return normalized;
    RIDE_GOAL_PROFILE_OVERRIDES = normalized.value.profiles;
    SHAPES = normalized.value.collectionShapes;
    QUESTION_WEIGHTS = normalized.value.questionWeights;
    COLLECTION_QUESTION_WEIGHTS = normalized.value.collectionQuestionWeights;
    return {
      ok: true,
      schemaVersion: RULES_SCHEMA_VERSION,
      publishedAt: normalized.value.publishedAt,
      publishedBy: normalized.value.publishedBy
    };
  }

  function loadShapePriorityOverrides(endpoint) {
    if (typeof global.fetch !== 'function' || !endpoint) return Promise.resolve();
    return global.fetch(endpoint, { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (payload) {
        if (payload && payload.profiles) {
          var versionedPayload = payload.schema_version === undefined
            ? Object.assign({}, payload, { schema_version: RULES_SCHEMA_VERSION })
            : payload;
          var result = applyRulePayload(versionedPayload);
          if (!result.ok && global.console && typeof global.console.warn === 'function') {
            global.console.warn('Kindred custom builder ignored invalid remote rules: ' + result.error);
          }
        } else if (payload && payload.priorities) applyShapePriorityOverrides(payload.priorities);
      })
      .catch(function () { /* Preserve built-in scoring when the service is unavailable. */ });
  }

  var BOARD_SHAPES = {
    'Tsitika': { name: 'Tsitika', lengths: [148, 152, 156, 158, 160, 162, 164, 168], terrain: ['backcountry', 'all_mountain'], snow: ['deep', 'soft', 'variable'], turns: ['long', 'mixed'], feel: ['powerful', 'balanced'], priorities: ['float', 'stability', 'edge_hold'], profile: 'Directional early rise with a supportive camber zone', flex: 7 },
    'MRK5': { name: 'MRK5', lengths: [153, 158, 163], terrain: ['backcountry', 'trees', 'all_mountain'], snow: ['variable', 'soft'], turns: ['quick', 'mixed'], feel: ['balanced'], priorities: ['touring_efficiency', 'maneuverability', 'versatility'], profile: 'Early-rise nose with camber through the running length', flex: 6 },
    'Ukee': { name: 'Ukee', lengths: [146, 150, 154, 158, 162, 166, 170], terrain: ['all_mountain', 'groomers'], snow: ['firm', 'variable', 'soft'], turns: ['mixed', 'long'], feel: ['powerful', 'balanced'], priorities: ['versatility', 'edge_hold', 'stability'], profile: 'Directional camber with controlled early rise', flex: 7 },
    'Arrowsmith': { name: 'Arrowsmith', lengths: [149, 153, 157, 161, 165, 169], terrain: ['trees', 'backcountry', 'all_mountain'], snow: ['soft', 'deep'], turns: ['quick', 'mixed'], feel: ['playful', 'balanced'], priorities: ['float', 'maneuverability', 'versatility'], profile: 'Directional early rise with camber underfoot', flex: 5 },
    'Tyee': { name: 'Tyee', lengths: [181], terrain: ['all_mountain', 'groomers', 'backcountry'], snow: ['variable', 'soft'], turns: ['mixed', 'long'], feel: ['powerful', 'balanced'], priorities: ['stability', 'edge_hold', 'float'], profile: 'Directional camber with an early-rise nose', flex: 7 },
    'Black Creek': { name: 'Black Creek', lengths: [146, 150, 154, 158, 162, 166, 170], terrain: ['all_mountain', 'backcountry'], snow: ['variable', 'soft'], turns: ['mixed'], feel: ['balanced'], priorities: ['versatility', 'stability'], profile: 'Directional camber with early rise', flex: 6 },
    'TR Twin': { name: 'TR Twin', lengths: [144, 148, 152, 156, 160, 164], terrain: ['park', 'all_mountain'], snow: ['firm', 'variable'], turns: ['quick', 'mixed'], feel: ['playful'], priorities: ['freestyle', 'maneuverability'], profile: 'True-twin camber with balanced rise', flex: 5 },
    'Nootka': { name: 'Nootka', lengths: [143, 147, 151, 155, 159, 163, 167], terrain: ['park', 'trees', 'all_mountain'], snow: ['variable', 'soft'], turns: ['quick', 'mixed'], feel: ['playful', 'balanced'], priorities: ['freestyle', 'maneuverability', 'versatility'], profile: 'Playful directional camber with early rise', flex: 5 },
    'Carmanah': { name: 'Carmanah', lengths: [150, 154, 158], terrain: ['backcountry', 'trees', 'all_mountain'], snow: ['deep', 'soft'], turns: ['quick', 'mixed'], feel: ['playful', 'balanced'], priorities: ['float', 'maneuverability'], profile: 'Directional powder rise with a compact tail', flex: 5 },
    'Merville': { name: 'Merville', lengths: [152, 158, 166], terrain: ['backcountry', 'all_mountain'], snow: ['deep', 'soft', 'variable'], turns: ['mixed', 'long'], feel: ['powerful', 'balanced'], priorities: ['float', 'stability'], profile: 'Long directional rise with camber underfoot', flex: 7 },
    'Tofino': { name: 'Tofino', lengths: [156, 160, 164], terrain: ['backcountry', 'trees'], snow: ['deep', 'soft'], turns: ['quick', 'mixed'], feel: ['playful', 'balanced'], priorities: ['float', 'maneuverability'], profile: 'Powder-focused early rise with directional taper', flex: 5 },
    'ProCarve': { name: 'ProCarve', lengths: [156, 161, 166, 171], terrain: ['groomers'], snow: ['firm', 'variable'], turns: ['long', 'mixed'], feel: ['powerful'], priorities: ['edge_hold', 'stability'], profile: 'Full camber with an extended effective edge', flex: 8 },
    'One Eyed Jack': { name: 'One Eyed Jack', lengths: [146, 150, 154, 158, 162, 166], terrain: ['groomers', 'park'], snow: ['firm', 'variable'], turns: ['mixed'], feel: ['playful', 'powerful'], priorities: ['freestyle', 'edge_hold'], profile: 'Twin camber with low rise', flex: 7 },
    'Delta': { name: 'Delta', lengths: [151, 155, 159, 163, 167, 171], terrain: ['groomers'], snow: ['firm', 'variable'], turns: ['long'], feel: ['powerful'], priorities: ['edge_hold', 'stability'], profile: 'Full camber with low tip and tail rise', flex: 8 },
    'BSL': { name: 'BSL', lengths: [150, 154, 158, 162, 166], terrain: ['groomers'], snow: ['firm', 'variable'], turns: ['long'], feel: ['powerful'], priorities: ['edge_hold', 'stability'], profile: 'Race-inspired camber with a long effective edge', flex: 9 },
    'FlowCarve': { name: 'FlowCarve', lengths: [154, 158, 162, 166, 170], terrain: ['groomers'], snow: ['firm', 'variable'], turns: ['quick'], feel: ['balanced', 'powerful'], priorities: ['edge_hold', 'maneuverability'], profile: 'Full camber with a quick-turning sidecut', flex: 7 },
    'Kidred': { name: 'Kidred', lengths: [121, 131, 141], terrain: ['all_mountain', 'park'], snow: ['firm', 'variable', 'soft'], turns: ['quick', 'mixed'], feel: ['playful', 'balanced'], priorities: ['maneuverability', 'versatility', 'freestyle'], profile: 'Youth-friendly camber with catch-resistant tip and tail geometry', flex: 3 },
    'Elkhorn': { name: 'Elkhorn', lengths: [124, 134, 144], terrain: ['all_mountain', 'trees', 'backcountry'], snow: ['soft', 'deep'], turns: ['quick', 'mixed'], feel: ['playful', 'balanced'], priorities: ['float', 'stability', 'maneuverability'], profile: 'Youth powder profile with early rise and supportive camber', flex: 4 }
  };

  var BOARD_WIDTH_SPECS = {
    'Tsitika': { waists: { 148: 254, 152: 260, 156: 270, 158: 271, 160: 272, 162: 274, 164: 277, 168: 280 }, adjustments: { narrow: -6, standard: 0, wide: 6, extra_wide: 12 }, custom: true },
    'MRK5': { waists: { 153: 260, 158: 270, 163: 280 }, adjustments: { narrow: -6, standard: 0, wide: 6 }, custom: true },
    'Ukee': { waists: { 146: 244, 150: 252, 154: 258, 158: 263, 162: 267, 166: 271, 170: 274 }, adjustments: { narrow: -6, standard: 0, wide: 6, extra_wide: 12 }, custom: true },
    'Arrowsmith': { waists: { 149: 254, 153: 262, 157: 269, 161: 274, 165: 277, 169: 280 }, adjustments: { narrow: -4, standard: 0, wide: 4, extra_wide: 8 }, custom: true },
    'Tyee': { waists: { 181: 267 }, adjustments: { standard: 0, wide: 6 }, custom: true },
    'Black Creek': { waists: { 146: 242, 150: 247, 154: 252, 158: 255, 162: 259, 166: 261, 170: 270 }, adjustments: { narrow: -5, standard: 0, wide: 6, extra_wide: 12 }, custom: true },
    'TR Twin': { waists: { 144: 248, 148: 253, 152: 258, 156: 263, 160: 268, 164: 273 }, adjustments: { narrow: -6, standard: 0, wide: 6, extra_wide: 12 }, custom: true },
    'Nootka': { waists: { 143: 240, 147: 244, 151: 249, 155: 250, 159: 253, 163: 256, 167: 265 }, adjustments: { narrow: -6, standard: 0, wide: 6, extra_wide: 12 }, custom: true },
    'Carmanah': { waists: { 150: 269, 154: 278, 158: 278 }, adjustments: { narrow: -6, standard: 0, wide: 6, extra_wide: 12 }, custom: true },
    'Merville': { waists: { 152: 255, 158: 264, 166: 268 }, adjustments: { narrow: -6, standard: 0, wide: 6, extra_wide: 12 }, custom: true },
    'Tofino': { waists: { 156: 255, 160: 260, 164: 263 }, adjustments: { narrow: -6, standard: 0, wide: 6, extra_wide: 12 }, custom: true },
    'ProCarve': { waists: { 156: 255, 161: 263, 166: 272, 171: 276 }, adjustments: { narrow: -6, standard: 0, wide: 6, extra_wide: 12 }, custom: true },
    'One Eyed Jack': { waists: { 146: 265, 150: 272, 154: 279, 158: 286, 162: 289, 166: 292 }, adjustments: { narrow: -6, standard: 0, wide: 6, extra_wide: 12 }, custom: true },
    'Delta': { waists: { 151: 273, 155: 277, 159: 281, 163: 285, 167: 288, 171: 290 }, adjustments: { narrow: -6, standard: 0, wide: 6, extra_wide: 12 }, custom: true },
    'BSL': { waists: { 150: 249, 154: 253, 158: 258, 162: 262, 166: 266 }, adjustments: { narrow: -6, standard: 0, wide: 6, extra_wide: 12 }, custom: true },
    'FlowCarve': { waists: { 154: 273, 158: 276, 162: 279, 166: 283, 170: 285 }, adjustments: { narrow: -6, standard: 0, wide: 6, extra_wide: 12 }, custom: true },
    'Kidred': { waists: { 121: 234, 131: 239, 141: 244 }, adjustments: { standard: 0 }, custom: false },
    'Elkhorn': { waists: { 124: 235, 134: 240, 144: 245 }, adjustments: { standard: 0 }, custom: false }
  };

  var WIDTH_OPTION_ORDER = ['extra_narrow', 'narrow', 'standard', 'wide', 'extra_wide'];
  var WIDTH_OPTION_LABELS = {
    extra_narrow: 'Extra Narrow',
    narrow: 'Narrow',
    standard: 'Standard',
    wide: 'Wide',
    extra_wide: 'Extra Wide',
    custom: 'Custom width'
  };
  var SKI_WIDTH_ADJUSTMENTS = {
    extra_narrow: -8,
    narrow: -4,
    standard: 0,
    wide: 4,
    extra_wide: 8
  };

  var SKI_WIDTH_SPECS = {
    'Tahsis': { waists: { 150: 80, 155: 83, 160: 85, 165: 87, 170: 93, 175: 93, 180: 96, 185: 96, 190: 97 }, adjustments: SKI_WIDTH_ADJUSTMENTS, custom: true },
    'Zeballos': { waists: { 155: 91, 160: 93, 165: 95, 170: 98, 175: 101, 180: 104, 185: 107, 190: 111 }, adjustments: SKI_WIDTH_ADJUSTMENTS, custom: true },
    '5040': { waists: { 163: 109, 169: 114, 175: 116, 181: 116, 187: 116, 193: 116 }, adjustments: SKI_WIDTH_ADJUSTMENTS, custom: true },
    'Ramblers': { waists: { 165: 110, 170: 113, 175: 113, 180: 117, 185: 117, 190: 119 }, adjustments: SKI_WIDTH_ADJUSTMENTS, custom: true }
  };

  var SKI_SHAPES = {
    'Tahsis': { name: 'Tahsis', lengths: [150, 155, 160, 165, 170, 175, 180, 185, 190], terrain: ['backcountry', 'all_mountain'], snow: ['deep', 'soft'], turns: ['long', 'mixed'], feel: ['powerful', 'balanced'], priorities: ['float', 'stability'], profile: 'Early-rise tip with camber underfoot', flex: 7 },
    'Zeballos': { name: 'Zeballos', lengths: [155, 160, 165, 170, 175, 180, 185, 190], terrain: ['all_mountain', 'trees'], snow: ['variable', 'soft'], turns: ['quick', 'mixed'], feel: ['playful', 'balanced'], priorities: ['versatility', 'maneuverability'], profile: 'Moderate tip rise with camber underfoot', flex: 6 },
    '5040': { name: '5040', lengths: [163, 169, 175, 181, 187, 193], terrain: ['backcountry', 'trees'], snow: ['variable', 'soft'], turns: ['quick'], feel: ['playful', 'balanced'], priorities: ['touring_efficiency', 'maneuverability'], profile: 'Touring-minded early rise with camber underfoot', flex: 6 },
    'Ramblers': { name: 'Ramblers', lengths: [165, 170, 175, 180, 185, 190], terrain: ['backcountry', 'all_mountain'], snow: ['deep', 'soft'], turns: ['long', 'mixed'], feel: ['powerful', 'balanced'], priorities: ['float', 'stability', 'versatility'], profile: 'Long early-rise tip with a supportive tail', flex: 7 }
  };

  var SHAPE_PRODUCT_SUMMARIES = {
    'Tsitika': {
      standard: 'Wide, cambered and aggressive, the Tsitika is an all-mountain freeride board built for powerful carving and composure at speed. Its progressive sidecut keeps turn transitions manageable and extends its capability beyond the groomers.',
      splitboard: 'Wide, cambered and aggressive, the Tsitika Split brings powerful edge drive and high-speed stability to an all-mountain touring platform. Its progressive sidecut keeps turn transitions manageable across changing conditions.'
    },
    'MRK5': {
      standard: 'Designed with Mark Fawcett for advanced riders, the MRK5 combines a wide waist, straighter sidecut and setback camber for deep carves, natural powder float and reduced boot drag. It has the stability of a longer board while remaining playful in tight terrain.',
      splitboard: 'Designed with Mark Fawcett for advanced riders, the MRK5 Split combines a wide waist, straighter sidecut and setback camber for strong edge angles, powder float and reduced boot drag. Its stable platform remains playful enough for tight backcountry terrain.'
    },
    'Ukee': {
      standard: 'The Ukee is an aggressive directional freeride shape for riders who charge deep snow. Asymmetrical camber, progressive sidecut, pronounced taper, a softer nose and a firmer tail create quick turn entry, strong speed stability and easy float.',
      splitboard: 'The Ukee Split is an aggressive directional touring shape for riders who charge deep snow. Asymmetrical camber, progressive sidecut, pronounced taper, a softer nose and a firmer tail create quick turn entry, strong speed stability and easy float.'
    },
    'Arrowsmith': {
      standard: 'The Arrowsmith is a directional all-mountain freeride shape tuned for powder days without sacrificing everyday versatility. Its balanced, forgiving character feels intuitive across the mountain, with easy turns and a playful, surf-inspired ride.',
      splitboard: 'The Arrowsmith Split brings a playful, surf-inspired feel to a directional all-mountain touring shape. It prioritizes powder float while remaining balanced, forgiving and intuitive across varied terrain.'
    },
    'Tyee': {
      standard: 'Built around speed on groomed terrain, the Tyee pairs full camber, conventional tip and tail rise and a long effective edge for a planted platform through fast turns. Its hard-charging character retains enough playfulness to stay engaging.'
    },
    'Black Creek': {
      standard: 'The Black Creek is a directional all-mountain shape that favours powder while remaining dependable across changing conditions. A broad nose adds float, mellow edge serration adds firm-snow bite, and early-rise camber with a firmer tail balances stability with manoeuvrability.',
      splitboard: 'Directional and powder-biased, the Black Creek Split uses a broad nose for float, mellow edge serration for grip in hard or icy snow, and early-rise camber with a firmer tail for a stable, manoeuvrable descent.'
    },
    'TR Twin': {
      standard: 'The TR Twin is a playful true twin with a forgiving mid flex for presses, butters and easy manoeuvring. A mellow tip-and-tail sidecut creates smooth, catch-free transitions while the lively platform adds snap.'
    },
    'Nootka': {
      standard: 'The Nootka is Kindred’s versatile, do-everything shape. Camber near the contact zones provides dependable grip, while rocker through the centre keeps the ride playful and buoyant in soft snow.',
      splitboard: 'The Nootka Split is a versatile touring shape for mixed mountain conditions. Dual camber maintains edge grip, while the rockered centre adds playfulness and float as the snow deepens.'
    },
    'Carmanah': {
      standard: 'The Carmanah is an ultra-wide, full-rocker powder board designed to be ridden short. Its large surface area provides deep-snow float, while the tight sidecut keeps it quick and playful in low-angle trees.',
      splitboard: 'The Carmanah Split brings an ultra-wide, short-riding powder platform to the skin track. Full rocker and generous surface area provide deep-snow float, while the tight sidecut keeps it quick and playful in low-angle trees.'
    },
    'Merville': {
      standard: 'The Merville is a highly directional powder shape with a paddle nose and swallowtail that is steered from the back foot. Its firmer tail supplies control while the softer nose creates quick engagement and effortless float.',
      splitboard: 'The Merville Split is a highly directional powder touring shape with a paddle nose and swallowtail that is steered from the back foot. Its firmer tail supplies control while the softer nose creates quick engagement and effortless float.'
    },
    'Tofino': {
      standard: 'The Tofino is a mid-stiff, full-camber shape with a long effective edge for powerful, stable carving. Its setback stance, broad nose and fishtail add float and a surfy feel in powder.',
      splitboard: 'The Tofino Split pairs a mid-stiff, full-camber touring platform with a long effective edge for powerful, stable turns. Its setback stance, broad nose and fishtail add float and a surfy feel in powder.'
    },
    'ProCarve': {
      standard: 'The ProCarve is a powerful, race-influenced carving board with immediate engagement and energetic response. Its damp, planted character inspires trust in demanding conditions and works with soft- or hard-boot setups.'
    },
    'One Eyed Jack': {
      standard: 'The One Eyed Jack is a lively twin carver built to drive powerful turns both regular and switch. Its reinforced platform delivers smooth power transfer, dependable edge hold and composure for aggressive riding on fresh groomers.'
    },
    'Delta': {
      standard: 'The Delta is a wide, stable carving shape made to feel planted at speed and dependable across firm or variable snow. It holds confidently through the turn and releases with lively snap into the next carve.'
    },
    'BSL': {
      standard: 'The BSL is a custom banked-slalom race shape developed with Canadian national team riders and coaches and backed by podium results. Its construction prioritizes maximum edge hold, precise feel and composed speed.'
    },
    'FlowCarve': {
      standard: 'The FlowCarve is a responsive carving shape for smooth, controlled riding at a medium pace. Its mid-stiff flex is supportive and stable while remaining easy to initiate and predictable through each turn.'
    },
    'Kidred': {
      standard: 'The Kidred is a playful yet supportive youth twin designed to help developing riders progress confidently. Its dual-radius sidecut encourages catch-free edge transitions while retaining stability as speed increases.'
    },
    'Elkhorn': {
      standard: 'The Elkhorn is a playful youth powder shape that balances float with dependable stability. Its easygoing character gives young riders confidence to explore fresh snow and new terrain.'
    },
    'Tahsis': {
      standard: 'The Tahsis is a stable, fast resort-freeride ski with modest traditional camber and medium-rise tip and tail. It offers strong on-piste bite, balanced support and quick response across changing terrain and conditions.'
    },
    'Zeballos': {
      standard: 'The Zeballos is a playful, powder-biased daily driver with elongated tip and tail plus subtle early-rise camber for float without sacrificing stability. Its modest waist and symmetrical flex keep the ride balanced and versatile.'
    },
    '5040': {
      standard: 'The 5040 is a BC freeride ski whose elongated tip and tail rise make turn initiation quick while retaining stability. It is aimed at backcountry touring and exploring less-travelled off-piste resort terrain.'
    },
    'Ramblers': {
      standard: 'The Ramblers are wide, directional big-mountain powder skis with an energetic character and early-rise camber for float. Camber underfoot keeps them solid edge to edge for touring and traversing while the shape rewards strong skiing in open alpine terrain.'
    }
  };

  function productSummary(shape, state) {
    var summaries = SHAPE_PRODUCT_SUMMARIES[shape.name] || {};
    if (state.product_type === 'splitboard' && summaries.splitboard) return summaries.splitboard;
    return summaries.standard || 'A proven Kindred shape that can be tuned around your measurements, terrain and ride goals.';
  }

  function shapesFrom(library, names) {
    return names.map(function (name) { return library[name]; }).filter(Boolean);
  }

  var DEFAULT_COLLECTION_SHAPES = {
    freeride_snowboard: ['Tsitika', 'MRK5', 'Ukee', 'Arrowsmith', 'Tyee', 'Black Creek', 'Nootka', 'Tofino', 'Merville', 'Carmanah'],
    freestyle_snowboard: ['TR Twin', 'Nootka', 'Arrowsmith'],
    carving_snowboard: ['ProCarve', 'One Eyed Jack', 'Delta', 'Tyee', 'Tsitika', 'MRK5', 'BSL', 'FlowCarve'],
    youth_snowboard: ['Kidred', 'Elkhorn'],
    splitboard: ['Arrowsmith', 'Tsitika', 'MRK5', 'Ukee', 'Black Creek', 'Nootka', 'Tofino', 'Merville', 'Carmanah'],
    ski: ['Tahsis', 'Zeballos', '5040', 'Ramblers']
  };

  var SHAPES = {};

  function collectionShapeLibrary(collection) {
    return collection === 'ski' ? SKI_SHAPES : BOARD_SHAPES;
  }

  function applyCollectionShapeOverrides(overrides) {
    var source = overrides && typeof overrides === 'object' ? overrides : {};
    Object.keys(DEFAULT_COLLECTION_SHAPES).forEach(function (collection) {
      var library = collectionShapeLibrary(collection);
      var requested = asArray(source[collection]).filter(function (name, index, values) {
        return Boolean(library[name]) && values.indexOf(name) === index;
      });
      var names = requested.length ? requested : DEFAULT_COLLECTION_SHAPES[collection];
      SHAPES[collection] = shapesFrom(library, names);
    });
  }

  applyCollectionShapeOverrides({});

  function number(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : (fallback || 0);
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function asArray(value) {
    if (Array.isArray(value)) return value;
    if (value === undefined || value === null || value === '') return [];
    return [value];
  }

  function humanize(value) {
    return String(value || '').replace(/_/g, ' ').replace(/\b\w/g, function (character) { return character.toUpperCase(); });
  }

  function label(group, value) {
    return LABELS[group] && LABELS[group][value] ? LABELS[group][value] : humanize(value);
  }

  function currencyCode(value, fallback) {
    var code = String(value || '').trim().toUpperCase();
    return /^[A-Z]{3}$/.test(code) ? code : (fallback || 'CAD');
  }

  function currencyRate(value, fallback) {
    var rate = Number(value);
    return Number.isFinite(rate) && rate > 0 ? rate : (fallback || 1);
  }

  function resolveCurrencyContext(config) {
    var baseCurrency = currencyCode(config && config.baseCurrency, 'CAD');
    var context = {
      currency: currencyCode(config && config.currency, baseCurrency),
      rate: currencyRate(config && config.currencyRate, 1)
    };
    var shopifySources = [];
    if (global.Shopify) shopifySources.push(global.Shopify);
    try {
      if (global.parent && global.parent !== global && global.parent.Shopify) shopifySources.push(global.parent.Shopify);
    } catch { /* Cross-origin Shopify parents provide currency through URL parameters or postMessage. */ }
    shopifySources.some(function (shopify) {
      var currency = shopify && shopify.currency;
      if (!currency) return false;
      context.currency = currencyCode(currency.active || currency.iso_code, context.currency);
      context.rate = currencyRate(currency.rate, context.rate);
      return true;
    });
    try {
      var params = new URLSearchParams(global.location && global.location.search || '');
      context.currency = currencyCode(params.get('currency') || params.get('shopify_currency'), context.currency);
      context.rate = currencyRate(params.get('currency_rate') || params.get('shopify_currency_rate') || params.get('rate'), context.rate);
    } catch { /* The configured fallback remains authoritative. */ }
    if (context.currency === baseCurrency) context.rate = 1;
    return context;
  }

  function convertedAmount(value, rate) {
    return Math.round(number(value, 0) * currencyRate(rate, 1));
  }

  function formatMoney(value, currency, includeCurrency) {
    var code = currencyCode(currency, 'CAD');
    var amount = Math.round(number(value, 0));
    var formatted;
    try {
      formatted = new Intl.NumberFormat('en-CA', { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 }).format(amount);
    } catch {
      formatted = '$' + amount.toLocaleString('en-CA');
    }
    return formatted + (includeCurrency === false ? '' : ' ' + code);
  }

  function mergeShapePrices(overrides) {
    var source = overrides || {};
    return {
      snowboard: Object.assign({}, DEFAULT_SHAPE_PRICES.snowboard, source.snowboard || {}),
      splitboard: Object.assign({}, DEFAULT_SHAPE_PRICES.splitboard, source.splitboard || {}),
      skis: Object.assign({}, DEFAULT_SHAPE_PRICES.skis, source.skis || {})
    };
  }

  function stockShapeBasePrice(shapeName, productType, config) {
    var table = config && config.shapePrices && config.shapePrices[productType];
    var value = table && table[shapeName];
    var parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  }

  function hasValue(value) {
    return value !== undefined && value !== null && String(value).trim() !== '';
  }

  function conciseNumber(value) {
    var numeric = number(value, 0);
    return Number.isInteger(numeric) ? String(numeric) : numeric.toFixed(1).replace(/\.0$/, '');
  }

  function splitImperialHeight(totalInches) {
    var rounded = Math.round(number(totalInches, 0) * 2) / 2;
    var feet = Math.floor(rounded / 12);
    var inches = rounded - (feet * 12);
    if (inches >= 12) {
      feet += 1;
      inches = 0;
    }
    return { feet: feet, inches: inches };
  }

  function formatHeight(input, normalized) {
    var source = input || {};
    if (normalized.unit === 'imperial') {
      var splitProvided = hasValue(source.height_feet) || hasValue(source.height_inches);
      var totalInches = splitProvided
        ? (number(source.height_feet, 0) * 12) + number(source.height_inches, 0)
        : (hasValue(source.height) ? number(source.height, 0) : normalized.heightCm / 2.54);
      var parts = splitImperialHeight(totalInches);
      return parts.feet + ' ft ' + conciseNumber(parts.inches) + ' in';
    }
    var centimetres = hasValue(source.height) ? number(source.height, 0) : normalized.heightCm;
    return conciseNumber(centimetres) + ' cm';
  }

  function formatWeight(input, normalized) {
    var source = input || {};
    if (normalized.unit === 'imperial') {
      var pounds = hasValue(source.weight) ? number(source.weight, 0) : normalized.weightKg / 0.45359237;
      return conciseNumber(pounds) + ' lb';
    }
    var kilograms = hasValue(source.weight) ? number(source.weight, 0) : normalized.weightKg;
    return conciseNumber(kilograms) + ' kg';
  }

  function formatBootSize(state) {
    return state.boot_size ? state.boot_size + ' ' + label('boot_size_unit', state.boot_size_unit) : 'Not supplied';
  }

  function formatStanceAngle(value, position) {
    if (!hasValue(value)) return '';
    var angle = number(value, 0);
    return position + ' ' + (angle > 0 ? '+' : '') + conciseNumber(angle) + '°';
  }

  function formatStance(state) {
    var details = [];
    if (hasValue(state.stance_width)) details.push(state.stance_width + ' ' + (state.stance_width_unit === 'in' ? 'in' : 'cm') + ' wide');
    var front = formatStanceAngle(state.front_angle, 'front');
    var rear = formatStanceAngle(state.rear_angle, 'rear');
    if (front) details.push(front);
    if (rear) details.push(rear);
    return details.join(' · ');
  }

  function formatSkiSetup(state) {
    var details = [];
    if (hasValue(state.ski_bsl)) details.push(state.ski_bsl + ' mm BSL');
    if (state.ski_binding_style) details.push(label('ski_binding_style', state.ski_binding_style));
    return details.join(' · ');
  }

  function resolveCollection(state, shapeChoice, legacyCustomShape) {
    if (state.collection || state.product_collection) return state.collection || state.product_collection;
    if (shapeChoice === 'full_custom' || legacyCustomShape) return 'custom_shape';
    if (state.product_type === 'splitboard' || state.product === 'splitboard') return 'splitboard';
    if (state.product_type === 'skis' || state.product === 'skis' || state.product_type === 'ski' || state.product === 'ski') return 'ski';
    return 'freeride_snowboard';
  }

  function resolveProductType(state, collection) {
    if (collection === 'custom_shape') {
      var customProduct = state.custom_product_type || state.product_type || state.product;
      return customProduct === 'splitboard' || customProduct === 'skis' ? customProduct : 'snowboard';
    }
    return COLLECTION_PRODUCT_TYPES[collection] || 'snowboard';
  }

  function shapePool(state) {
    if (state.collection !== 'custom_shape') return SHAPES[state.collection] || SHAPES.freeride_snowboard;
    if (state.product_type === 'skis') return SHAPES.ski;
    if (state.product_type === 'splitboard') return SHAPES.splitboard;
    var names = new Set();
    return SHAPES.freeride_snowboard.concat(SHAPES.freestyle_snowboard, SHAPES.carving_snowboard).filter(function (shape) {
      if (names.has(shape.name)) return false;
      names.add(shape.name);
      return true;
    });
  }

  function collectionShapeNames(collection) {
    return (SHAPES[collection] || []).map(function (shape) { return shape.name; });
  }

  function stockLengthsForShape(name) {
    var shape = BOARD_SHAPES[name] || SKI_SHAPES[name];
    return shape && Array.isArray(shape.lengths) ? shape.lengths.slice() : [];
  }

  function normalizeState(input) {
    var state = input || {};
    var rider = state.rider || {};
    var conditions = state.conditions || {};
    var ride = state.ride || {};
    var unit = state.unit || state.units || 'metric';
    var splitHeightProvided = hasValue(state.height_feet) || hasValue(state.height_inches);
    var height = unit === 'imperial'
      ? (splitHeightProvided
        ? ((number(state.height_feet, 0) * 12) + number(state.height_inches, 0)) * 2.54
        : (state.height !== undefined ? number(state.height, 0) * 2.54 : number(state.heightCm !== undefined ? state.heightCm : rider.heightCm, 0)))
      : number(state.height !== undefined ? state.height : (state.heightCm !== undefined ? state.heightCm : rider.heightCm), 0);
    var weight = state.weight !== undefined ? number(state.weight, 0) : number(state.weightKg !== undefined ? state.weightKg : rider.weightKg, 0);
    if (unit === 'imperial' && state.weight !== undefined) weight *= 0.45359237;
    var legacyCustomShape = state.custom_shape === true || state.custom_shape === 'custom';
    var shapeChoice = state.shape_choice || state.shape_selection || state.selected_shape || '';
    var collection = resolveCollection(state, shapeChoice, legacyCustomShape);
    if (collection === 'custom_shape' || (!shapeChoice && legacyCustomShape)) shapeChoice = 'full_custom';
    var productType = resolveProductType(state, collection);
    var hasProvidedSpecs = Boolean(state.expert_specs) || ['exact_length', 'exact_waist', 'exact_radius', 'exact_taper', 'exact_tip_length', 'exact_tail_length', 'exact_setback', 'camber_profile', 'expert_notes'].some(function (key) { return hasValue(state[key]); });
    var customSpecMode = state.custom_spec_mode || (hasProvidedSpecs ? 'specs' : 'consult');
    var submittedOwnSpecs = collection === 'custom_shape' ? customSpecMode === 'specs' : Boolean(state.expert_specs);
    if (submittedOwnSpecs) {
      shapeChoice = 'full_custom';
      customSpecMode = 'specs';
    }
    var normalizedConstruction = compatibleConstructionKey(
      state.construction || 'fiberglass',
      constructionOptionsForSelection(shapeChoice, collection === 'custom_shape' || shapeChoice === 'full_custom' || legacyCustomShape, productType)
    );

    var goalProfile = collectionGoalProfile(goalProfileKey(collection, productType));
    return {
      collection: collection,
      product_type: productType,
      custom_product_type: state.custom_product_type || productType,
      unit: unit,
      heightCm: height || 178,
      weightKg: weight || 78,
      boot_size: String(state.boot_size !== undefined ? state.boot_size : (rider.boot && rider.boot.value) || ''),
      boot_size_unit: state.boot_size_unit || (rider.boot && rider.boot.unit) || 'mens_us',
      ability: state.ability || 'intermediate',
      location: state.location || rider.location || 'pnw_bc_coast',
      terrain: state.terrain || conditions.terrain || collectionGoalProfile(collection).terrainFallback,
      snow: state.snow || conditions.snow || collectionGoalProfile(collection).snowFallback,
      turn_style: state.turn_style || ride.turns || 'mixed',
      ride_feel: state.ride_feel || ride.feel || 'balanced',
      responsiveness: state.responsiveness || ride.responsiveness || '',
      priorities: asArray(state.priorities || ride.priorities || ['versatility']).filter(function (priority) { return goalProfile.priorityOptions.indexOf(priority) !== -1; }),
      construction: normalizedConstruction,
      flex_pattern: ['extra_soft', 'soft', 'standard', 'stiff', 'extra_stiff'].indexOf(state.flex_pattern) !== -1 ? state.flex_pattern : '',
      artwork_level: state.artwork_level || 'stock_graphic',
      graphic_option: state.graphic_option || '',
      graphic_title: state.graphic_title || '',
      base_colour: state.base_colour || 'black_on_red',
      shape_choice: shapeChoice,
      waist_width_choice: state.waist_width_choice || state.width_choice || '',
      custom_shape: shapeChoice === 'full_custom' || legacyCustomShape ? 'custom' : 'standard',
      custom_spec_mode: customSpecMode,
      expert_specs: collection === 'custom_shape' ? customSpecMode === 'specs' : Boolean(state.expert_specs),
      exact_length: state.exact_length || '',
      exact_waist: state.exact_waist || '',
      exact_radius: state.exact_radius || '',
      exact_taper: state.exact_taper || state.taper || '',
      exact_tip_length: state.exact_tip_length || '',
      exact_tail_length: state.exact_tail_length || '',
      exact_setback: state.exact_setback || '',
      camber_profile: state.camber_profile || '',
      expert_notes: state.expert_notes || '',
      art_notes: state.artwork_level === 'customer_provided' ? '' : (state.art_notes || ''),
      art_link: state.art_link || '',
      art_inspiration_link: state.art_inspiration_link || '',
      art_reference_link: state.art_reference_link || '',
      timing: state.timing || '',
      contact_notes: state.contact_notes || '',
      stance_width_unit: state.stance_width_unit || (unit === 'imperial' ? 'in' : 'cm'),
      stance_width: state.stance_width || '',
      front_angle: hasValue(state.front_angle) ? String(state.front_angle) : '',
      rear_angle: hasValue(state.rear_angle) ? String(state.rear_angle) : '',
      ski_bsl: state.ski_bsl || '',
      ski_binding_style: state.ski_binding_style || '',
      ski_touring_notch: state.ski_touring_notch || 'no',
      touring_focus: state.touring_focus || 'balanced',
      hidden_questions: asArray(state.hidden_questions)
    };
  }

  function profileCategory(state) {
    if (state.product_type === 'splitboard') return 'splitboard';
    if (state.product_type === 'skis') return 'ski';
    return 'snowboard';
  }

  function rideGoalProfile(shape, state) {
    return RIDE_GOAL_PROFILE_OVERRIDES[profileCategory(state) + ':' + shape.name] || null;
  }

  function scaleContribution(profile, section, answer, maximum) {
    var value = profile && profile[section] ? number(profile[section][answer], NaN) : NaN;
    if (!Number.isFinite(value)) return 0;
    return ((clamp(value, 1, 5) - 1) / 4) * maximum;
  }

  var INTERMEDIATE_ANSWER_NEIGHBOURS = {
    turn_style: {
      short: ['quick', 'mixed'],
      sweeping: ['mixed', 'long']
    },
    ride_feel: {
      lively: ['playful', 'balanced'],
      supportive: ['balanced', 'powerful']
    }
  };

  function fallbackAnswerContribution(matches, section, answer, maximum) {
    if (matches.indexOf(answer) !== -1) return maximum;
    var neighbours = INTERMEDIATE_ANSWER_NEIGHBOURS[section] && INTERMEDIATE_ANSWER_NEIGHBOURS[section][answer];
    if (!neighbours) return 0;
    var count = neighbours.filter(function (key) { return matches.indexOf(key) !== -1; }).length;
    return count === 2 ? maximum : (count === 1 ? maximum * 0.6 : 0);
  }

  function quickTurnPreference(value) {
    return value === 'quick' || value === 'short';
  }

  function longTurnPreference(value) {
    return value === 'sweeping' || value === 'long';
  }

  function playfulRidePreference(value) {
    return value === 'playful' || value === 'lively';
  }

  function powerfulRidePreference(value) {
    return value === 'supportive' || value === 'powerful';
  }

  function scoreShape(shape, state) {
    var questionWeights = questionWeightsForState(state);
    var profile = rideGoalProfile(shape, state);
    if (profile) {
      var profileScore = asArray(profile.terrain).indexOf(state.terrain) !== -1 ? questionWeights.terrain : 0;
      profileScore += scaleContribution(profile, 'snow', state.snow, questionWeights.snow);
      profileScore += scaleContribution(profile, 'turn_style', state.turn_style, questionWeights.turn_style);
      profileScore += scaleContribution(profile, 'responsiveness', state.responsiveness, questionWeights.responsiveness);
      profileScore += scaleContribution(profile, 'ride_feel', state.ride_feel, questionWeights.ride_feel);
      state.priorities.forEach(function (priority) {
        profileScore += scaleContribution(profile, 'priorities', priority, questionWeights.priorities);
      });
      if (state.product_type === 'splitboard') {
        profileScore += scaleContribution(profile, 'touring_focus', state.touring_focus, questionWeights.touring_focus);
      }
      if (state.product_type === 'skis') {
        profileScore += scaleContribution(profile, 'ski_touring_notch', state.ski_touring_notch, questionWeights.ski_touring_notch);
      }
      return profileScore;
    }

    var score = 0;
    if (shapeMatchesTerrain(shape, state.terrain)) score += questionWeights.terrain;
    if (shape.snow.indexOf(state.snow) !== -1) score += questionWeights.snow;
    score += fallbackAnswerContribution(shape.turns, 'turn_style', state.turn_style, questionWeights.turn_style);
    score += fallbackAnswerContribution(shape.feel, 'ride_feel', state.ride_feel, questionWeights.ride_feel);
    state.priorities.forEach(function (priority) {
      score += shape.priorities.indexOf(priority) !== -1 ? questionWeights.priorities : -(questionWeights.priorities / 16);
    });
    if (state.snow === 'deep' && shape.priorities.indexOf('float') === -1) score -= questionWeights.snow * (4 / 7);
    if (state.terrain === 'park' && shape.priorities.indexOf('freestyle') === -1) score -= questionWeights.terrain * (6 / 7);
    if (state.terrain === 'groomers' && powerfulRidePreference(state.ride_feel) && shape.priorities.indexOf('edge_hold') !== -1) score += Math.min(questionWeights.terrain, questionWeights.ride_feel) * (3 / 5);
    if (state.product_type === 'splitboard' && state.touring_focus === 'uphill' && shape.name === 'MRK5') score += questionWeights.touring_focus;
    if (state.product_type === 'splitboard' && state.touring_focus === 'descent' && shape.name === 'Tsitika') score += questionWeights.touring_focus;
    return score;
  }

  function mensBootEquivalent(bootText, bootUnit) {
    var match = String(bootText || '').match(/\d+(?:\.\d+)?/);
    var boot = match ? Number(match[0]) : NaN;
    if (!Number.isFinite(boot)) return NaN;
    if (bootUnit === 'womens_us') return boot - 1.5;
    if (bootUnit === 'mondo') return boot - 18;
    if (bootUnit === 'eu') return boot - 33;
    if (bootUnit === 'uk') return boot + 1;
    return boot;
  }

  function averageMensBootByHeight(heightCm) {
    var height = number(heightCm, NaN);
    if (!Number.isFinite(height) || height < 150) return NaN;
    var referenceHeight = clamp(height, 150, 200);
    return Math.round(((0.162109 * referenceHeight) - 18.4409) * 2) / 2;
  }

  function sizingFootEquivalent(state) {
    var boot = mensBootEquivalent(state.boot_size, state.boot_size_unit);
    if (Number.isFinite(boot)) return boot;
    return clamp(Math.round((((0.162109 * state.heightCm) - 18.4409) * 2)) / 2, 1, 16);
  }

  function combinedSizeFitScore(state, target) {
    if (!target || typeof target !== 'object') return 0;
    var targetHeight = number(target.height_cm, NaN);
    var targetWeight = number(target.weight_kg, NaN);
    var targetFoot = number(target.foot_us, NaN);
    if (!Number.isFinite(targetHeight) || !Number.isFinite(targetWeight) || !Number.isFinite(targetFoot)) return 0;
    var heightScore = Math.max(0, 100 - ((Math.abs(state.heightCm - targetHeight) / 20) * 100));
    var weightScore = Math.max(0, 100 - ((Math.abs(state.weightKg - targetWeight) / 30) * 100));
    var footScore = Math.max(0, 100 - ((Math.abs(sizingFootEquivalent(state) - targetFoot) / 5) * 100));
    return Math.round((heightScore * 0.35) + (weightScore * 0.45) + (footScore * 0.2));
  }

  function stockWaistForShape(name, length, profile) {
    var configuredTarget = profile && profile.size_fits && profile.size_fits[String(length)];
    var configuredWaist = configuredTarget ? Number(configuredTarget.waist_mm) : NaN;
    if (Number.isFinite(configuredWaist)) return configuredWaist;
    var spec = BOARD_WIDTH_SPECS[name] || SKI_WIDTH_SPECS[name];
    if (!spec || !spec.waists || !hasValue(length)) return null;
    var waist = number(spec.waists[String(length)], NaN);
    return Number.isFinite(waist) ? waist : null;
  }

  function stockFootReferenceForShape(shape, state, length) {
    var profile = shape ? rideGoalProfile(shape, state) : null;
    var configuredTarget = profile && profile.size_fits && profile.size_fits[String(length)];
    var configuredFoot = configuredTarget ? Number(configuredTarget.foot_us) : NaN;
    if (Number.isFinite(configuredFoot)) return { value: configuredFoot, source: 'selected_size' };
    return { value: averageMensBootByHeight(state.heightCm), source: 'height' };
  }

  function signedMillimetres(value) {
    if (value > 0) return '+' + value + ' mm';
    if (value < 0) return '−' + Math.abs(value) + ' mm';
    return '0 mm';
  }

  function widthGoalSignals(state) {
    var wider = 0;
    var narrower = 0;
    if (state.terrain === 'backcountry') wider += 1;
    if (state.terrain === 'trees' || state.terrain === 'groomers') narrower += 1;
    if (state.terrain === 'park') narrower += 2;
    if (state.snow === 'deep') wider += 3;
    else if (state.snow === 'soft') wider += 1;
    if (state.priorities.indexOf('float') !== -1) wider += 3;
    if (state.priorities.indexOf('stability') !== -1) wider += 1;
    if (longTurnPreference(state.turn_style)) wider += 1;
    if (state.ride_feel === 'powerful') wider += 1;
    if (state.snow === 'firm') narrower += 1;
    if (state.priorities.indexOf('maneuverability') !== -1) narrower += 2;
    if (state.priorities.indexOf('freestyle') !== -1) narrower += 2;
    if (state.priorities.indexOf('touring_efficiency') !== -1) narrower += 2;
    if (quickTurnPreference(state.turn_style)) narrower += 2;
    if (state.ride_feel === 'playful') narrower += 1;
    return {
      wider: wider,
      narrower: narrower,
      direction: wider >= narrower + 2 ? 'wider' : (narrower >= wider + 2 ? 'narrower' : 'balanced')
    };
  }

  function boardWidthRecommendation(shape, state, stockLength) {
    var spec = BOARD_WIDTH_SPECS[shape.name];
    var profile = rideGoalProfile(shape, state);
    var standardWaist = stockWaistForShape(shape.name, stockLength, profile);
    var boot = mensBootEquivalent(state.boot_size, state.boot_size_unit);
    var footReference = stockFootReferenceForShape(shape, state, stockLength);
    var referenceBoot = footReference.value;
    var referenceText = Number.isFinite(referenceBoot)
      ? (footReference.source === 'selected_size'
        ? ' · Men’s US ' + conciseNumber(referenceBoot) + ' selected-size reference'
        : ' · avg. Men’s US ' + conciseNumber(referenceBoot) + ' height reference')
      : '';
    var goalSignals = widthGoalSignals(state);

    if (!spec || standardWaist === null) {
      var fallback = !Number.isFinite(boot)
        ? 'Standard width · confirm from boot dimensions'
        : (boot <= 8 ? 'Narrow to standard · builder to confirm' : (boot <= 10.5 ? 'Standard width' : (boot <= 11.5 ? 'Wide · builder to confirm' : 'Custom waist · boot clearance review required')));
      return {
        key: 'standard',
        label: 'Standard',
        waist: null,
        standardWaist: null,
        adjustment: 0,
        referenceBoot: referenceBoot,
        text: fallback + referenceText,
        reason: 'Boot clearance and ride goals require a builder review for this stock shape.'
      };
    }

    var requestedKey = 'standard';
    var bootDifference = NaN;
    if (Number.isFinite(boot) && Number.isFinite(referenceBoot)) {
      bootDifference = boot - referenceBoot;
      if (bootDifference <= -1.5) requestedKey = 'narrow';
      else if (bootDifference >= 2) requestedKey = 'extra_wide';
      else if (bootDifference >= 1) requestedKey = 'wide';
    }

    var requestedIndex = WIDTH_OPTION_ORDER.indexOf(requestedKey);
    if (goalSignals.direction === 'wider' && requestedIndex >= 0) {
      requestedKey = WIDTH_OPTION_ORDER[Math.min(WIDTH_OPTION_ORDER.length - 1, requestedIndex + 1)];
    } else if (goalSignals.direction === 'narrower' && requestedIndex > 1 && bootDifference < 0) {
      requestedKey = WIDTH_OPTION_ORDER[requestedIndex - 1];
    } else if (goalSignals.direction === 'narrower' && requestedIndex === 1 && bootDifference <= -0.5) {
      requestedKey = 'narrow';
    }

    var availableAdjustment = spec.adjustments[requestedKey];
    var key = requestedKey;
    if (!Number.isFinite(availableAdjustment)) {
      if (requestedKey === 'extra_wide' && Number.isFinite(spec.adjustments.wide) && !spec.custom) key = 'wide';
      else if (requestedKey !== 'standard' && spec.custom) key = 'custom';
      else key = 'standard';
    }

    if (key === 'custom') {
      return {
        key: key,
        label: 'Custom width',
        waist: null,
        standardWaist: standardWaist,
        adjustment: null,
        referenceBoot: referenceBoot,
        text: 'Custom width · ' + standardWaist + ' mm stock standard' + referenceText,
        reason: 'Boot clearance sets the minimum width. ' + (goalSignals.direction === 'wider'
          ? 'The selected snow and ride goals also favour more platform, so a builder-defined waist is suggested.'
          : 'The selected handling goals are balanced against boot clearance, so a builder-defined waist is suggested.')
      };
    }

    var adjustment = spec.adjustments[key];
    var waist = standardWaist + adjustment;
    var labels = WIDTH_OPTION_LABELS;
    var adjustmentText = key === 'standard' ? '' : ' ' + signedMillimetres(adjustment);
    var baselineText = key === 'standard' ? '' : ' · ' + standardWaist + ' mm standard';
    var bootReason = Number.isFinite(boot)
      ? 'A Men’s US ' + conciseNumber(boot) + ' equivalent establishes the boot-clearance requirement.'
      : 'Boot dimensions will be confirmed by the builder.';
    var goalReason = goalSignals.direction === 'wider'
      ? 'The selected snow and ride goals favour additional platform.'
      : (goalSignals.direction === 'narrower'
        ? 'The selected ride goals favour quicker edge-to-edge handling where boot clearance allows.'
        : 'The selected ride goals support a balanced width.');
    return {
      key: key,
      label: labels[key],
      waist: waist,
      standardWaist: standardWaist,
      adjustment: adjustment,
      referenceBoot: referenceBoot,
      text: labels[key] + adjustmentText + ' · ' + waist + ' mm waist' + baselineText + referenceText,
      reason: bootReason + ' ' + goalReason
    };
  }

  function boardWidthOptions(shape, state, stockLength) {
    var spec = BOARD_WIDTH_SPECS[shape.name];
    var suggested = boardWidthRecommendation(shape, state, stockLength);
    var standardWaist = stockWaistForShape(shape.name, stockLength, rideGoalProfile(shape, state));
    if (!spec || standardWaist === null) {
      return [{
        key: 'standard',
        label: 'Standard',
        waist: null,
        adjustment: 0,
        text: 'Standard width · builder to confirm',
        detail: 'Stock width requires a builder review.',
        isSuggested: true
      }];
    }
    var options = WIDTH_OPTION_ORDER.filter(function (key) {
      return Number.isFinite(spec.adjustments[key]);
    }).map(function (key) {
      var adjustment = spec.adjustments[key];
      var waist = standardWaist + adjustment;
      return {
        key: key,
        label: WIDTH_OPTION_LABELS[key],
        waist: waist,
        standardWaist: standardWaist,
        adjustment: adjustment,
        text: WIDTH_OPTION_LABELS[key] + (key === 'standard' ? '' : ' ' + signedMillimetres(adjustment)) + ' · ' + waist + ' mm waist',
        detail: key === 'standard'
          ? 'Stock standard at the selected length.'
          : Math.abs(adjustment) + ' mm ' + (adjustment < 0 ? 'narrower' : 'wider') + ' than the stock standard.',
        isSuggested: suggested.key === key
      };
    });
    if (spec.custom) {
      options.push({
        key: 'custom',
        label: 'Custom width',
        waist: null,
        standardWaist: standardWaist,
        adjustment: null,
        text: 'Custom width · ' + standardWaist + ' mm stock standard',
        detail: 'A builder-defined waist using the selected stock outline.',
        isSuggested: suggested.key === 'custom'
      });
    }
    return options;
  }

  function skiWidthRecommendation(shape, state, stockLength) {
    var spec = shape && SKI_WIDTH_SPECS[shape.name];
    var standardWaist = shape ? stockWaistForShape(shape.name, stockLength, rideGoalProfile(shape, state)) : null;
    var signals = widthGoalSignals(state);
    var requestedIndex = WIDTH_OPTION_ORDER.indexOf('standard');

    var deepAndFloat = state.snow === 'deep' && state.priorities.indexOf('float') !== -1;
    if (deepAndFloat) requestedIndex += 2;
    else if (state.snow === 'deep' || state.priorities.indexOf('float') !== -1 || signals.direction === 'wider') requestedIndex += 1;
    else if (state.snow === 'firm' && signals.direction === 'narrower') requestedIndex -= 2;
    else if (signals.direction === 'narrower') requestedIndex -= 1;
    requestedIndex = clamp(requestedIndex, 0, WIDTH_OPTION_ORDER.length - 1);

    var key = WIDTH_OPTION_ORDER[requestedIndex];
    var adjustment = SKI_WIDTH_ADJUSTMENTS[key];
    var waist = standardWaist === null ? null : standardWaist + adjustment;
    var adjustmentText = key === 'standard' ? '' : ' ' + signedMillimetres(adjustment);
    var baselineText = key === 'standard' || standardWaist === null ? '' : ' · ' + standardWaist + ' mm standard';
    var text = waist === null
      ? (key === 'standard' ? 'Standard · stock waist dimensions' : WIDTH_OPTION_LABELS[key] + adjustmentText + ' from stock standard')
      : WIDTH_OPTION_LABELS[key] + adjustmentText + ' · ' + waist + ' mm waist' + baselineText;
    var goalReason = key === 'extra_wide' || key === 'wide'
      ? 'Your snow conditions and ride goals favour more surface area, flotation and stability. A wider waist feels more deliberate from edge to edge.'
      : (key === 'extra_narrow' || key === 'narrow'
        ? 'Your snow conditions and ride goals favour quicker edge-to-edge response, lower swing weight and precise firm-snow handling. A narrower waist provides less flotation.'
        : 'Your snow conditions and ride goals balance edge-to-edge responsiveness with flotation and stability.');
    return {
      key: key,
      label: WIDTH_OPTION_LABELS[key],
      waist: waist,
      standardWaist: standardWaist,
      adjustment: adjustment,
      referenceBoot: null,
      text: text,
      reason: goalReason + (spec ? '' : ' A Kindred builder will confirm the final measurement.')
    };
  }

  function skiWidthOptions(shape, state, stockLength) {
    var spec = shape && SKI_WIDTH_SPECS[shape.name];
    var standardWaist = shape ? stockWaistForShape(shape.name, stockLength, rideGoalProfile(shape, state)) : null;
    var suggested = skiWidthRecommendation(shape, state, stockLength);
    var options = WIDTH_OPTION_ORDER.map(function (key) {
      var adjustment = spec && spec.adjustments ? spec.adjustments[key] : SKI_WIDTH_ADJUSTMENTS[key];
      var waist = standardWaist === null ? null : standardWaist + adjustment;
      return {
        key: key,
        label: WIDTH_OPTION_LABELS[key],
        waist: waist,
        standardWaist: standardWaist,
        adjustment: adjustment,
        text: waist === null
          ? (key === 'standard' ? 'Standard · stock waist dimensions' : WIDTH_OPTION_LABELS[key] + ' ' + signedMillimetres(adjustment) + ' from stock standard')
          : WIDTH_OPTION_LABELS[key] + (key === 'standard' ? '' : ' ' + signedMillimetres(adjustment)) + ' · ' + waist + ' mm waist',
        detail: key === 'extra_narrow'
          ? 'Fastest edge-to-edge response and lowest swing weight; provides the least flotation and soft-snow stability.'
          : key === 'narrow'
            ? 'Quick, precise edge changes on firm snow, with less flotation than the stock waist.'
            : key === 'standard'
              ? 'Balanced edge-to-edge response, flotation and stability for the selected ski.'
              : key === 'wide'
                ? 'Adds flotation and soft-snow stability, with slower and more deliberate edge changes.'
                : 'Maximizes flotation and platform stability in deep snow; requires the most effort edge to edge.',
        isSuggested: suggested.key === key
      };
    });
    options.push({
      key: 'custom',
      label: 'Custom width',
      waist: null,
      standardWaist: standardWaist,
      adjustment: null,
      text: standardWaist === null ? 'Custom width · builder-defined ski waist' : 'Custom width · ' + standardWaist + ' mm stock standard',
      detail: 'Tune the balance of flotation, stability and edge-to-edge responsiveness with a Kindred builder.',
      isSuggested: false
    });
    return options;
  }

  function stockWidthOptions(shape, state, stockLength) {
    return state.product_type === 'skis'
      ? skiWidthOptions(shape, state, stockLength)
      : boardWidthOptions(shape, state, stockLength);
  }

  function calculatedTargetLength(state) {
    var centre;
    if (state.product_type === 'skis') {
      var skiAbilityAdjustment = { beginner: -10, novice: -7, intermediate: -5, advanced: 0, expert: 2 };
      centre = state.heightCm + (skiAbilityAdjustment[state.ability] || 0);
      if (state.snow === 'deep' || longTurnPreference(state.turn_style)) centre += 3;
      if (quickTurnPreference(state.turn_style) || playfulRidePreference(state.ride_feel)) centre -= 3;
      return clamp(Math.round(centre / 2) * 2, 150, 200);
    }

    if (state.collection === 'youth_snowboard') {
      centre = state.heightCm - 16 + ((state.weightKg - 35) * 0.25);
      var youthAbilityAdjustment = { beginner: -3, novice: -2, intermediate: 0, advanced: 1, expert: 2 };
      centre += youthAbilityAdjustment[state.ability] || 0;
      if (state.snow === 'deep' || state.priorities.indexOf('float') !== -1) centre += 2;
      if (quickTurnPreference(state.turn_style) || playfulRidePreference(state.ride_feel)) centre -= 2;
      return clamp(Math.round(centre / 2) * 2, 100, 145);
    }

    centre = (state.heightCm * 0.47) + (state.weightKg * 0.92);
    var boardAbilityAdjustment = { beginner: -3, novice: -2, intermediate: -1, advanced: 0, expert: 2 };
    centre += boardAbilityAdjustment[state.ability] || 0;
    if (state.snow === 'deep' || longTurnPreference(state.turn_style) || state.priorities.indexOf('stability') !== -1) centre += 2;
    if (quickTurnPreference(state.turn_style) || playfulRidePreference(state.ride_feel) || state.priorities.indexOf('maneuverability') !== -1) centre -= 2;
    if (state.product_type === 'splitboard') centre += 1;
    return clamp(Math.round(centre / 2) * 2, 138, 180);
  }

  function targetLength(state) {
    if (state.expert_specs && hasValue(state.exact_length)) return number(state.exact_length, calculatedTargetLength(state));
    return calculatedTargetLength(state);
  }

  function lengthRange(state) {
    var centre = targetLength(state);
    if (state.expert_specs && hasValue(state.exact_length)) return conciseNumber(centre) + ' cm target';
    return conciseNumber(centre - 3) + '–' + conciseNumber(centre + 3) + ' cm target';
  }

  function stockLengthTolerance(state) {
    if (state.product_type === 'skis' || state.collection === 'youth_snowboard') return 5;
    return 4;
  }

  function closestStockLength(shape, state) {
    var target = targetLength(state);
    var lengths = Array.isArray(shape.lengths) ? shape.lengths.slice() : [];
    var sizeUp = state.snow === 'deep' || longTurnPreference(state.turn_style) || state.priorities.indexOf('float') !== -1 || state.priorities.indexOf('stability') !== -1;
    var profile = rideGoalProfile(shape, state);
    var sizeFits = profile && profile.size_fits && typeof profile.size_fits === 'object' ? profile.size_fits : null;
    if (sizeFits) {
      var bestFit = lengths.reduce(function (best, length) {
        var score = combinedSizeFitScore(state, sizeFits[String(length)]);
        if (!best || score > best.score) return { length: length, score: score };
        if (score < best.score) return best;
        return { length: sizeUp ? Math.max(best.length, length) : Math.min(best.length, length), score: score };
      }, null);
      var fitDifference = bestFit ? Math.abs(bestFit.length - target) : Infinity;
      return {
        target: target,
        length: bestFit ? bestFit.length : null,
        difference: fitDifference,
        tolerance: stockLengthTolerance(state),
        close: Boolean(bestFit && bestFit.score >= 50),
        fitScore: bestFit ? bestFit.score : 0,
        available: lengths
      };
    }
    var closest = lengths.reduce(function (best, length) {
      if (best === null) return length;
      var difference = Math.abs(length - target);
      var bestDifference = Math.abs(best - target);
      if (difference < bestDifference) return length;
      if (difference > bestDifference) return best;
      return sizeUp ? Math.max(best, length) : Math.min(best, length);
    }, null);
    var difference = closest === null ? Infinity : Math.abs(closest - target);
    return {
      target: target,
      length: closest,
      difference: difference,
      tolerance: stockLengthTolerance(state),
      close: closest !== null && difference <= stockLengthTolerance(state),
      fitScore: closest === null ? 0 : Math.max(0, Math.round(100 - ((difference / Math.max(1, stockLengthTolerance(state) * 2)) * 100))),
      available: lengths
    };
  }

  var FLEX_PATTERN_ORDER = ['soft', 'standard', 'stiff'];
  var CUSTOM_FLEX_PATTERN_ORDER = ['extra_soft', 'soft', 'standard', 'stiff', 'extra_stiff'];
  var FLEX_PATTERN_DETAILS = {
    extra_soft: { offset: -2, detail: 'Significantly easier to bend than the standard flex built for the rider’s physical specifications.' },
    soft: { offset: -1, detail: 'Easier to bend, more forgiving and calmer at lower speeds.' },
    standard: { offset: 0, detail: 'The model’s balanced workshop flex for its rider range.' },
    stiff: { offset: 1, detail: 'More support under load, stronger rebound and greater composure at speed.' },
    extra_stiff: { offset: 2, detail: 'Significantly more supportive than the standard flex built for the rider’s physical specifications.' }
  };

  function fallbackWeightTarget(shape, state, length) {
    var selectedLength = number(length, NaN);
    if (!Number.isFinite(selectedLength)) return state.weightKg;
    if (state.product_type === 'skis') return Math.round(78 + ((selectedLength - 174) * 0.75));
    if (shape.name === 'Kidred' || shape.name === 'Elkhorn') return Math.round(35 + ((selectedLength - 131) * 0.65));
    var splitAdjustment = state.product_type === 'splitboard' ? 1 : 0;
    var targetHeight = Math.round((selectedLength + 52.06 - splitAdjustment) / 1.16);
    return Math.round(0.75 * (targetHeight - 74));
  }

  function flexWeightBand(shape, state, length) {
    var profile = rideGoalProfile(shape, state);
    var configuredTarget = profile && profile.size_fits && profile.size_fits[String(length)];
    var target = configuredTarget ? number(configuredTarget.weight_kg, NaN) : NaN;
    if (!Number.isFinite(target)) target = fallbackWeightTarget(shape, state, length);
    var youth = shape.name === 'Kidred' || shape.name === 'Elkhorn' || state.collection === 'youth_snowboard';
    var halfRange = youth ? 6 : (state.product_type === 'skis' ? 12 : 11);
    var configuredMinimum = configuredTarget ? number(configuredTarget.weight_min_kg, NaN) : NaN;
    var configuredMaximum = configuredTarget ? number(configuredTarget.weight_max_kg, NaN) : NaN;
    var hasConfiguredRange = Number.isFinite(configuredMinimum) && Number.isFinite(configuredMaximum) && configuredMinimum < configuredMaximum;
    return {
      target: Math.round(target),
      minimum: hasConfiguredRange ? configuredMinimum : Math.max(15, Math.round(target - halfRange)),
      maximum: hasConfiguredRange ? configuredMaximum : Math.round(target + halfRange),
      source: hasConfiguredRange ? 'selected_size_range' : 'calculated_size_range'
    };
  }

  function displayWeightKg(value, state) {
    return state.unit === 'imperial'
      ? conciseNumber(value / 0.45359237) + ' lb'
      : conciseNumber(value) + ' kg';
  }

  function flexRideGoalSignal(state) {
    var score = 0;
    if (playfulRidePreference(state.ride_feel)) score -= 1;
    if (powerfulRidePreference(state.ride_feel)) score += 1;
    if (state.responsiveness === 'low') score -= 0.5;
    if (state.responsiveness === 'high') score += 0.5;
    if (quickTurnPreference(state.turn_style)) score -= 0.25;
    if (longTurnPreference(state.turn_style)) score += 0.25;
    state.priorities.forEach(function (priority) {
      if (priority === 'maneuverability' || priority === 'freestyle') score -= 0.25;
      if (priority === 'touring_efficiency') score -= 0.25;
      if (priority === 'stability' || priority === 'edge_hold') score += 0.25;
    });
    return clamp(score, -1, 1);
  }

  function flexPatternRecommendation(shape, state, length) {
    var band = flexWeightBand(shape, state, length);
    var weightScore = state.weightKg < band.minimum ? -2 : (state.weightKg > band.maximum ? 2 : 0);
    var abilityScore = { beginner: -1, novice: -0.5, intermediate: 0, advanced: 0.5, expert: 1 }[state.ability] || 0;
    var rideGoalScore = flexRideGoalSignal(state);
    var score = weightScore + abilityScore + rideGoalScore;
    var key = score <= -1.5 ? 'soft' : (score >= 1.5 ? 'stiff' : 'standard');
    var riderWeight = displayWeightKg(state.weightKg, state);
    var weightDirection = weightScore < 0 ? 'softer' : (weightScore > 0 ? 'stiffer' : 'neutral');
    var abilityDirection = abilityScore < 0 ? 'softer' : (abilityScore > 0 ? 'stiffer' : 'neutral');
    var goalDirection = rideGoalScore < -0.5 ? 'softer' : (rideGoalScore > 0.5 ? 'stiffer' : 'balanced');
    var selectedLength = Number.isFinite(number(length, NaN)) ? conciseNumber(length) : 'selected size';
    return {
      key: key,
      label: label('flex_pattern', key),
      score: score,
      intendedFlex: clamp(Math.round(shape.flex + FLEX_PATTERN_DETAILS[key].offset), 2, 10),
      targetWeight: band.target,
      weightMinimum: band.minimum,
      weightMaximum: band.maximum,
      weightSource: band.source,
      reason: label('flex_pattern', key) + ' is suggested for your ' + shape.name + ' ' + selectedLength + '.',
      factors: [
        { label: 'Rider weight', value: riderWeight + ' · ' + weightDirection + ' influence' },
        { label: 'Ability', value: label('ability', state.ability) + ' · ' + abilityDirection + ' influence' },
        { label: 'Ride goals', value: goalDirection.charAt(0).toUpperCase() + goalDirection.slice(1) + ' influence' }
      ]
    };
  }

  function flexPatternOptions(shape, suggestion) {
    return FLEX_PATTERN_ORDER.map(function (key) {
      var detail = FLEX_PATTERN_DETAILS[key];
      var intendedFlex = clamp(Math.round(shape.flex + detail.offset), 2, 10);
      return {
        key: key,
        label: label('flex_pattern', key),
        intendedFlex: intendedFlex,
        text: label('flex_pattern', key) + ' ' + intendedFlex + '/10',
        detail: detail.detail,
        isSuggested: key === suggestion.key
      };
    });
  }

  function customFlexPatternOptions() {
    var customDetails = {
      extra_soft: 'Significantly easier to bend than the standard flex built for the rider’s physical specifications.',
      soft: 'Easier to bend than the standard flex built for the rider’s physical specifications.',
      standard: 'The balanced standard flex developed for the rider’s physical specifications.',
      stiff: 'More supportive than the standard flex built for the rider’s physical specifications.',
      extra_stiff: 'Significantly more supportive than the standard flex built for the rider’s physical specifications.'
    };
    return CUSTOM_FLEX_PATTERN_ORDER.map(function (key) {
      return {
        key: key,
        label: label('flex_pattern', key),
        intendedFlex: null,
        text: label('flex_pattern', key),
        detail: customDetails[key],
        isSuggested: false
      };
    });
  }

  function flexPatternEffect(key, subject) {
    var shape = subject || 'the selected shape';
    var effects = {
      extra_soft: 'Makes ' + shape + ' significantly easier to bend and pivot, with the least support when speed and rider input increase.',
      soft: 'Makes ' + shape + ' easier to bend and initiate, with a more forgiving response and less support under heavier loads.',
      standard: 'Preserves the balanced flex progression of ' + shape + ', combining predictable turn initiation, dependable support and controlled rebound.',
      stiff: 'Adds support and rebound to ' + shape + ', improving composure at speed and under load while requiring more rider input.',
      extra_stiff: 'Gives ' + shape + ' the most support and direct response, while requiring the most physical input to bend and release.'
    };
    return effects[key] || '';
  }

  function profileRecommendation(shape, state) {
    if (state.terrain === 'park' || state.priorities.indexOf('freestyle') !== -1) return 'Twin camber with equal tip and tail rise';
    if (state.terrain === 'groomers' && (state.snow === 'firm' || state.priorities.indexOf('edge_hold') !== -1)) return 'Full camber with low tip and tail rise';
    if (state.product_type === 'splitboard') return 'Early-rise nose, camber through the touring zone and controlled tail rise';
    if (state.snow === 'deep' && playfulRidePreference(state.ride_feel)) return 'Long directional rise, camber underfoot and an easy-releasing tail';
    if (state.snow === 'deep') return 'Long early-rise nose with camber underfoot';
    return shape.profile;
  }

  function conceptRecommendation(state, width, profile) {
    var details = [];
    if (state.terrain === 'park' || state.priorities.indexOf('freestyle') !== -1) {
      details.push('a true-twin or near-twin outline, centred stance and minimal taper');
    } else if (state.snow === 'deep' || state.priorities.indexOf('float') !== -1) {
      details.push('more nose surface area, directional taper and a reduced tail area for easier float');
    } else {
      details.push('a directional outline balanced around your preferred terrain');
    }
    if (quickTurnPreference(state.turn_style) || state.priorities.indexOf('maneuverability') !== -1) details.push('a tighter sidecut and compact running length for quick release');
    if (longTurnPreference(state.turn_style) || state.priorities.indexOf('stability') !== -1) details.push('a calmer radius and longer effective edge for stability');
    if ((state.product_type === 'skis' || state.product_type === 'splitboard') && state.priorities.indexOf('touring_efficiency') !== -1) details.push('controlled width, reduced swing weight and a skin-friendly tail');
    if (state.priorities.indexOf('edge_hold') !== -1) details.push('retained camber and effective edge for firm-snow confidence');
    return 'Initial direction: ' + details.join('; ') + '. Width target: ' + width + '. Profile: ' + profile + '.';
  }

  function shapeReasons(shape, state) {
    var reasons = [];
    if (shapeMatchesTerrain(shape, state.terrain)) reasons.push(shape.name + ' is a proven reference for ' + label('terrain', state.terrain).toLowerCase() + '.');
    if (shape.snow.indexOf(state.snow) !== -1) reasons.push('Its platform aligns well with ' + label('snow', state.snow).toLowerCase() + ' snow conditions.');
    reasons.push('Its geometry can be tuned toward a ' + label('ride_feel', state.ride_feel).toLowerCase() + ' ride and ' + label('turn_style', state.turn_style).toLowerCase() + ' turns.');
    if (state.priorities.length) reasons.push('The build brief emphasizes ' + state.priorities.map(function (item) { return label('priorities', item).toLowerCase(); }).join(', ') + '.');
    if (state.product_type === 'splitboard') reasons.push('Touring balance and hardware compatibility still require a builder review.');
    return reasons.slice(0, 4);
  }

  function buildShapeOption(entry, state, config, rank) {
    var shape = entry.shape;
    var lengthMatch = entry.lengthMatch || closestStockLength(shape, state);
    var widthSuggestion = state.product_type === 'skis'
      ? skiWidthRecommendation(shape, state, lengthMatch.length)
      : boardWidthRecommendation(shape, state, lengthMatch.length);
    var widthOptions = stockWidthOptions(shape, state, lengthMatch.length);
    var selectedWidth = widthOptions.find(function (option) { return option.key === state.waist_width_choice; });
    var displayWidth = selectedWidth
      || widthOptions.find(function (option) { return option.isSuggested; })
      || widthOptions.find(function (option) { return option.key === 'standard'; })
      || widthOptions[0];
    var width = displayWidth ? displayWidth.text : widthSuggestion.text;
    var flexSuggestion = flexPatternRecommendation(shape, state, lengthMatch.length);
    var flexOptions = flexPatternOptions(shape, flexSuggestion);
    var selectedFlex = flexOptions.find(function (option) { return option.key === state.flex_pattern; });
    var profile = profileRecommendation(shape, state);
    var reasons = shapeReasons(shape, state);
    var summary = productSummary(shape, state);
    var basePrice = stockShapeBasePrice(shape.name, state.product_type, config);
    var startingPrice = basePrice === null ? '' : formatMoney(
      convertedAmount(basePrice, config && config.currencyRate),
      config && config.currency
    );
    var imageLibrary = state.product_type === 'splitboard' && config && config.splitboardShapeAssets
      ? config.splitboardShapeAssets
      : config && config.shapeAssets;
    return {
      rank: rank,
      name: shape.name,
      image: imageLibrary ? imageLibrary[shape.name] || '' : '',
      blueprint: config && config.shapeBlueprints ? config.shapeBlueprints[shape.name] || '' : '',
      length: lengthMatch.length === null ? 'No stock length listed' : conciseNumber(lengthMatch.length) + ' cm stock length',
      stockLength: lengthMatch.length,
      targetLength: lengthMatch.target,
      lengthDifference: lengthMatch.difference,
      lengthTolerance: lengthMatch.tolerance,
      sizeFitScore: lengthMatch.fitScore,
      rideGoalScore: entry.rideGoalScore,
      combinedScore: Math.round(entry.score * 10) / 10,
      isLengthClose: lengthMatch.close,
      availableLengths: lengthMatch.available,
      width: state.expert_specs && state.exact_waist ? String(state.exact_waist) + ' mm waist target' : width,
      widthProfile: selectedWidth ? selectedWidth.key : '',
      suggestedWidthProfile: widthSuggestion.key,
      widthSuggestionReason: widthSuggestion.reason,
      widthOptions: widthOptions,
      waist: displayWidth ? displayWidth.waist : widthSuggestion.waist,
      standardWaist: displayWidth ? displayWidth.standardWaist : widthSuggestion.standardWaist,
      referenceBoot: widthSuggestion.referenceBoot,
      flex: selectedFlex ? selectedFlex.text : '',
      flexPattern: selectedFlex ? selectedFlex.key : '',
      suggestedFlexPattern: flexSuggestion.key,
      suggestedFlex: flexSuggestion.label + ' ' + flexSuggestion.intendedFlex + '/10',
      suggestedFlexValue: flexSuggestion.intendedFlex,
      flexSuggestionReason: flexSuggestion.reason,
      flexFactors: flexSuggestion.factors,
      flexOptions: flexOptions,
      flexWeightBand: {
        target: flexSuggestion.targetWeight,
        minimum: flexSuggestion.weightMinimum,
        maximum: flexSuggestion.weightMaximum,
        source: flexSuggestion.weightSource
      },
      profile: profile,
      summary: summary,
      basePrice: basePrice,
      startingPrice: startingPrice,
      reasons: reasons,
      concept: conceptRecommendation(state, width, profile),
      intro: shape.name + ' gives us a proven reference. We can retain what works and tune the dimensions, flex and profile around your brief.'
    };
  }

  function recommendComposite(input) {
    var state = normalizeState(input);
    var priorities = state.priorities;
    var edgeScore = priorities.indexOf('edge_hold') !== -1 ? 3 : (state.snow === 'firm' ? 2 : (state.terrain === 'groomers' ? 1 : 0));
    var rideScore = state.ride_feel === 'powerful' ? 3 : (state.ride_feel === 'supportive' ? 2 : (state.ride_feel === 'balanced' ? 1 : (state.ride_feel === 'lively' ? 0.5 : 0)));
    var explicitResponse = String(state.responsiveness || '').toLowerCase();
    var responseScore = explicitResponse === 'high' || explicitResponse === 'quick' ? 3 : (explicitResponse === 'responsive' || explicitResponse === 'short' ? 2 : (explicitResponse === 'medium' || explicitResponse === 'mixed' ? 1 : (explicitResponse === 'relaxed' || explicitResponse === 'sweeping' ? 0.5 : (explicitResponse === 'low' || explicitResponse === 'long' ? 0 : (state.turn_style === 'quick' ? 3 : (state.turn_style === 'short' ? 2 : (state.turn_style === 'mixed' ? 1 : (state.turn_style === 'sweeping' ? 0.5 : 0))))))));
    if (priorities.indexOf('maneuverability') !== -1) responseScore += 1;
    if ((state.product_type === 'skis' || state.product_type === 'splitboard') && priorities.indexOf('touring_efficiency') !== -1) responseScore += 1;
    responseScore = clamp(responseScore, 0, 4);
    var weightScore = state.weightKg > 90 ? 2 : (state.weightKg >= 65 ? 1 : 0);
    var total = edgeScore + rideScore + responseScore + weightScore;
    var desiredKey = total >= 8 && edgeScore >= 2 && rideScore >= 1 ? 'race' : (total >= 4 ? 'carbon' : 'fiberglass');
    var key = compatibleConstructionKey(desiredKey, constructionOptionsForState(state));
    var responseLabel = explicitResponse ? label('responsiveness', explicitResponse) : (responseScore >= 3 ? 'High / quick' : (responseScore >= 1 ? 'Balanced' : 'Calm / composed'));
    var edgeLabel = edgeScore >= 3 ? 'High priority' : (edgeScore >= 2 ? 'Firm-snow focus' : (edgeScore === 1 ? 'Moderate' : 'Not dominant'));
    var weightLabel = conciseNumber(state.weightKg) + ' kg · ' + (weightScore === 2 ? 'higher load' : (weightScore === 1 ? 'moderate load' : 'lighter load'));
    var reason = key === 'race'
      ? 'Race construction best supports the requested edge authority, powerful ride quality and fast response under the rider load.'
      : key === 'titanal_carbon'
        ? 'Titanal reinforced carbon best matches the requested quick response while adding damping and authoritative edge support for this shape.'
        : key === 'carbon'
        ? 'Carbon fiber best matches the requested responsiveness while reducing weight and retaining useful support.'
        : key === 'titanal_fiberglass'
          ? 'Titanal reinforced fiberglass best supports the requested edge confidence with a damp, composed and predictable response for this shape.'
          : key === 'triaxial_fiberglass'
            ? 'Triaxial fiberglass best matches the requested ride quality with smooth response and dependable torsional support.'
            : 'Biaxial fiberglass best matches the requested ride quality with a smooth, forgiving and predictable response.';
    return {
      key: key,
      label: label('construction', key),
      score: total,
      reason: reason,
      factors: [
        { label: 'Edge hold', value: edgeLabel },
        { label: 'Ride quality', value: label('ride_feel', state.ride_feel) },
        { label: 'Responsiveness', value: responseLabel },
        { label: 'Rider weight', value: weightLabel }
      ]
    };
  }

  function recommend(input, config) {
    var state = normalizeState(input);
    var questionWeights = questionWeightsForState(state);
    var pool = shapePool(state);
    var ranked = pool.map(function (shape, index) {
      var rideGoalScore = scoreShape(shape, state);
      var lengthMatch = closestStockLength(shape, state);
      return {
        shape: shape,
        lengthMatch: lengthMatch,
        rideGoalScore: rideGoalScore,
        score: rideGoalScore + ((lengthMatch.fitScore / 100) * questionWeights.sizing_fit) - (index * 0.05)
      };
    }).sort(function (a, b) { return b.score - a.score; });
    var evaluated = ranked.map(function (entry, index) { return buildShapeOption(entry, state, config, index + 1); });
    var specsOnly = state.expert_specs;
    var stockOptions = (specsOnly || state.collection === 'custom_shape' ? [] : evaluated.filter(function (option) { return option.isLengthClose; }).slice(0, 3)).map(function (option, index) {
      option.rank = index + 1;
      return option;
    });
    var selectedStock = stockOptions.find(function (option) { return option.name === state.shape_choice; });
    var requestedCustom = specsOnly || state.shape_choice === 'full_custom' || state.collection === 'custom_shape';
    var autoCustom = !specsOnly && state.collection !== 'custom_shape' && !stockOptions.length;
    var isFullCustom = requestedCustom || autoCustom;
    var chosen = selectedStock || stockOptions[0] || evaluated[0];
    var customConcept = specsOnly
      ? 'Customer-provided build specifications will be reviewed with a Kindred designer before the final geometry and outline are confirmed.'
      : 'Designer collaboration starting brief: ' + chosen.concept.replace(/^Initial direction:\s*/, '');
    var customReasons = specsOnly ? [
      'Your submitted build specifications make Custom Shape the only available starting point.',
      'A Kindred designer will review the supplied targets before confirming the final specification and outline.'
    ] : autoCustom ? [
      'No current stock length in this collection is within ' + stockLengthTolerance(state) + ' cm of the ' + conciseNumber(targetLength(state)) + ' cm rider target.',
      chosen.name + ' is the closest functional reference, but its nearest stock size is ' + chosen.length + '.',
      'A Kindred designer can develop the final length, specification and outline around the rider brief.'
    ] : [
      'You chose direct collaboration with a Kindred designer rather than a stock-shape starting point.',
      chosen.name + ' is the closest functional reference from your current answers.',
      'The specification and final outline will be determined together before the build is accepted.'
    ];
    var customWidth = state.exact_waist
      ? String(state.exact_waist) + ' mm waist target · designer to confirm'
      : 'Custom waist width · designer to confirm';
    var availableFlexOptions = isFullCustom ? customFlexPatternOptions() : chosen.flexOptions;
    var customFlexOption = isFullCustom
      ? availableFlexOptions.find(function (option) { return option.key === state.flex_pattern; })
      : null;
    return {
      shape: isFullCustom ? 'Custom Shape' : chosen.name,
      selectedShapeKey: isFullCustom ? 'full_custom' : (selectedStock ? selectedStock.name : ''),
      isFullCustom: isFullCustom,
      autoCustom: autoCustom,
      specsOnly: specsOnly,
      targetLength: targetLength(state),
      lengthTolerance: stockLengthTolerance(state),
      referenceShape: specsOnly ? '' : chosen.name,
      stockOptions: stockOptions,
      ranked: stockOptions,
      image: isFullCustom ? '' : chosen.image,
      blueprint: isFullCustom ? '' : chosen.blueprint,
      alternatives: specsOnly ? [] : stockOptions.filter(function (option) { return isFullCustom || option.name !== chosen.name; }).map(function (option) { return option.name; }),
      length: isFullCustom ? lengthRange(state) + ' · designer to confirm' : chosen.length,
      stockLength: isFullCustom ? null : chosen.stockLength,
      width: isFullCustom ? customWidth : chosen.width,
      widthProfile: isFullCustom ? 'custom' : chosen.widthProfile,
      suggestedWidthProfile: isFullCustom ? '' : chosen.suggestedWidthProfile,
      widthSuggestionReason: isFullCustom
        ? (specsOnly && state.exact_waist
          ? 'The supplied waist target will be reviewed with a Kindred designer before the shape is confirmed.'
          : 'The waist width will be developed from boot size, stance and ride goals with a Kindred designer.')
        : chosen.widthSuggestionReason,
      widthOptions: isFullCustom ? [] : chosen.widthOptions,
      flex: isFullCustom ? (customFlexOption ? customFlexOption.label : '') : chosen.flex,
      flexPattern: isFullCustom ? (customFlexOption ? customFlexOption.key : '') : chosen.flexPattern,
      suggestedFlexPattern: isFullCustom ? '' : chosen.suggestedFlexPattern,
      suggestedFlex: isFullCustom ? '' : chosen.suggestedFlex,
      suggestedFlexValue: isFullCustom ? null : chosen.suggestedFlexValue,
      flexSuggestionReason: isFullCustom ? '' : chosen.flexSuggestionReason,
      flexFactors: isFullCustom ? [] : chosen.flexFactors,
      flexOptions: availableFlexOptions,
      flexWeightBand: isFullCustom ? null : chosen.flexWeightBand,
      profile: isFullCustom ? 'Designer-developed from rider brief' : chosen.profile,
      reasons: isFullCustom ? customReasons : chosen.reasons,
      summary: specsOnly ? 'Custom Shape is the only available path when you submit your own build specifications. A Kindred designer will review the targets before confirming the build.' : (isFullCustom ? 'Work directly with a Kindred designer to develop the specification and final outline from your measurements, terrain and ride goals.' : chosen.summary),
      concept: isFullCustom ? customConcept : chosen.concept,
      intro: specsOnly
        ? 'Your submitted build specifications require Custom Shape, so no stock-shape suggestion is made.'
        : autoCustom
        ? 'No current stock length is close enough to the rider target, so a designer-developed Custom Shape is the recommended starting point.'
        : (isFullCustom ? 'Work directly with a Kindred designer to determine the specification, geometry and final shape from your profile and goals.' : chosen.intro),
      composite: recommendComposite(state)
    };
  }

  function recommendStock(input, config) {
    var state = normalizeState(input);
    var questionWeights = questionWeightsForState(state);
    var pool = shapePool(state);
    var ranked = pool.map(function (shape, index) {
      var rideGoalScore = scoreShape(shape, state);
      var lengthMatch = closestStockLength(shape, state);
      return {
        shape: shape,
        lengthMatch: lengthMatch,
        rideGoalScore: rideGoalScore,
        score: rideGoalScore + ((lengthMatch.fitScore / 100) * questionWeights.sizing_fit) - (index * 0.05)
      };
    }).sort(function (a, b) { return b.score - a.score; });
    var evaluated = ranked.map(function (entry, index) {
      return buildShapeOption(entry, state, config, index + 1);
    });
    var closeMatches = evaluated.filter(function (option) { return option.isLengthClose; });
    var closestStockMatches = evaluated.filter(function (option) { return !option.isLengthClose; });
    var stockOptions = closeMatches.concat(closestStockMatches).slice(0, 3).map(function (option, index) {
      option.rank = index + 1;
      option.isClosestStockOption = !option.isLengthClose;
      return option;
    });
    var selectedStock = stockOptions.find(function (option) { return option.name === state.shape_choice; });
    var chosen = selectedStock || stockOptions[0] || null;

    if (!chosen) {
      return {
        shape: '',
        selectedShapeKey: '',
        isFullCustom: false,
        stockOptions: [],
        ranked: [],
        alternatives: [],
        targetLength: targetLength(state),
        lengthTolerance: stockLengthTolerance(state)
      };
    }

    return {
      shape: chosen.name,
      selectedShapeKey: selectedStock ? selectedStock.name : chosen.name,
      isFullCustom: false,
      autoCustom: false,
      specsOnly: false,
      targetLength: targetLength(state),
      lengthTolerance: stockLengthTolerance(state),
      referenceShape: chosen.name,
      stockOptions: stockOptions,
      ranked: stockOptions,
      image: chosen.image,
      blueprint: chosen.blueprint,
      alternatives: stockOptions.filter(function (option) { return option.name !== chosen.name; }).map(function (option) { return option.name; }),
      length: chosen.length,
      stockLength: chosen.stockLength,
      width: chosen.width,
      widthProfile: chosen.widthProfile,
      suggestedWidthProfile: chosen.suggestedWidthProfile,
      widthSuggestionReason: chosen.widthSuggestionReason,
      widthOptions: chosen.widthOptions.filter(function (option) { return option.key !== 'custom'; }),
      flex: chosen.flex,
      flexPattern: chosen.flexPattern,
      suggestedFlexPattern: chosen.suggestedFlexPattern,
      suggestedFlex: chosen.suggestedFlex,
      suggestedFlexValue: chosen.suggestedFlexValue,
      flexSuggestionReason: chosen.flexSuggestionReason,
      flexFactors: chosen.flexFactors,
      flexOptions: chosen.flexOptions,
      flexWeightBand: chosen.flexWeightBand,
      profile: chosen.profile,
      reasons: chosen.reasons,
      summary: chosen.summary,
      concept: chosen.concept,
      intro: chosen.intro,
      composite: recommendComposite(state)
    };
  }

  function calculatePrice(input, configOrPrices) {
    var state = normalizeState(input);
    var prices = Object.assign({}, DEFAULT_PRICES, configOrPrices && configOrPrices.prices ? configOrPrices.prices : configOrPrices || {});
    var currency = currencyCode(configOrPrices && configOrPrices.currency, 'CAD');
    var rate = currencyRate(configOrPrices && configOrPrices.currencyRate, 1);
    var priceFor = function (key) { return convertedAmount(number(prices[key], DEFAULT_PRICES[key]), rate); };
    var suggestedShape = '';
    var shapeBasePrice = null;
    if (configOrPrices && configOrPrices.shapePrices && state.custom_shape !== 'custom') {
      var recommendation = recommend(state, configOrPrices);
      if (!recommendation.isFullCustom) {
        suggestedShape = recommendation.shape;
        shapeBasePrice = stockShapeBasePrice(suggestedShape, state.product_type, configOrPrices);
      }
    }
    var customBaseProducts = {
      snowboard: { key: 'custom_snowboard', label: 'Custom Snowboard' },
      splitboard: { key: 'custom_splitboard', label: 'Custom Splitboard' },
      skis: { key: 'custom_ski', label: 'Custom Ski' }
    };
    var customBaseProduct = state.custom_shape === 'custom' ? customBaseProducts[state.product_type] : null;
    var baseLabel = customBaseProduct
      ? customBaseProduct.label
      : (suggestedShape
        ? suggestedShape + ' ' + label('product_type', state.product_type).toLowerCase()
        : label('collection', state.collection));
    var baseKey = customBaseProduct ? customBaseProduct.key : state.product_type;
    var baseAmount = customBaseProduct
      ? priceFor(customBaseProduct.key)
      : (shapeBasePrice === null ? priceFor(state.product_type) : convertedAmount(shapeBasePrice, rate));
    var items = [{ key: baseKey, label: baseLabel + ' base build', amount: baseAmount }];

    if (state.construction === 'carbon') items.push({ key: 'carbon', label: label('construction', state.construction) + ' construction', amount: priceFor('carbon') });
    if (state.construction === 'titanal_fiberglass') items.push({ key: 'titanal_fiberglass', label: label('construction', state.construction) + ' construction', amount: priceFor('titanal_fiberglass') });
    if (state.construction === 'titanal_carbon') items.push({ key: 'titanal_carbon', label: label('construction', state.construction) + ' construction', amount: priceFor('titanal_carbon') });
    if (state.construction === 'race') items.push({ key: 'race', label: 'Race construction', amount: priceFor('race') });
    if (state.artwork_level !== 'stock_graphic') items.push({ key: state.artwork_level, label: label('artwork_level', state.artwork_level), amount: priceFor(state.artwork_level) });
    if (state.artwork_level === 'stock_graphic' && ['black_on_red', 'red_on_black'].indexOf(state.base_colour) === -1) items.push({ key: 'base_colour_surcharge', label: 'Base colour surcharge', amount: priceFor('base_colour_surcharge') });

    return {
      currency: currency,
      shape: suggestedShape,
      items: items,
      total: items.reduce(function (sum, item) { return sum + item.amount; }, 0)
    };
  }

  function buildSummary(input, recommendation, estimate, config, contact) {
    var state = normalizeState(input);
    var rec = recommendation || recommend(state, config || {});
    var price = estimate || calculatePrice(state, config || {});
    var person = contact || {};
    var heightDisplay = formatHeight(input, state);
    var weightDisplay = formatWeight(input, state);
    var hidden = new Set(state.hidden_questions);
    var composite = rec.composite || recommendComposite(state);
    var selectedShapeLabel = rec.selectedShapeKey ? rec.shape : 'Not selected — suggested first match: ' + rec.shape;
    var lines = [
      'KINDRED CUSTOM BUILD CONFIGURATION',
      '',
      'PRODUCT & RIDER',
      'Product: ' + label('product_type', state.product_type),
      'Collection: ' + label('collection', state.collection),
      'Height: ' + heightDisplay,
      'Riding weight: ' + weightDisplay,
      'Boot size: ' + formatBootSize(state),
      'Ability: ' + label('ability', state.ability),
      'Location: ' + label('location', state.location),
      '',
      'RIDE GOALS',
      'Terrain: ' + label('terrain', state.terrain),
      'Snow: ' + label('snow', state.snow),
      'Turns: ' + label('turn_style', state.turn_style),
      'Responsiveness: ' + (state.responsiveness ? label('responsiveness', state.responsiveness) : 'Inferred from turn preference'),
      'Feel: ' + label('ride_feel', state.ride_feel),
      'Priorities: ' + state.priorities.map(function (item) { return label('priorities', item); }).join(', '),
      '',
      'SHAPE & STARTING GEOMETRY',
      'Selected shape starting point: ' + selectedShapeLabel,
      'Functional Kindred reference: ' + (rec.referenceShape || rec.shape),
      'Other stock starting points: ' + rec.alternatives.join(', '),
      'Length: ' + rec.length,
      'Width: ' + rec.width,
      'Profile: ' + rec.profile,
      'Shape direction: ' + rec.concept,
      '',
      'CONSTRUCTION',
      ...(rec.isFullCustom ? [] : ['Suggested flex: ' + rec.suggestedFlex]),
      'Chosen flex: ' + (rec.flex || 'To be selected'),
      'Composite suggestion: ' + composite.label,
      'Construction: ' + label('construction', state.construction),
      '',
      'ARTWORK',
      'Artwork: ' + label('artwork_level', state.artwork_level),
      'Graphic direction: ' + (state.graphic_title || humanize(state.graphic_option) || 'To discuss'),
      'Base colour: ' + label('base_colour', state.base_colour)
    ];

    if (state.custom_shape === 'custom') {
      var shapeLineIndex = lines.findIndex(function (line) { return line.indexOf('Functional Kindred reference:') === 0; });
      var shapeProcess = state.custom_spec_mode === 'specs'
        ? 'Customer-provided build targets with a Kindred designer review before the specification and final outline are confirmed'
        : 'Designer consultation to determine the specification and final outline from the rider profile and goals';
      lines.splice(shapeLineIndex + 1, 0, 'Shape process: ' + shapeProcess);
      if (state.expert_specs) {
        lines = lines.filter(function (line) {
          return line.indexOf('Functional Kindred reference:') !== 0 && line.indexOf('Other stock starting points:') !== 0;
        });
      }
    }

    var hiddenPrefixes = {
      product_type: ['Product:'], collection: ['Collection:'], height: ['Height:'], weight: ['Riding weight:'], boot_size: ['Boot size:'], ability: ['Ability:'], location: ['Location:'],
      terrain: ['Terrain:'], snow: ['Snow:'], turn_style: ['Turns:'], responsiveness: ['Responsiveness:'], ride_feel: ['Feel:'], priorities: ['Priorities:'],
      flex_pattern: ['Suggested flex:', 'Chosen flex:'], construction: ['Composite suggestion:', 'Construction:'], artwork_level: ['Artwork:'], graphic_option: ['Graphic direction:'], base_colour: ['Base colour:'], custom_shape: ['Shape process:'], stance_setup: ['Stance:'], ski_touring_notch: ['Touring notch:']
    };
    Object.keys(hiddenPrefixes).forEach(function (key) {
      if (!hidden.has(key)) return;
      lines = lines.filter(function (line) { return !hiddenPrefixes[key].some(function (prefix) { return line.indexOf(prefix) === 0; }); });
    });

    var locationLineIndex = lines.findIndex(function (line) { return line.indexOf('Location:') === 0; });
    var abilityLineIndex = lines.findIndex(function (line) { return line.indexOf('Ability:') === 0; });
    var riderDetailIndex = locationLineIndex >= 0 ? locationLineIndex + 1 : (abilityLineIndex >= 0 ? abilityLineIndex + 1 : 8);
    if (state.product_type === 'skis' && hasValue(state.ski_bsl)) lines.splice(riderDetailIndex++, 0, 'Boot sole length (BSL): ' + state.ski_bsl + ' mm');
    if (state.product_type === 'skis' && state.ski_binding_style) lines.splice(riderDetailIndex++, 0, 'Binding style: ' + label('ski_binding_style', state.ski_binding_style));
    if (state.product_type === 'skis' && !hidden.has('ski_touring_notch')) lines.splice(riderDetailIndex++, 0, 'Touring notch: ' + label('ski_touring_notch', state.ski_touring_notch));
    var stanceSummary = formatStance(state);
    if (state.product_type !== 'skis' && stanceSummary && !hidden.has('stance_setup')) lines.splice(riderDetailIndex, 0, 'Stance: ' + stanceSummary);
    if (state.product_type === 'splitboard' && !hidden.has('touring_focus')) {
      var priorityLineIndex = lines.findIndex(function (line) { return line.indexOf('Priorities:') === 0; });
      var feelLineIndex = lines.findIndex(function (line) { return line.indexOf('Feel:') === 0; });
      var touringLineIndex = priorityLineIndex >= 0 ? priorityLineIndex + 1 : (feelLineIndex >= 0 ? feelLineIndex + 1 : lines.length);
      lines.splice(touringLineIndex, 0, 'Touring emphasis: ' + label('touring_focus', state.touring_focus));
    }
    if (state.artwork_level !== 'stock_graphic') lines = lines.filter(function (line) { return line.indexOf('Graphic direction:') !== 0 && line.indexOf('Base colour:') !== 0; });

    if (state.expert_specs) {
      lines.push('', 'EXPERT SPECIFICATIONS');
      if (state.exact_length) lines.push('Exact length target: ' + state.exact_length + ' cm');
      if (state.exact_waist) lines.push('Waist target: ' + state.exact_waist + ' mm');
      if (state.exact_radius) lines.push('Sidecut radius target: ' + state.exact_radius + ' m');
      if (state.exact_taper) lines.push('Taper target: ' + state.exact_taper + ' mm');
      if (state.exact_tip_length) lines.push('Tip length target: ' + state.exact_tip_length + ' mm');
      if (state.exact_tail_length) lines.push('Tail length target: ' + state.exact_tail_length + ' mm');
      if (state.exact_setback) lines.push('Setback: ' + state.exact_setback + ' mm');
      if (state.camber_profile) lines.push('Camber profile: ' + label('camber_profile', state.camber_profile));
      if (state.expert_notes) lines.push('Additional information: ' + state.expert_notes);
    }
    if (state.artwork_level !== 'stock_graphic' && (state.art_notes || state.art_link || state.art_inspiration_link || state.art_reference_link)) {
      lines.push('', 'ARTWORK NOTES');
      if (state.art_notes) lines.push('Requested direction: ' + state.art_notes);
      if (state.art_link) lines.push('Customer artwork file: ' + state.art_link);
      if (state.art_inspiration_link) lines.push('Past work inspiration: ' + state.art_inspiration_link);
      if (state.art_reference_link) lines.push('Reference image: ' + state.art_reference_link);
    }
    lines.push('', 'ESTIMATED STARTING PRICE');
    price.items.forEach(function (item) { lines.push(item.label + ': ' + formatMoney(item.amount, price.currency)); });
    lines.push('Estimated total: ' + formatMoney(price.total, price.currency) + ' plus shipping and applicable taxes');
    if (state.timing) lines.push('', 'Requested delivery date: ' + state.timing);
    if (state.contact_notes) lines.push('Additional notes: ' + state.contact_notes);
    if (person.name) lines.push('', 'Customer: ' + person.name);
    if (person.email) lines.push('Email: ' + person.email);
    if (person.phone) lines.push('Phone: ' + person.phone);
    if (config && config.rulesVersion) lines.push('', 'Recommendation rules: ' + config.rulesVersion);
    lines.push('', (config && config.content && config.content.disclaimer) || 'Final geometry, construction, artwork feasibility, timing and pricing must be confirmed with a Kindred builder before the build begins.');
    return lines.join('\n');
  }

  var instances = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function childrenByData(parent, key, value) {
    if (!parent) return [];
    return Array.prototype.filter.call(parent.querySelectorAll('[' + key + ']'), function (element) {
      return value === undefined || element.getAttribute(key) === value;
    });
  }

  function question(root, key) {
    return childrenByData(root, 'data-question-key', key)[0] || null;
  }

  function answer(questionElement, key) {
    if (!questionElement) return null;
    var normalized = String(key || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
    return childrenByData(questionElement, 'data-answer-key').filter(function (item) {
      return String(item.getAttribute('data-answer-key') || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '') === normalized;
    })[0] || null;
  }

  function sortDirectChildren(parent, selector) {
    if (!parent) return;
    Array.prototype.slice.call(parent.children).filter(function (item) { return item.matches(selector); }).sort(function (a, b) {
      return number(a.getAttribute('data-sort-order'), number(a.getAttribute('data-default-order'), 50)) - number(b.getAttribute('data-sort-order'), number(b.getAttribute('data-default-order'), 50));
    }).forEach(function (item) { parent.appendChild(item); });
  }

  function applyOverrides(root, config) {
    (config.questionOverrides || []).forEach(function (override) {
      var item = question(root, override.key);
      if (!item) return;
      if (String(override.label || '').trim()) {
        var labelElement = item.querySelector('[data-question-label]');
        if (labelElement) labelElement.textContent = override.label;
      }
      if (String(override.help || '').trim()) {
        var helpElement = item.querySelector('[data-question-help]');
        if (helpElement) helpElement.textContent = override.help;
      }
      item.hidden = Boolean(override.hidden);
      item.setAttribute('data-override-hidden', override.hidden ? 'true' : 'false');
      item.setAttribute('data-sort-order', number(override.order, 50));
    });

    (config.answerOverrides || []).forEach(function (override) {
      var parentQuestion = question(root, override.questionKey);
      var item = answer(parentQuestion, override.key);
      if (!item) return;
      if (String(override.label || '').trim()) {
        var title = item.querySelector('.kcb-option-title');
        if (title) title.textContent = override.label;
      }
      if (String(override.description || '').trim()) {
        var description = item.querySelector('.kcb-option-description');
        if (description) description.textContent = override.description;
      }
      item.hidden = Boolean(override.hidden);
      item.setAttribute('data-override-hidden', override.hidden ? 'true' : 'false');
      item.setAttribute('data-sort-order', number(override.order, 50));
      if (item.hidden) {
        var hiddenInput = item.querySelector('input');
        if (hiddenInput) hiddenInput.checked = false;
      }
    });

    root.querySelectorAll('[data-question-list]').forEach(function (list) { sortDirectChildren(list, '[data-question-key]'); });
    var constructionDetailsPanel = root.querySelector('[data-construction-details]');
    var flexQuestion = question(root, 'flex_pattern');
    if (constructionDetailsPanel && flexQuestion) constructionDetailsPanel.insertAdjacentElement('afterend', flexQuestion);
    root.querySelectorAll('[data-answer-list]').forEach(function (list) {
      sortDirectChildren(list, '[data-answer-key]');
    });
  }

  function readConfig(root) {
    var script = root.querySelector('[data-custom-build-config]');
    if (!script) return {};
    try { return JSON.parse(script.textContent || '{}'); }
    catch (error) {
      if (global.console) global.console.error('Kindred Custom Builder configuration could not be read.', error);
      return {};
    }
  }

  function assetUrl(config, path) {
    var source = String(path || '');
    if (!source || /^(?:[a-z]+:)?\/\//i.test(source) || source.indexOf('data:') === 0 || source.charAt(0) === '/') return source;
    var probe = config && config.assetProbe;
    if (!probe) return source;
    var filename = source.split('/').pop();
    try {
      var resolved = new URL(probe, document.baseURI);
      resolved.pathname = resolved.pathname.replace(/[^/]*$/, filename);
      resolved.search = '';
      resolved.hash = '';
      return resolved.toString();
    } catch (error) {
      return source;
    }
  }

  function readRadio(root, key, fallback) {
    var item = question(root, key);
    if (!item || item.hidden) return fallback;
    var input = item && item.querySelector('input[type="radio"]:checked');
    return input ? input.value : fallback;
  }

  function readField(root, key) {
    var field = childrenByData(root, 'data-field', key)[0];
    if (!field) return '';
    var ancestor = field.parentElement;
    while (ancestor && ancestor !== root) {
      if (ancestor.hidden && !ancestor.hasAttribute('data-step')) return field.type === 'checkbox' ? false : '';
      ancestor = ancestor.parentElement;
    }
    if (field.type === 'checkbox') return field.checked;
    return String(field.value || '').trim();
  }

  function selectedTitle(root, key) {
    var item = question(root, key);
    if (!item || item.hidden) return '';
    var input = item && item.querySelector('input:checked');
    var wrapper = input && input.closest('[data-answer-key]');
    var title = wrapper && wrapper.querySelector('.kcb-option-title');
    return title ? title.textContent.trim() : '';
  }

  function readState(root) {
    var priorityQuestion = question(root, 'priorities');
    var unit = root.getAttribute('data-units') || 'metric';
    var collection = readRadio(root, 'collection', '');
    var customProductType = readField(root, 'custom_product_type');
    var productType = collection === 'custom_shape' ? customProductType : (COLLECTION_PRODUCT_TYPES[collection] || 'snowboard');
    var goalProfile = collectionGoalProfile(goalProfileKey(collection, productType));
    var customSpecMode = readRadio(root, 'custom_spec_mode', '');
    var heightFeet = readField(root, 'height_feet');
    var heightInches = readField(root, 'height_inches');
    var imperialHeight = hasValue(heightFeet) || hasValue(heightInches)
      ? (number(heightFeet, 0) * 12) + number(heightInches, 0)
      : '';
    var stanceUnitField = root.querySelector('[data-field="stance_width_unit"]:checked') || childrenByData(root, 'data-field', 'stance_width_unit')[0];
    return {
      collection: collection,
      product_type: productType,
      custom_product_type: customProductType,
      unit: unit,
      height: unit === 'metric' ? readField(root, 'height') : imperialHeight,
      height_feet: heightFeet,
      height_inches: heightInches,
      weight: readField(root, 'weight'),
      boot_size: readField(root, 'boot_size'),
      boot_size_unit: readField(root, 'boot_size_unit') || 'mens_us',
      ability: readRadio(root, 'ability', ''),
      location: readRadio(root, 'location', ''),
      terrain: readRadio(root, 'terrain', '') || (goalProfile.hideTerrainQuestion ? goalProfile.terrainFallback : ''),
      snow: readRadio(root, 'snow', ''),
      turn_style: readRadio(root, 'turn_style', ''),
      responsiveness: readRadio(root, 'responsiveness', ''),
      ride_feel: readRadio(root, 'ride_feel', ''),
      touring_focus: readRadio(root, 'touring_focus', ''),
      priorities: !priorityQuestion || priorityQuestion.hidden ? [] : Array.prototype.map.call(priorityQuestion.querySelectorAll('input[type="checkbox"]:checked'), function (input) { return input.value; }),
      flex_pattern: readRadio(root, 'flex_pattern', ''),
      construction: readRadio(root, 'construction', ''),
      artwork_level: readRadio(root, 'artwork_level', ''),
      graphic_option: readRadio(root, 'graphic_option', ''),
      graphic_title: selectedTitle(root, 'graphic_option'),
      base_colour: readRadio(root, 'base_colour', ''),
      shape_choice: collection === 'custom_shape' ? 'full_custom' : readRadio(root, 'shape_choice', ''),
      waist_width_choice: readRadio(root, 'waist_width_choice', ''),
      custom_width_confirmation: readRadio(root, 'custom_width_confirmation', ''),
      custom_spec_mode: customSpecMode,
      expert_specs: collection === 'custom_shape' ? customSpecMode === 'specs' : Boolean(readField(root, 'expert_specs')),
      exact_length: readField(root, 'exact_length'),
      exact_waist: readField(root, 'exact_waist'),
      exact_radius: readField(root, 'exact_radius'),
      exact_taper: readField(root, 'exact_taper'),
      exact_tip_length: readField(root, 'exact_tip_length'),
      exact_tail_length: readField(root, 'exact_tail_length'),
      exact_setback: readField(root, 'exact_setback'),
      camber_profile: readField(root, 'camber_profile'),
      expert_notes: readField(root, 'expert_notes'),
      art_notes: readField(root, 'art_notes'),
      art_link: readField(root, 'art_link'),
      art_inspiration_link: readField(root, 'art_inspiration_link'),
      art_reference_link: readField(root, 'art_reference_link'),
      timing: readField(root, 'timing'),
      contact_notes: readField(root, 'contact_notes'),
      stance_width_unit: stanceUnitField ? stanceUnitField.value : 'cm',
      stance_width: readField(root, 'stance_width'),
      front_angle: readField(root, 'front_angle'),
      rear_angle: readField(root, 'rear_angle'),
      ski_bsl: readField(root, 'ski_bsl'),
      ski_binding_style: readField(root, 'ski_binding_style'),
      ski_touring_notch: readRadio(root, 'ski_touring_notch', ''),
      hidden_questions: Array.prototype.map.call(root.querySelectorAll('[data-question-key][hidden]'), function (item) { return item.getAttribute('data-question-key'); })
    };
  }

  function setText(root, selector, value) {
    root.querySelectorAll(selector).forEach(function (element) { element.textContent = value; });
  }

  function customShapeArtwork(config, productType) {
    var isSki = productType === 'skis';
    return {
      src: assetUrl(config, isSki ? 'kindred-custom-ski-shapes.webp' : 'kindred-custom-shape-topsheets.webp'),
      alt: isSki
        ? 'Three pairs of Kindred custom skis with topsheet artwork'
        : 'Three Kindred custom snowboard shapes with topsheet artwork'
    };
  }

  function renderShapeOptions(root, recommendation, inputState) {
    var container = root.querySelector('[data-shape-options]');
    if (!container) return;
    var state = normalizeState(inputState || readState(root));
    var customArtwork = customShapeArtwork(root._kcbConfig, state.product_type);
    var signature = JSON.stringify({
      autoCustom: recommendation.autoCustom,
      specsOnly: recommendation.specsOnly,
      targetLength: recommendation.targetLength,
      lengthTolerance: recommendation.lengthTolerance,
      productType: state.product_type,
      options: recommendation.stockOptions.map(function (option) {
        return [option.name, option.image, option.blueprint, option.startingPrice, option.length, option.width, option.flex, option.profile, option.summary];
      })
    });
    if (container._kcbShapeSignature !== signature) {
      container.replaceChildren();

      var customCard = document.createElement('label');
      customCard.className = 'kcb-shape-choice kcb-shape-choice--custom';
      customCard.classList.toggle('is-recommended', recommendation.autoCustom || recommendation.specsOnly);
      customCard.setAttribute('data-answer-key', 'full_custom');

      var customInput = document.createElement('input');
      customInput.type = 'radio';
      customInput.name = 'kcb-shape-choice-' + ((root._kcbConfig && root._kcbConfig.sectionId) || 'section');
      customInput.value = 'full_custom';

      var customVisual = document.createElement('span');
      customVisual.className = 'kcb-shape-choice-visual kcb-shape-choice-visual--custom';
      var customImage = document.createElement('img');
      customImage.src = customArtwork.src;
      customImage.alt = customArtwork.alt;
      customImage.loading = 'lazy';
      customVisual.appendChild(customImage);

      var customBody = document.createElement('span');
      customBody.className = 'kcb-shape-choice-body';
      var customHeading = document.createElement('span');
      customHeading.className = 'kcb-shape-choice-heading';
      var customTitle = document.createElement('strong');
      customTitle.className = 'kcb-option-title';
      customTitle.textContent = 'Custom Shape';
      var customBadge = document.createElement('small');
      customBadge.textContent = recommendation.specsOnly ? 'Required for own specs' : (recommendation.autoCustom ? 'Recommended for fit' : 'Designer collaboration');
      customHeading.appendChild(customTitle);
      customHeading.appendChild(customBadge);

      var customDescription = document.createElement('span');
      customDescription.className = 'kcb-option-description';
      customDescription.textContent = recommendation.specsOnly
        ? 'Your build specifications will be reviewed with a Kindred designer before the final geometry and outline are confirmed.'
        : recommendation.autoCustom
        ? 'No stock length in this collection is within ' + recommendation.lengthTolerance + ' cm of the ' + conciseNumber(recommendation.targetLength) + ' cm rider target. Work with a Kindred designer to determine the final specification and outline.'
        : 'Work directly with a Kindred designer to determine the specification and final outline.';
      var customAction = document.createElement('span');
      customAction.className = 'kcb-shape-choice-action';
      customAction.textContent = recommendation.autoCustom || recommendation.specsOnly ? 'Continue with Custom Shape' : 'Select Custom Shape';

      customBody.appendChild(customHeading);
      customBody.appendChild(customDescription);
      customBody.appendChild(customAction);
      customCard.appendChild(customInput);
      customCard.appendChild(customVisual);
      customCard.appendChild(customBody);

      recommendation.stockOptions.forEach(function (option) {
        var card = document.createElement('label');
        card.className = 'kcb-shape-choice';
        card.setAttribute('data-answer-key', option.name);

        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'kcb-shape-choice-' + ((root._kcbConfig && root._kcbConfig.sectionId) || 'section');
        input.value = option.name;

        var visual = document.createElement('span');
        visual.className = 'kcb-shape-choice-visual';
        if (option.image) {
          var image = document.createElement('img');
          image.src = option.image;
          image.alt = 'Kindred ' + option.name + ' shape';
          image.loading = 'lazy';
          visual.appendChild(image);
        }

        var body = document.createElement('span');
        body.className = 'kcb-shape-choice-body';
        var heading = document.createElement('span');
        heading.className = 'kcb-shape-choice-heading';
        var titleBlock = document.createElement('span');
        titleBlock.className = 'kcb-shape-choice-title-block';
        var title = document.createElement('strong');
        title.className = 'kcb-option-title';
        title.textContent = option.name;
        var price = document.createElement('small');
        price.className = 'kcb-shape-choice-price';
        price.textContent = option.startingPrice ? 'From ' + option.startingPrice : 'Price confirmed by builder';
        var rank = document.createElement('small');
        rank.textContent = option.rank === 1 ? 'Best match' : 'Match ' + option.rank;
        titleBlock.appendChild(title);
        titleBlock.appendChild(price);
        heading.appendChild(titleBlock);
        heading.appendChild(rank);

        var specs = document.createElement('span');
        specs.className = 'kcb-shape-choice-specs';
        [
          ['Length', option.length],
          ['Width', option.width],
          ['Suggested flex', option.suggestedFlex],
          ['Camber', option.profile]
        ].forEach(function (item) {
          var spec = document.createElement('small');
          spec.textContent = item[0] + ': ' + (item[1] || 'To determine');
          specs.appendChild(spec);
        });
        var description = document.createElement('span');
        description.className = 'kcb-option-description';
        description.textContent = option.summary;
        var action = document.createElement('span');
        action.className = 'kcb-shape-choice-action';
        action.textContent = 'Select ' + option.name;

        body.appendChild(heading);
        body.appendChild(specs);
        body.appendChild(description);
        body.appendChild(action);
        card.appendChild(input);
        card.appendChild(visual);
        card.appendChild(body);
        container.appendChild(card);
      });
      container.appendChild(customCard);
      container._kcbShapeSignature = signature;
    }
    container.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.checked = recommendation.selectedShapeKey === input.value;
    });
  }

  function renderWidthOptions(root, state, recommendation) {
    var stockContent = root.querySelector('[data-stock-width-content]');
    var stockSelection = root.querySelector('[data-stock-width-selection]');
    var customSelection = root.querySelector('[data-custom-width-selection]');
    var custom = recommendation.isFullCustom;
    var isSki = state.product_type === 'skis';
    setText(root, '[data-width-step-intro]', isSki
      ? 'Compare every width available for the selected ski. The suggestion is determined by snow conditions, terrain, turn style and ride goals—not foot size.'
      : 'Compare every width available for the selected stock shape. The suggested starting point balances boot clearance with the rider’s snow, terrain and handling goals.');
    var skiWidthGuide = root.querySelector('[data-ski-width-guide]');
    if (skiWidthGuide) skiWidthGuide.hidden = !isSki;
    if (root._kcbWasCustomWidth !== undefined && root._kcbWasCustomWidth !== custom && customSelection) {
      customSelection.querySelectorAll('input[type="radio"]').forEach(function (input) { input.checked = false; });
    }
    root._kcbWasCustomWidth = custom;
    if (stockContent) stockContent.hidden = custom;
    if (stockSelection) stockSelection.hidden = custom;
    if (customSelection) customSelection.hidden = !custom;

    if (custom) {
      var customImage = customSelection && customSelection.querySelector('[data-custom-shape-confirmation-image]');
      if (customImage) {
        var customArtwork = customShapeArtwork(root._kcbConfig, state.product_type);
        customImage.src = customArtwork.src;
        customImage.alt = customArtwork.alt;
      }
      var customMessage = state.expert_specs && state.exact_waist
        ? 'Your ' + state.exact_waist + ' mm waist target will be reviewed with a Kindred designer before the final shape is confirmed.'
        : (state.expert_specs
          ? 'Your supplied build specifications will be reviewed with a Kindred designer before the final waist width and shape are confirmed.'
          : (isSki
            ? 'The waist width will be determined with a Kindred designer from the rider’s snow conditions, terrain and ride goals.'
            : 'The waist width will be determined with a Kindred designer from the rider’s boot size, stance and ride goals.'));
      setText(root, '[data-custom-width-message]', customMessage + ' Select this card to confirm and continue.');
      return;
    }

    var options = recommendation.widthOptions || [];
    var suggested = options.find(function (option) { return option.key === recommendation.suggestedWidthProfile; })
      || options.find(function (option) { return option.isSuggested; })
      || options[0];
    setText(root, '[data-width-shape-name]', recommendation.shape);
    setText(root, '[data-width-stock-length]', recommendation.stockLength ? conciseNumber(recommendation.stockLength) + ' cm stock length' : 'selected stock length');
    setText(root, '[data-width-suggestion-title]', suggested
      ? suggested.label + (suggested.waist ? ' · ' + suggested.waist + ' mm waist' : '')
      : 'Builder review');
    setText(root, '[data-width-suggestion-reason]', recommendation.widthSuggestionReason || 'A Kindred builder will confirm the final waist width.');

    var container = root.querySelector('[data-width-options]');
    if (!container) return;
    var signature = JSON.stringify({
      shape: recommendation.shape,
      stockLength: recommendation.stockLength,
      options: options.map(function (option) {
        return [option.key, option.label, option.text, option.detail, option.isSuggested];
      })
    });
    if (container._kcbWidthSignature !== signature) {
      container.replaceChildren();
      options.forEach(function (option) {
        var card = document.createElement('label');
        card.className = 'kcb-width-choice';
        card.classList.toggle('is-recommended', option.isSuggested);
        card.setAttribute('data-answer-key', option.key);

        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'kcb-waist-width-' + ((root._kcbConfig && root._kcbConfig.sectionId) || 'section');
        input.value = option.key;

        var heading = document.createElement('span');
        heading.className = 'kcb-width-choice__heading';
        var title = document.createElement('strong');
        title.className = 'kcb-option-title';
        title.textContent = option.label;
        heading.appendChild(title);
        if (option.isSuggested) {
          var badge = document.createElement('small');
          badge.textContent = 'Suggested';
          heading.appendChild(badge);
        }

        var measurement = document.createElement('strong');
        measurement.className = 'kcb-width-choice__measurement';
        measurement.textContent = option.waist ? option.waist + ' mm waist' : option.text;
        var detail = document.createElement('small');
        detail.className = 'kcb-option-description';
        detail.textContent = option.detail;

        card.appendChild(input);
        card.appendChild(heading);
        card.appendChild(measurement);
        card.appendChild(detail);
        container.appendChild(card);
      });
      container._kcbWidthSignature = signature;
    }
    var selectedKey = state.waist_width_choice || '';
    container.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.checked = input.value === selectedKey;
    });
  }

  function renderComposite(root, composite) {
    var constructionQuestion = question(root, 'construction');
    if (constructionQuestion) {
      constructionQuestion.querySelectorAll('[data-answer-key]').forEach(function (card) {
        var recommended = card.getAttribute('data-answer-key') === composite.key;
        card.classList.toggle('is-recommended', recommended);
        var badge = card.querySelector('.kcb-recommended-badge');
        if (badge) badge.hidden = !recommended;
      });
    }
  }

  function renderFlexOptions(root, recommendation) {
    var flexQuestion = question(root, 'flex_pattern');
    if (!flexQuestion) return;
    var hasSuggestion = !recommendation.isFullCustom && Boolean(recommendation.suggestedFlexPattern);
    var flexHelp = flexQuestion.querySelector('[data-flex-help]');
    if (flexHelp) {
      flexHelp.textContent = hasSuggestion
        ? 'Soft, Standard and Stiff are relative to the selected model’s native flex. The suggested option reflects the rider profile and ride goals. Select a pattern to see how it changes the selected shape.'
        : 'Choose from five flex patterns. Each is relative to the standard flex Kindred would build for the rider’s physical specifications. A Kindred designer will confirm the finished flex.';
    }
    var flexName = recommendation.shape || recommendation.referenceShape || 'Selected model';
    var flexOptions = recommendation.flexOptions || [];
    var optionsContainer = flexQuestion.querySelector('.kcb-flex-options');
    if (optionsContainer) {
      optionsContainer.classList.toggle('kcb-options--three', !recommendation.isFullCustom);
      optionsContainer.classList.toggle('kcb-options--five', recommendation.isFullCustom);
    }
    flexQuestion.querySelectorAll('[data-answer-key]').forEach(function (card) {
      var key = card.getAttribute('data-answer-key');
      var option = flexOptions.find(function (item) { return item.key === key; });
      var unavailable = !option || card.getAttribute('data-override-hidden') === 'true';
      card.hidden = unavailable;
      var input = card.querySelector('input[type="radio"]');
      if (unavailable) {
        card.classList.remove('is-recommended');
        if (input) input.checked = false;
        return;
      }
      var recommended = hasSuggestion && option.isSuggested;
      card.classList.toggle('is-recommended', recommended);
      var badge = card.querySelector('.kcb-recommended-badge');
      if (badge) badge.hidden = !recommended;
      var description = card.querySelector('[data-flex-option-description]');
      if (description) description.textContent = hasSuggestion && Number.isFinite(option.intendedFlex)
        ? option.intendedFlex + '/10'
        : 'Relative to rider profile';
      if (input) input.checked = option.key === recommendation.flexPattern;
    });
    renderFlexDetails(root, recommendation, flexName);
  }

  function renderFlexDetails(root, recommendation, flexName) {
    var panel = root.querySelector('[data-flex-details]');
    if (!panel) return;
    var selected = (recommendation.flexOptions || []).find(function (option) {
      return option.key === recommendation.flexPattern;
    });
    var flexQuestion = question(root, 'flex_pattern');
    var selectedCard = selected && flexQuestion ? answer(flexQuestion, selected.key) : null;
    if (selectedCard && (selectedCard.hidden || selectedCard.getAttribute('data-override-hidden') === 'true')) selected = null;
    panel.hidden = !selected;
    if (!selected) return;
    panel.setAttribute('data-flex-key', selected.key);

    var stockLength = Number.isFinite(number(recommendation.stockLength, NaN))
      ? ' ' + conciseNumber(recommendation.stockLength)
      : '';
    var modelLabel = recommendation.isFullCustom
      ? 'your Custom Shape'
      : 'the ' + (flexName || 'selected model') + stockLength;
    var rating = Number.isFinite(selected.intendedFlex) ? selected.intendedFlex + '/10' : 'Set for rider';
    var relative = label('flex_pattern', selected.key);
    var note = recommendation.isFullCustom
      ? 'Flex is set relative to the rider’s physical specifications and confirmed during the build review.'
      : (selected.isSuggested
        ? selected.text + ' is suggested based on rider weight, ability and ride goals.'
        : 'Suggested flex: ' + recommendation.suggestedFlex + '. Your selected pattern will be confirmed during the build review.');

    setText(root, '[data-flex-detail-title]', selected.text);
    setText(root, '[data-flex-detail-rating]', rating);
    setText(root, '[data-flex-detail-relative]', relative);
    setText(root, '[data-flex-detail-summary]', selected.detail);
    setText(root, '[data-flex-effect-heading]', 'How it affects ' + modelLabel);
    setText(root, '[data-flex-detail-effect]', flexPatternEffect(selected.key, modelLabel));
    setText(root, '[data-flex-detail-note]', note);
  }

  function constructionDetails(key) {
    var normalizedKey = key === 'fiberglass' ? 'triaxial_fiberglass' : key;
    return CONSTRUCTION_DETAILS[normalizedKey] || CONSTRUCTION_DETAILS.triaxial_fiberglass;
  }

  function renderConstructionDetails(root, key) {
    var panel = root.querySelector('[data-construction-details]');
    if (!panel) return;
    panel.hidden = !key;
    if (!key) return;
    var details = constructionDetails(key);
    panel.setAttribute('data-construction-key', details.key);
    setText(root, '[data-construction-title]', details.title);
    setText(root, '[data-construction-summary]', details.summary);
    setText(root, '[data-construction-best]', details.best);
    setText(root, '[data-construction-tradeoff]', details.tradeoff);
    setText(root, '[data-construction-note]', details.note);
    var factors = root.querySelector('[data-construction-detail-factors]');
    if (factors) {
      factors.replaceChildren();
      details.factors.forEach(function (factor) {
        var row = document.createElement('div');
        var term = document.createElement('dt');
        var value = document.createElement('dd');
        term.textContent = factor.label;
        value.textContent = factor.value;
        row.appendChild(term);
        row.appendChild(value);
        factors.appendChild(row);
      });
    }
  }

  function renderRecommendation(root, recommendation, state) {
    renderShapeOptions(root, recommendation, state);
    renderFlexOptions(root, recommendation);
    renderComposite(root, recommendation.composite);
  }

  function proofAssets(input, recommendation, config) {
    var state = normalizeState(input);
    if (state.custom_shape === 'custom' || state.artwork_level !== 'stock_graphic') return null;
    var shape = recommendation && recommendation.shape ? recommendation.shape : state.shape_choice;
    var shapeSlug = PROOF_SHAPE_SLUGS[shape];
    if (!shapeSlug) return null;
    var folder = state.product_type === 'skis' ? 'skis' : (state.product_type === 'splitboard' ? 'splitboards' : 'snowboards');
    var productSlug = folder === 'skis' ? 'skis' : (folder === 'splitboards' ? 'splitboard' : 'snowboard');
    var graphicKey = state.graphic_option || 'night-watch';
    var graphicSlug = PROOF_GRAPHIC_SLUGS[graphicKey] || graphicKey;
    var baseKey = state.base_colour || 'black_on_red';
    var baseSlug = baseKey.replace(/_/g, '-');
    return {
      shape: shape,
      graphic: state.graphic_title || label('stock_graphic', graphicKey),
      construction: label('construction', state.construction),
      base: label('base_colour', baseKey),
      topsheet: assetUrl(config, 'kindred-' + shapeSlug + '-' + productSlug + '-' + graphicSlug + '-topsheet.webp'),
      constructionImage: assetUrl(config, CONSTRUCTION_ASSETS[state.construction]),
      baseImage: assetUrl(config, 'kindred-base-coupon-' + baseSlug + '.webp')
    };
  }

  function renderFinalProof(root, state, recommendation) {
    var panel = root.querySelector('[data-final-proof]');
    if (!panel) return;
    var proof = proofAssets(state, recommendation, root._kcbConfig);
    panel.hidden = !proof;
    if (!proof) return;

    var topsheet = panel.querySelector('[data-proof-topsheet]');
    if (topsheet) {
      topsheet.src = proof.topsheet;
      topsheet.alt = 'Finished ' + proof.shape + ' with the ' + proof.graphic + ' stock topsheet';
    }
    var construction = panel.querySelector('[data-proof-construction]');
    if (construction) {
      construction.src = proof.constructionImage;
      construction.alt = proof.construction + ' composite layup';
    }
    var base = panel.querySelector('[data-proof-base]');
    if (base) {
      base.src = proof.baseImage;
      base.alt = proof.base + ' base colour coupon';
    }
    setText(panel, '[data-proof-topsheet-label]', proof.graphic);
    setText(panel, '[data-proof-topsheet-summary]', proof.graphic);
    setText(panel, '[data-proof-construction-label]', proof.construction);
    setText(panel, '[data-proof-base-label]', proof.base);
    setText(panel, '[data-proof-shape]', proof.shape);
  }

  function syncGraphicImages(root, state) {
    var productType = state.product_type === 'skis'
      ? 'skis'
      : (state.product_type === 'splitboard' ? 'splitboard' : 'snowboard');
    var productLabel = productType === 'skis' ? 'ski' : productType;
    root.querySelectorAll('[data-graphic-product-image]').forEach(function (image) {
      var source = image.getAttribute('data-image-' + productType)
        || image.getAttribute('data-image-snowboard')
        || image.getAttribute('src');
      if (source && image.getAttribute('src') !== source) image.setAttribute('src', source);
      var title = image.getAttribute('data-graphic-title') || 'Kindred';
      image.alt = title + ' stock ' + productLabel + ' graphic';
    });
  }

  function renderPrice(root, estimate) {
    setText(root, '[data-price-total]', formatMoney(estimate.total, estimate.currency));
    var container = root.querySelector('[data-price-items]');
    if (!container) return;
    container.replaceChildren();
    estimate.items.forEach(function (item) {
      var row = document.createElement('div');
      var name = document.createElement('span');
      var amount = document.createElement('strong');
      name.textContent = item.label;
      amount.textContent = formatMoney(item.amount, estimate.currency);
      row.appendChild(name);
      row.appendChild(amount);
      container.appendChild(row);
    });
  }

  function addReviewRow(list, term, description) {
    var row = document.createElement('div');
    var dt = document.createElement('dt');
    var dd = document.createElement('dd');
    dt.textContent = term;
    dd.textContent = description;
    row.appendChild(dt);
    row.appendChild(dd);
    list.appendChild(row);
  }

  function renderReview(root, state, recommendation, estimate) {
    var container = root.querySelector('[data-review-summary]');
    if (!container) return;
    container.replaceChildren();
    var list = document.createElement('dl');
    var normalized = normalizeState(state);
    addReviewRow(list, 'Collection', label('collection', normalized.collection));
    addReviewRow(list, 'Build', label('product_type', normalized.product_type));
    addReviewRow(list, 'Rider', formatHeight(state, normalized) + ' · ' + formatWeight(state, normalized) + ' · boot ' + formatBootSize(normalized));
    addReviewRow(list, 'Ability', label('ability', state.ability));
    var hiddenQuestions = new Set(normalized.hidden_questions);
    if (!hiddenQuestions.has('location')) addReviewRow(list, 'Location', label('location', normalized.location));
    var skiSetupSummary = formatSkiSetup(state);
    if (state.product_type === 'skis' && skiSetupSummary) addReviewRow(list, 'Ski setup', skiSetupSummary);
    if (normalized.product_type === 'skis' && !hiddenQuestions.has('ski_touring_notch')) addReviewRow(list, 'Touring notch', label('ski_touring_notch', normalized.ski_touring_notch));
    var stanceSummary = formatStance(state);
    if (state.product_type !== 'skis' && stanceSummary) addReviewRow(list, 'Stance', stanceSummary);
    var rideSummary = [];
    if (!hiddenQuestions.has('terrain')) rideSummary.push(label('terrain', normalized.terrain));
    rideSummary.push(label('snow', normalized.snow) + ' snow');
    if (normalized.collection === 'carving_snowboard') rideSummary.push(label('turn_style', normalized.turn_style) + ' turns');
    rideSummary.push(label('ride_feel', normalized.ride_feel).toLowerCase());
    addReviewRow(list, 'Ride', rideSummary.join(' · '));
    addReviewRow(list, 'Responsiveness', normalized.responsiveness ? label('responsiveness', normalized.responsiveness) : 'Inferred from turn preference');
    addReviewRow(list, 'Priorities', normalized.priorities.map(function (item) { return label('priorities', item); }).join(', ') || 'To discuss');
    if (normalized.product_type === 'splitboard') addReviewRow(list, 'Touring emphasis', label('touring_focus', normalized.touring_focus));
    addReviewRow(list, 'Selected shape', recommendation.shape + ' · ' + recommendation.length);
    if (recommendation.isFullCustom) {
      var processLabel = normalized.custom_spec_mode === 'specs' ? 'Own build specs with designer review' : 'Designer consultation';
      addReviewRow(list, 'Shape process', processLabel + (recommendation.referenceShape ? ' · reference: ' + recommendation.referenceShape : ''));
    }
    addReviewRow(list, 'Waist width', recommendation.width);
    addReviewRow(list, 'Geometry', recommendation.profile);
    if (normalized.expert_specs) {
      var expertSpecs = [];
      if (state.exact_length) expertSpecs.push(state.exact_length + ' cm length');
      if (state.exact_waist) expertSpecs.push(state.exact_waist + ' mm waist');
      if (state.exact_radius) expertSpecs.push(state.exact_radius + ' m sidecut');
      if (state.exact_taper) expertSpecs.push(state.exact_taper + ' mm taper');
      if (state.exact_tip_length) expertSpecs.push(state.exact_tip_length + ' mm tip');
      if (state.exact_tail_length) expertSpecs.push(state.exact_tail_length + ' mm tail');
      if (state.exact_setback) expertSpecs.push(state.exact_setback + ' mm setback');
      if (state.camber_profile) expertSpecs.push(label('camber_profile', state.camber_profile));
      if (expertSpecs.length) addReviewRow(list, 'Build specs', expertSpecs.join(' · '));
      if (state.expert_notes) addReviewRow(list, 'Additional information', state.expert_notes);
    }
    if (!recommendation.isFullCustom) addReviewRow(list, 'Suggested flex', recommendation.suggestedFlex);
    if (recommendation.flex) addReviewRow(list, 'Chosen flex', recommendation.flex);
    addReviewRow(list, 'Composite suggestion', recommendation.composite.label);
    addReviewRow(list, 'Construction', label('construction', state.construction));
    addReviewRow(list, 'Artwork', label('artwork_level', state.artwork_level) + (state.artwork_level === 'stock_graphic' ? ' · ' + (state.graphic_title || 'direction to discuss') : ''));
    if (state.artwork_level === 'stock_graphic') {
      var surcharge = estimate && estimate.items.find(function (item) { return item.key === 'base_colour_surcharge'; });
      addReviewRow(list, 'Base colour', label('base_colour', state.base_colour) + (['black_on_red', 'red_on_black'].indexOf(state.base_colour) !== -1 ? ' · included' : ' · +' + formatMoney(surcharge ? surcharge.amount : DEFAULT_PRICES.base_colour_surcharge, estimate && estimate.currency || 'CAD')));
    }
    if (state.artwork_level !== 'stock_graphic' && normalized.art_notes) addReviewRow(list, 'Art direction', normalized.art_notes);
    if (state.artwork_level === 'customer_provided' && state.art_link) addReviewRow(list, 'Artwork file', state.art_link);
    if (state.artwork_level !== 'stock_graphic' && state.art_inspiration_link) addReviewRow(list, 'Past work inspiration', state.art_inspiration_link);
    if (state.artwork_level !== 'stock_graphic' && state.art_reference_link) addReviewRow(list, 'Reference image', state.art_reference_link);
    if (normalized.timing) addReviewRow(list, 'Requested delivery date', normalized.timing);
    addReviewRow(list, 'Shape option', normalized.custom_shape === 'custom' ? 'Custom Shape' : 'Selected stock shape');
    container.appendChild(list);
  }

  function contactValues(root) {
    var name = root.querySelector('[name="contact[name]"]');
    var email = root.querySelector('[name="contact[email]"]');
    var phone = root.querySelector('[name="contact[phone]"]');
    return { name: name ? name.value.trim() : '', email: email ? email.value.trim() : '', phone: phone ? phone.value.trim() : '' };
  }

  function setGoalCopy(element, value) {
    if (!element) return;
    if (!Object.prototype.hasOwnProperty.call(element, '_kcbDefaultCopy')) element._kcbDefaultCopy = element.textContent;
    element.textContent = value === undefined ? element._kcbDefaultCopy : value;
  }

  function applyGoalCopy(root, collection) {
    var copy = COLLECTION_GOAL_COPY[collection] || {};
    var heading = root.querySelector('[data-goals-heading]');
    var intro = root.querySelector('[data-goals-intro]');
    setGoalCopy(heading, copy.heading);
    setGoalCopy(intro, copy.intro);

    ['terrain', 'snow', 'turn_style'].forEach(function (key) {
      var item = question(root, key);
      if (!item) return;
      setGoalCopy(item.querySelector('[data-question-label]'));
      setGoalCopy(item.querySelector('[data-question-help]'));
      childrenByData(item, 'data-answer-key').forEach(function (option) {
        setGoalCopy(option.querySelector('.kcb-option-title'));
        setGoalCopy(option.querySelector('.kcb-option-description'));
      });
    });

    Object.keys(copy.questions || {}).forEach(function (key) {
      var item = question(root, key);
      var questionCopy = copy.questions[key];
      if (!item) return;
      setGoalCopy(item.querySelector('[data-question-label]'), questionCopy.label);
      setGoalCopy(item.querySelector('[data-question-help]'), questionCopy.help);
    });

    Object.keys(copy.answers || {}).forEach(function (questionKey) {
      var item = question(root, questionKey);
      Object.keys(copy.answers[questionKey]).forEach(function (answerKey) {
        var option = answer(item, answerKey);
        var answerCopy = copy.answers[questionKey][answerKey];
        if (!option) return;
        setGoalCopy(option.querySelector('.kcb-option-title'), answerCopy.title);
        setGoalCopy(option.querySelector('.kcb-option-description'), answerCopy.description);
      });
    });
  }

  function setAllowedAnswers(root, questionKey, allowedKeys) {
    var item = question(root, questionKey);
    if (!item) return;
    childrenByData(item, 'data-answer-key').forEach(function (option) {
      var allowed = allowedKeys.indexOf(option.getAttribute('data-answer-key')) !== -1;
      option.hidden = !allowed || option.getAttribute('data-override-hidden') === 'true';
      if (option.hidden) {
        var input = option.querySelector('input');
        if (input) input.checked = false;
      }
    });
  }

  function applyCollectionGoalProfile(root, state) {
    var profileKey = goalProfileKey(state.collection, state.product_type);
    var profile = collectionGoalProfile(profileKey);
    applyGoalCopy(root, profileKey);
    var terrainQuestion = question(root, 'terrain');
    if (terrainQuestion) terrainQuestion.hidden = profile.hideTerrainQuestion || terrainQuestion.getAttribute('data-override-hidden') === 'true';
    setAllowedAnswers(root, 'terrain', profile.terrainOptions);
    setAllowedAnswers(root, 'snow', profile.snowOptions);
    setAllowedAnswers(root, 'priorities', profile.priorityOptions);
    var priorityQuestion = question(root, 'priorities');
    var selectedPriorities = priorityQuestion && !priorityQuestion.hidden
      ? priorityQuestion.querySelectorAll('input[type="checkbox"]:checked').length
      : 0;
    var status = root.querySelector('[data-priority-status]');
    if (status) status.textContent = selectedPriorities ? selectedPriorities + ' of 3 selected' : '';
  }

  function applyConstructionAvailability(root, state) {
    var constructionQuestion = question(root, 'construction');
    if (!constructionQuestion) return;
    var allowed = constructionOptionsForState(state);

    constructionQuestion.querySelectorAll('[data-answer-key]').forEach(function (card) {
      var key = card.getAttribute('data-answer-key');
      card.hidden = allowed.indexOf(key) === -1 || card.getAttribute('data-override-hidden') === 'true';
      var input = card.querySelector('input[type="radio"]');
      if (input) {
        input.disabled = card.hidden;
        if (card.hidden && input.checked) input.checked = false;
      }
    });
  }

  function toggleConditionals(root, state) {
    root.querySelectorAll('[data-conditional-product]').forEach(function (element) {
      var matches = element.getAttribute('data-conditional-product').split(',').indexOf(state.product_type) !== -1;
      element.hidden = !matches || element.getAttribute('data-override-hidden') === 'true';
    });
    root.querySelectorAll('[data-conditional-art]').forEach(function (element) {
      var matches = element.getAttribute('data-conditional-art').split(',').indexOf(state.artwork_level) !== -1;
      element.hidden = !matches || element.getAttribute('data-override-hidden') === 'true';
    });
    root.querySelectorAll('[data-conditional-shape]').forEach(function (element) {
      var matches = element.getAttribute('data-conditional-shape') === state.custom_shape;
      element.hidden = !matches || element.getAttribute('data-override-hidden') === 'true';
    });
    applyCollectionGoalProfile(root, state);
    applyConstructionAvailability(root, state);
    var customShapeFlow = state.collection === 'custom_shape';
    var expert = root.querySelector('[data-expert-specs]');
    if (expert) expert.hidden = !state.expert_specs;
    var expertToggle = root.querySelector('[data-expert-toggle]');
    if (expertToggle) expertToggle.hidden = customShapeFlow;
    var expertLegend = root.querySelector('[data-expert-legend]');
    if (expertLegend) expertLegend.textContent = customShapeFlow ? 'Custom shape development' : 'Do you already know your detailed specs?';
    var expertHelp = root.querySelector('[data-expert-help]');
    if (expertHelp) expertHelp.textContent = customShapeFlow ? 'Choose whether to begin with a designer consultation or share your own geometry targets.' : 'Optional. Add exact targets only if they are meaningful to you.';
    var customProductType = root.querySelector('[data-custom-product-type]');
    if (customProductType) customProductType.hidden = !customShapeFlow;
    var customSpecMode = root.querySelector('[data-custom-spec-mode]');
    if (customSpecMode) customSpecMode.hidden = !customShapeFlow;
    var stockShapeSelection = root.querySelector('[data-stock-shape-selection]');
    if (stockShapeSelection) stockShapeSelection.hidden = stockShapeSelection.getAttribute('data-override-hidden') === 'true';
    var stockShapeIntro = root.querySelector('[data-stock-shape-intro]');
    if (stockShapeIntro) stockShapeIntro.hidden = customShapeFlow || state.expert_specs;
    var customShapeIntro = root.querySelector('[data-custom-shape-intro]');
    if (customShapeIntro) customShapeIntro.hidden = !customShapeFlow || state.expert_specs;
    var ownSpecShapeIntro = root.querySelector('[data-own-spec-shape-intro]');
    if (ownSpecShapeIntro) ownSpecShapeIntro.hidden = !state.expert_specs;
  }

  function syncCards(root) {
    root.querySelectorAll('[data-answer-key]').forEach(function (card) {
      var input = card.querySelector('input');
      card.classList.toggle('is-selected', Boolean(input && input.checked));
    });
  }

  function selectionSummaries(input, recommendation, estimate, context) {
    var rawState = input || {};
    var state = normalizeState(rawState);
    var rec = recommendation || recommend(state, {});
    var price = estimate || calculatePrice(state, {});
    var options = context || {};
    var currentStep = number(options.step, 0);
    var completedSteps = options.completedSteps || {};
    var reached = function (position) {
      return currentStep >= position || Boolean(completedSteps[position]);
    };
    var completionEntry = function (position) {
      if (completedSteps[position]) return { text: 'Completed', status: 'complete' };
      if (currentStep === position) return { text: 'In progress', status: 'current' };
      return { text: 'Not completed', status: 'pending' };
    };
    var explicit = function (key, fallback) {
      return options[key] === undefined ? Boolean(fallback) : Boolean(options[key]);
    };
    var productSelected = explicit('productSelected', hasValue(rawState.collection || rawState.product_collection));
    var customProductTypeSelected = explicit('customProductTypeSelected', hasValue(rawState.custom_product_type));
    var pricedProductSelected = productSelected && (state.collection !== 'custom_shape' || customProductTypeSelected);
    var constructionSelected = explicit('constructionSelected', hasValue(rawState.construction));
    var flexSelected = explicit('flexSelected', hasValue(rawState.flex_pattern));
    var artworkSelected = explicit('artworkSelected', hasValue(rawState.artwork_level));
    var graphicSelected = explicit('graphicSelected', hasValue(rawState.graphic_option));
    var baseColourSelected = explicit('baseColourSelected', hasValue(rawState.base_colour));
    var productText = 'Not selected';
    if (productSelected) {
      productText = state.collection === 'custom_shape'
        ? (customProductTypeSelected
          ? 'Custom ' + (state.product_type === 'skis' ? 'Ski' : label('product_type', state.product_type))
          : 'Custom Shape')
        : label('collection', state.collection);
    }
    var shapeSelected = explicit(
      'shapeSelected',
      state.collection === 'custom_shape' || Boolean(rawState.shape_choice || rawState.shape_selection || rawState.selected_shape) || Boolean(rec.autoCustom)
    );
    var shapeText = 'Not selected';
    if (shapeSelected) {
      shapeText = rec.isFullCustom
        ? 'Custom Shape'
        : rec.shape + (hasValue(rec.stockLength) ? ' · ' + conciseNumber(rec.stockLength) + ' cm' : '');
    }
    var widthText = 'Not selected';
    var customWidthConfirmed = explicit('customWidthConfirmed', false);
    var widthSelected = explicit('widthSelected', hasValue(rawState.waist_width_choice || rawState.width_choice) || customWidthConfirmed || completedSteps[4]);
    if (shapeSelected && reached(4) && widthSelected) {
      if (rec.isFullCustom) {
        widthText = customWidthConfirmed || completedSteps[4] ? 'Custom Shape Selected' : 'Not confirmed';
      } else {
        var widthOption = (rec.widthOptions || []).find(function (option) { return option.key === state.waist_width_choice; })
          || (rec.widthOptions || []).find(function (option) { return option.key === rawState.width_choice; });
        widthText = widthOption
          ? widthOption.label + (hasValue(widthOption.waist) ? ' · ' + conciseNumber(widthOption.waist) + ' mm' : '')
          : 'Not selected';
      }
    }
    var constructionText = 'Not selected';
    if (reached(5) && constructionSelected) {
      constructionText = label('construction', state.construction) + (flexSelected ? ' · ' + label('flex_pattern', state.flex_pattern) : ' · Flex not selected');
    }
    var artworkText = 'Not selected';
    if (reached(6) && artworkSelected) {
      artworkText = label('artwork_level', state.artwork_level);
      if (state.artwork_level === 'stock_graphic') {
        var graphic = graphicSelected ? (state.graphic_title || label('stock_graphic', state.graphic_option)) : 'Graphic not selected';
        var baseColour = baseColourSelected ? label('base_colour', state.base_colour) : 'Base colour not selected';
        artworkText = 'Stock · ' + graphic + ' · ' + baseColour;
      }
    }
    var reviewPrice = formatMoney(price.total, price.currency);
    var fitEntry = completionEntry(1);
    var goalsEntry = completionEntry(2);
    return [
      { step: 0, text: productText, status: currentStep === 0 ? 'current' : (productSelected ? 'selected' : 'pending') },
      { step: 1, text: fitEntry.text, status: fitEntry.status },
      { step: 2, text: goalsEntry.text, status: goalsEntry.status },
      { step: 3, text: shapeText, status: shapeSelected ? (currentStep === 3 ? 'current' : 'selected') : 'pending' },
      { step: 4, text: widthText, status: widthText === 'Not selected' || widthText === 'Not confirmed' ? 'pending' : (currentStep === 4 ? 'current' : 'selected') },
      { step: 5, text: constructionText, status: constructionText === 'Not selected' ? 'pending' : (currentStep === 5 ? 'current' : 'selected') },
      { step: 6, text: artworkText, status: artworkText === 'Not selected' ? 'pending' : (currentStep === 6 ? 'current' : 'selected') },
      { step: 7, text: pricedProductSelected ? (reached(7) ? 'Ready · ' + reviewPrice : 'Starting ' + reviewPrice) : 'Not available', status: currentStep === 7 ? 'current' : 'pending' }
    ];
  }

  function renderSelectionSummaries(root, state, recommendation, estimate, context) {
    selectionSummaries(state, recommendation, estimate, context).forEach(function (entry) {
      var item = root.querySelector('[data-selection-summary-step="' + entry.step + '"]');
      var value = item && item.querySelector('[data-selection-summary-value]');
      if (!item || !value) return;
      value.textContent = entry.text;
      value.title = entry.text;
      item.setAttribute('data-summary-status', entry.status);
    });
  }

  function validateStep(root, step) {
    var message = root.querySelector('[data-step="' + step + '"] [data-validation]');
    if (message) message.textContent = '';
    var availableRadio = function (item, checkedOnly) {
      if (!item || item.hidden) return null;
      return Array.prototype.find.call(item.querySelectorAll('input[type="radio"]'), function (input) {
        var card = input.closest('[data-answer-key]');
        return !input.disabled && (!card || !card.hidden) && (!checkedOnly || input.checked);
      }) || null;
    };
    if (step === 0) {
      var collectionQuestion = question(root, 'collection');
      if (!availableRadio(collectionQuestion, true)) {
        if (message) message.textContent = 'Select a product collection to continue.';
        var firstCollection = availableRadio(collectionQuestion, false);
        if (firstCollection) firstCollection.focus();
        return false;
      }
      return true;
    }
    if (step === 2) {
      var missingGoalQuestion = ['terrain', 'snow', 'turn_style', 'responsiveness', 'ride_feel', 'touring_focus', 'ski_touring_notch'].map(function (key) {
        return question(root, key);
      }).find(function (item) {
        return item && !item.hidden && !availableRadio(item, true);
      });
      if (missingGoalQuestion) {
        if (message) message.textContent = 'Choose an option for each ride-goal question before continuing.';
        var firstGoalOption = availableRadio(missingGoalQuestion, false);
        if (firstGoalOption) firstGoalOption.focus();
        return false;
      }
      var priorityQuestion = question(root, 'priorities');
      if (priorityQuestion && !priorityQuestion.hidden && !priorityQuestion.querySelector('input[type="checkbox"]:checked')) {
        var priorityMessage = root.querySelector('[data-priority-status]');
        if (priorityMessage) priorityMessage.textContent = 'Choose at least one priority.';
        if (message) message.textContent = 'Choose at least one top priority before continuing.';
        var firstPriority = priorityQuestion.querySelector('input[type="checkbox"]');
        if (firstPriority) firstPriority.focus();
        return false;
      }
      return true;
    }
    if (step === 3) {
      if (readState(root).collection === 'custom_shape') return true;
      var shapeQuestion = question(root, 'shape_choice');
      var selectedShape = shapeQuestion && shapeQuestion.querySelector('input[type="radio"]:checked');
      if (!selectedShape) {
        if (message) message.textContent = 'Select Custom Shape or a stock starting point to continue.';
        var firstShape = shapeQuestion && shapeQuestion.querySelector('input[type="radio"]');
        if (firstShape) firstShape.focus();
        return false;
      }
      return true;
    }
    if (step === 4) {
      var customWidthQuestion = question(root, 'custom_width_confirmation');
      if (customWidthQuestion && !customWidthQuestion.hidden) {
        var customWidthConfirmation = customWidthQuestion.querySelector('input[type="radio"]:checked');
        if (!customWidthConfirmation) {
          if (message) message.textContent = 'Select “Custom Shape Selected” to confirm and continue.';
          var customWidthInput = customWidthQuestion.querySelector('input[type="radio"]');
          if (customWidthInput) customWidthInput.focus();
          return false;
        }
        return true;
      }
      var widthQuestion = question(root, 'waist_width_choice');
      var selectedWidth = widthQuestion && widthQuestion.querySelector('input[type="radio"]:checked');
      if (!selectedWidth) {
        if (message) message.textContent = 'Select a waist width to continue.';
        var firstWidth = widthQuestion && widthQuestion.querySelector('input[type="radio"]');
        if (firstWidth) firstWidth.focus();
        return false;
      }
      return true;
    }
    if (step === 5) {
      var constructionQuestion = question(root, 'construction');
      var selectedConstruction = availableRadio(constructionQuestion, true);
      if (constructionQuestion && !constructionQuestion.hidden && !selectedConstruction) {
        if (message) message.textContent = 'Select a build construction to continue.';
        var firstConstruction = availableRadio(constructionQuestion, false);
        if (firstConstruction) firstConstruction.focus();
        return false;
      }
      var flexQuestion = question(root, 'flex_pattern');
      var selectedFlex = availableRadio(flexQuestion, true);
      if (flexQuestion && !flexQuestion.hidden && !selectedFlex) {
        if (message) message.textContent = 'Select a flex pattern to continue.';
        var firstFlex = availableRadio(flexQuestion, false);
        if (firstFlex) firstFlex.focus();
        return false;
      }
      return true;
    }
    if (step === 6) {
      var artworkQuestion = question(root, 'artwork_level');
      if (!availableRadio(artworkQuestion, true)) {
        if (message) message.textContent = 'Select an artwork option to continue.';
        var firstArtwork = availableRadio(artworkQuestion, false);
        if (firstArtwork) firstArtwork.focus();
        return false;
      }
      if (readRadio(root, 'artwork_level', '') === 'stock_graphic') {
        var graphicQuestion = question(root, 'graphic_option');
        if (!availableRadio(graphicQuestion, true)) {
          if (message) message.textContent = 'Select a stock graphic to continue.';
          var firstGraphic = availableRadio(graphicQuestion, false);
          if (firstGraphic) firstGraphic.focus();
          return false;
        }
        var baseColourQuestion = question(root, 'base_colour');
        if (!availableRadio(baseColourQuestion, true)) {
          if (message) message.textContent = 'Select a base colour to continue.';
          var firstBaseColour = availableRadio(baseColourQuestion, false);
          if (firstBaseColour) firstBaseColour.focus();
          return false;
        }
      }
      return true;
    }
    if (step !== 1) return true;
    var unit = root.getAttribute('data-units') || 'metric';
    var required = [
      { key: 'weight', name: 'riding weight' },
      { key: 'boot_size', name: 'boot size' }
    ];
    var missing = [];
    var first = null;
    var heightParent = question(root, 'height');
    if (heightParent && !heightParent.hidden) {
      if (unit === 'imperial') {
        var feetInput = childrenByData(root, 'data-field', 'height_feet')[0];
        var inchesInput = childrenByData(root, 'data-field', 'height_inches')[0];
        var feetMissing = !feetInput || !String(feetInput.value || '').trim() || !feetInput.validity.valid || number(feetInput.value, 0) <= 0;
        var inchesMissing = !inchesInput || !String(inchesInput.value || '').trim() || !inchesInput.validity.valid || number(inchesInput.value, -1) < 0;
        if (feetInput) feetInput.toggleAttribute('aria-invalid', feetMissing);
        if (inchesInput) inchesInput.toggleAttribute('aria-invalid', inchesMissing);
        if (feetMissing || inchesMissing) {
          missing.push('height');
          first = feetMissing ? feetInput : inchesInput;
        }
      } else {
        var heightInput = childrenByData(root, 'data-field', 'height')[0];
        var heightMissing = !heightInput || !String(heightInput.value || '').trim() || !heightInput.validity.valid || number(heightInput.value, 0) <= 0;
        if (heightInput) heightInput.toggleAttribute('aria-invalid', heightMissing);
        if (heightMissing) {
          missing.push('height');
          first = heightInput;
        }
      }
    }
    required.forEach(function (item) {
      var parent = question(root, item.key);
      var input = childrenByData(root, 'data-field', item.key)[0];
      var isMissing = parent && !parent.hidden && (!input || !String(input.value || '').trim() || (item.key !== 'boot_size' && (!input.validity.valid || number(input.value, 0) <= 0)));
      if (isMissing) {
        missing.push(item.name);
        if (input) input.setAttribute('aria-invalid', 'true');
        if (!first) first = input;
      } else if (input) input.removeAttribute('aria-invalid');
    });
    ['ability', 'location'].forEach(function (key) {
      var item = question(root, key);
      if (item && !item.hidden && !availableRadio(item, true)) {
        missing.push(key);
        if (!first) first = availableRadio(item, false);
      }
    });
    if (readRadio(root, 'collection', '') === 'custom_shape') {
      var customProductType = childrenByData(root, 'data-field', 'custom_product_type')[0];
      var customProductTypeMissing = !customProductType || !String(customProductType.value || '').trim();
      if (customProductType) customProductType.toggleAttribute('aria-invalid', customProductTypeMissing);
      if (customProductTypeMissing) {
        missing.push('custom product format');
        if (!first) first = customProductType;
      }
      var customSpecQuestion = question(root, 'custom_spec_mode');
      if (!availableRadio(customSpecQuestion, true)) {
        missing.push('custom shape starting path');
        if (!first) first = availableRadio(customSpecQuestion, false);
      }
    }
    if (!missing.length) return true;
    if (message) message.textContent = 'Please complete ' + missing.join(', ') + ' before continuing.';
    if (first) first.focus();
    return false;
  }

  var ANALYTICS_STEP_NAMES = ['product', 'rider_fit', 'ride_goals', 'shape', 'waist_width', 'construction', 'artwork'];

  function isMeaningfulAnalyticsChange(target) {
    if (!target || !target.matches || target.disabled) return false;
    if (target.name && String(target.name).indexOf('contact[') === 0) return false;
    if (target.matches('[data-summary-body]')) return false;
    return Boolean(target.closest('[data-question-key]') || target.matches('[data-field]'));
  }

  function mountOne(root) {
    if (instances && instances.has(root)) return;
    if (instances) instances.add(root);
    var config = readConfig(root);
    if (!root._kcbAnalyticsInstanceKey) {
      analyticsInstanceCount += 1;
      root._kcbAnalyticsInstanceKey = 'configurator-' + analyticsInstanceCount;
    }
    root._kcbConfig = config;
    config.prices = Object.assign({}, DEFAULT_PRICES, config.prices || {});
    config.shapePrices = mergeShapePrices(config.shapePrices);
    var initialCurrency = resolveCurrencyContext(config);
    config.currency = initialCurrency.currency;
    config.currencyRate = initialCurrency.rate;
    root.classList.add('is-enhanced');
    root.setAttribute('data-units', 'metric');
    applyOverrides(root, config);

    var generatedBody = root.querySelector('[data-summary-body]');
    var postedBody = generatedBody ? generatedBody.value : '';
    var preservePostedBody = Boolean(root.querySelector('.kcb-form-errors') && postedBody.trim());
    if (generatedBody) {
      generatedBody.tabIndex = -1;
      generatedBody.setAttribute('aria-hidden', 'true');
    }

    function syncCurrencyDisplay() {
      root.setAttribute('data-currency', config.currency);
      root.querySelectorAll('[data-currency-code]').forEach(function (element) { element.textContent = config.currency; });
      Object.keys(config.prices).forEach(function (key) {
        root.querySelectorAll('[data-price="' + key + '"]').forEach(function (element) {
          element.textContent = formatMoney(convertedAmount(config.prices[key], config.currencyRate), config.currency, false);
        });
      });
      var baseColourHelp = root.querySelector('[data-base-colour-help]');
      if (baseColourHelp) baseColourHelp.textContent = 'Black on Red and Red on Black are included. A ' + formatMoney(convertedAmount(config.prices.base_colour_surcharge, config.currencyRate), config.currency) + ' surcharge applies if another colour selection is chosen.';
    }

    syncCurrencyDisplay();

    function setHeightMode(unit) {
      var metricFields = root.querySelector('[data-height-metric]');
      var imperialFields = root.querySelector('[data-height-imperial]');
      if (metricFields) metricFields.hidden = unit === 'imperial';
      if (imperialFields) imperialFields.hidden = unit !== 'imperial';
      if (unit === 'imperial') {
        var metricInput = childrenByData(root, 'data-field', 'height')[0];
        if (metricInput) metricInput.removeAttribute('aria-invalid');
      } else {
        childrenByData(root, 'data-field', 'height_feet').concat(childrenByData(root, 'data-field', 'height_inches')).forEach(function (input) {
          input.removeAttribute('aria-invalid');
        });
      }
    }

    function syncStanceWidthOptions(convertExisting) {
      var unitSelect = root.querySelector('[data-field="stance_width_unit"]:checked') || childrenByData(root, 'data-field', 'stance_width_unit')[0];
      var widthSelect = childrenByData(root, 'data-field', 'stance_width')[0];
      if (!unitSelect || !widthSelect) return;
      var nextUnit = unitSelect.value === 'in' ? 'in' : 'cm';
      var previousUnit = widthSelect.getAttribute('data-width-unit') || nextUnit;
      var previousValue = hasValue(widthSelect.value) ? number(widthSelect.value, 0) : null;
      var preferredValue = previousValue;
      if (convertExisting && previousValue !== null && previousUnit !== nextUnit) {
        preferredValue = nextUnit === 'in' ? previousValue / 2.54 : previousValue * 2.54;
      }
      var minimum = nextUnit === 'in' ? 16 : 40;
      var maximum = nextUnit === 'in' ? 28 : 70;
      var stepSize = 0.5;
      widthSelect.replaceChildren();
      var unknown = document.createElement('option');
      unknown.value = '';
      unknown.textContent = 'Not sure';
      widthSelect.appendChild(unknown);
      var closestValue = null;
      for (var value = minimum; value <= maximum; value += stepSize) {
        var optionValue = conciseNumber(value);
        var option = document.createElement('option');
        option.value = optionValue;
        option.textContent = optionValue + ' ' + nextUnit;
        widthSelect.appendChild(option);
        if (preferredValue !== null && (closestValue === null || Math.abs(value - preferredValue) < Math.abs(closestValue - preferredValue))) closestValue = value;
      }
      if (closestValue !== null) widthSelect.value = conciseNumber(closestValue);
      widthSelect.setAttribute('data-width-unit', nextUnit);
      setText(root, '[data-stance-width-unit-label]', nextUnit);
    }

    function syncStanceWidthUnit(nextUnit, convertExisting) {
      var normalizedUnit = nextUnit === 'in' ? 'in' : 'cm';
      var fields = childrenByData(root, 'data-field', 'stance_width_unit');
      fields.forEach(function (field) {
        if (field.type === 'radio') field.checked = field.value === normalizedUnit;
        else field.value = normalizedUnit;
      });
      syncStanceWidthOptions(convertExisting);
    }

    syncStanceWidthUnit('cm', false);

    function populateSkiBslOptions() {
      var bslSelect = childrenByData(root, 'data-field', 'ski_bsl')[0];
      if (!bslSelect || bslSelect.options.length > 1) return;
      for (var bsl = 220; bsl <= 380; bsl += 1) {
        var option = document.createElement('option');
        option.value = String(bsl);
        option.textContent = bsl + ' mm';
        bslSelect.appendChild(option);
      }
    }

    populateSkiBslOptions();

    function syncBootPlaceholder() {
      var unitField = childrenByData(root, 'data-field', 'boot_size_unit')[0];
      var sizeField = childrenByData(root, 'data-field', 'boot_size')[0];
      var placeholders = { mens_us: '9.5', womens_us: '10.5', youth_us: '5', mondo: '27.5', eu: '43', uk: '8.5' };
      if (sizeField) sizeField.placeholder = placeholders[unitField ? unitField.value : 'mens_us'] || '9.5';
    }

    function syncWeightUnitLabel(unit) {
      var labelElement = root.querySelector('[data-weight-unit-label]');
      if (labelElement) labelElement.textContent = unit === 'imperial' ? 'Pounds' : 'Kilograms';
    }

    setHeightMode('metric');
    syncWeightUnitLabel('metric');
    syncBootPlaceholder();

    var step = 0;
    var contactResult = root.querySelector('[data-contact-result]');
    var hasFormResult = Boolean(root.querySelector('[data-form-success], .kcb-form-errors'));
    if (contactResult) {
      try { hasFormResult = hasFormResult || Boolean(JSON.parse(contactResult.textContent || '{}').success); }
      catch { /* The visible Liquid result remains authoritative. */ }
    }
    if (hasFormResult) step = 7;
    var completedSteps = {};
    if (hasFormResult) {
      for (var completedStep = 0; completedStep < 7; completedStep += 1) completedSteps[completedStep] = true;
    }

    function clearCompletedFrom(position) {
      Object.keys(completedSteps).forEach(function (key) {
        if (number(key, 0) >= position) delete completedSteps[key];
      });
    }

    function current() {
      return readState(root);
    }

    function updateAll() {
      var state = current();
      if (!root._kcbWidthTouched) state.waist_width_choice = '';
      if (!root._kcbFlexTouched) state.flex_pattern = '';
      toggleConditionals(root, state);
      state = current();
      if (!root._kcbWidthTouched) state.waist_width_choice = '';
      if (!root._kcbFlexTouched) state.flex_pattern = '';
      var recommendation = recommend(state, config);
      var estimate = calculatePrice(state, config);
      syncGraphicImages(root, state);
      renderRecommendation(root, recommendation, state);
      renderWidthOptions(root, state, recommendation);
      renderFinalProof(root, state, recommendation);
      renderConstructionDetails(root, state.construction);
      renderPrice(root, estimate);
      renderReview(root, state, recommendation, estimate);
      syncCards(root);
      var selectedRadio = function (key) {
        var item = question(root, key);
        return Boolean(item && item.querySelector('input[type="radio"]:checked:not(:disabled)'));
      };
      var customWidthQuestion = question(root, 'custom_width_confirmation');
      var customWidthConfirmed = Boolean(customWidthQuestion && customWidthQuestion.querySelector('input[type="radio"]:checked'));
      renderSelectionSummaries(root, state, recommendation, estimate, {
        step: step,
        completedSteps: completedSteps,
        productSelected: selectedRadio('collection'),
        customProductTypeSelected: hasValue(readField(root, 'custom_product_type')),
        shapeSelected: state.collection === 'custom_shape' || recommendation.autoCustom || selectedRadio('shape_choice'),
        widthSelected: customWidthConfirmed || selectedRadio('waist_width_choice'),
        customWidthConfirmed: customWidthConfirmed,
        constructionSelected: selectedRadio('construction'),
        flexSelected: selectedRadio('flex_pattern'),
        artworkSelected: selectedRadio('artwork_level'),
        graphicSelected: selectedRadio('graphic_option'),
        baseColourSelected: selectedRadio('base_colour')
      });
      var summary = buildSummary(state, recommendation, estimate, config, contactValues(root));
      var body = root.querySelector('[data-summary-body]');
      var outgoingSummary = preservePostedBody ? postedBody : summary;
      if (body) body.value = outgoingSummary;
      var result = { state: state, recommendation: recommendation, estimate: estimate, summary: outgoingSummary };
      root._kcbCurrentResult = result;
      root.dispatchEvent(new CustomEvent('kindred.custombuild.updated', { detail: result }));
      return result;
    }

    root._kcbRefresh = updateAll;
    root._kcbReleasePostedBody = function () {
      preservePostedBody = false;
      postedBody = '';
      return updateAll();
    };
    root._kcbValidatePurchase = function () {
      for (var position = 0; position < 7; position += 1) {
        if (!validateStep(root, position)) return false;
      }
      return true;
    };

    var parentOrigin = '';
    try { parentOrigin = document.referrer ? new URL(document.referrer).origin : ''; }
    catch { parentOrigin = ''; }
    function receiveCurrency(event) {
      if (!event || event.source !== global.parent) return;
      if (parentOrigin && event.origin !== parentOrigin) return;
      var payload = event.data || {};
      if (payload.type !== 'kindred:currency' && payload.type !== 'shopify:currency') return;
      var nextCurrency = currencyCode(payload.currency || payload.active, config.currency);
      var nextRate = currencyRate(payload.rate || payload.currencyRate, config.currencyRate);
      if (nextCurrency === currencyCode(config.baseCurrency, 'CAD')) nextRate = 1;
      if (nextCurrency === config.currency && nextRate === config.currencyRate) return;
      config.currency = nextCurrency;
      config.currencyRate = nextRate;
      syncCurrencyDisplay();
      updateAll();
    }
    if (global.addEventListener) global.addEventListener('message', receiveCurrency);
    try {
      if (global.parent && global.parent !== global) global.parent.postMessage({ type: 'kindred:currency-request' }, parentOrigin || '*');
    } catch { /* Query parameters and configured defaults remain available. */ }

    function showStep(nextStep, shouldFocus) {
      step = clamp(nextStep, 0, 7);
      root.querySelectorAll('[data-step]').forEach(function (panel) {
        var active = number(panel.getAttribute('data-step'), 0) === step;
        panel.hidden = !active;
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      root.querySelectorAll('[data-progress-step]').forEach(function (item) {
        var position = number(item.getAttribute('data-progress-step'), 0);
        if (position === step) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
        item.classList.toggle('is-complete', position < step);
      });
      var bar = root.querySelector('[data-progress-bar]');
      if (bar) bar.style.width = (((step + 1) / 8) * 100) + '%';
      var progressBack = root.querySelector('[data-progress-back]');
      var progressNext = root.querySelector('[data-progress-next]');
      if (progressBack) progressBack.disabled = step === 0;
      if (progressNext) progressNext.disabled = step === 7;
      root.setAttribute('data-current-step', step);
      updateAll();
      if (shouldFocus) {
        var panel = root.querySelector('[data-step="' + step + '"]');
        var heading = panel && panel.querySelector('h3');
        if (heading) heading.focus({ preventScroll: true });
        var reduceMotion = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;
        root.querySelector('.kcb-wizard').scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    }

    root.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.matches('[data-question-key="collection"] input[type="radio"]')) clearCompletedFrom(3);
      if (target && (
        target.matches('[data-question-key="shape_choice"] input[type="radio"]') ||
        target.matches('[data-question-key="custom_spec_mode"] input[type="radio"]') ||
        target.matches('[data-field="expert_specs"]')
      )) clearCompletedFrom(4);
      if (target && (
        target.matches('[data-question-key="collection"] input[type="radio"]') ||
        target.matches('[data-question-key="shape_choice"] input[type="radio"]') ||
        target.matches('[data-question-key="custom_spec_mode"] input[type="radio"]') ||
        target.matches('[data-field="expert_specs"]')
      )) {
        var customWidthQuestion = question(root, 'custom_width_confirmation');
        if (customWidthQuestion) customWidthQuestion.querySelectorAll('input[type="radio"]').forEach(function (input) { input.checked = false; });
      }
      if (target && target.matches('[data-question-key="collection"] input[type="radio"]')) {
        root._kcbWidthTouched = false;
        root._kcbFlexTouched = false;
        var shapeQuestion = question(root, 'shape_choice');
        if (shapeQuestion) shapeQuestion.querySelectorAll('input[type="radio"]').forEach(function (input) { input.checked = false; });
        var collectionWidthQuestion = question(root, 'waist_width_choice');
        if (collectionWidthQuestion) collectionWidthQuestion.querySelectorAll('input[type="radio"]').forEach(function (input) { input.checked = false; });
        var collectionFlexQuestion = question(root, 'flex_pattern');
        if (collectionFlexQuestion) collectionFlexQuestion.querySelectorAll('input[type="radio"]').forEach(function (input) { input.checked = false; });
      }
      if (target && target.matches('[data-question-key="shape_choice"] input[type="radio"]')) {
        root._kcbWidthTouched = false;
        root._kcbFlexTouched = false;
        var shapeWidthQuestion = question(root, 'waist_width_choice');
        if (shapeWidthQuestion) shapeWidthQuestion.querySelectorAll('input[type="radio"]').forEach(function (input) { input.checked = false; });
        var shapeFlexQuestion = question(root, 'flex_pattern');
        if (shapeFlexQuestion) shapeFlexQuestion.querySelectorAll('input[type="radio"]').forEach(function (input) { input.checked = false; });
      }
      if (target && target.matches('[data-question-key="waist_width_choice"] input[type="radio"]')) root._kcbWidthTouched = true;
      if (target && target.matches('[data-question-key="flex_pattern"] input[type="radio"]')) root._kcbFlexTouched = true;
      if (target && target.matches('[data-field="boot_size_unit"]')) syncBootPlaceholder();
      if (target && target.matches('[data-field="stance_width_unit"]')) syncStanceWidthOptions(true);
      if (target && target.matches('[data-question-key="priorities"] input[type="checkbox"]')) {
        var checked = (question(root, 'priorities') || root).querySelectorAll('input[type="checkbox"]:checked');
        var priorityStatus = root.querySelector('[data-priority-status]');
        if (checked.length > 3) {
          target.checked = false;
          if (priorityStatus) priorityStatus.textContent = 'Choose up to three priorities.';
        } else if (checked.length === 0) {
          target.checked = true;
          if (priorityStatus) priorityStatus.textContent = 'Keep at least one priority selected.';
        } else if (priorityStatus) priorityStatus.textContent = checked.length + ' of 3 selected';
      }
      var changedResult = updateAll();
      if (isMeaningfulAnalyticsChange(target)) {
        publishAnalyticsEvent(root, ANALYTICS_EVENTS.started, changedResult, config, {
          key: root._kcbAnalyticsInstanceKey + ':started',
          persist: false
        });
      }
    });
    root.addEventListener('input', function () { updateAll(); });

    root.querySelectorAll('[data-unit]').forEach(function (button) {
      button.addEventListener('click', function () {
        var nextUnit = button.getAttribute('data-unit');
        var oldUnit = root.getAttribute('data-units') || 'metric';
        if (nextUnit === oldUnit) return;
        var height = childrenByData(root, 'data-field', 'height')[0];
        var heightFeet = childrenByData(root, 'data-field', 'height_feet')[0];
        var heightInches = childrenByData(root, 'data-field', 'height_inches')[0];
        var weight = childrenByData(root, 'data-field', 'weight')[0];
        if (oldUnit === 'metric' && height && height.value) {
          var imperialParts = splitImperialHeight(number(height.value, 0) / 2.54);
          if (heightFeet) heightFeet.value = imperialParts.feet;
          if (heightInches) heightInches.value = conciseNumber(imperialParts.inches);
        } else if (oldUnit === 'imperial' && height && heightFeet && heightInches && heightFeet.value && heightInches.value !== '') {
          height.value = (((number(heightFeet.value, 0) * 12) + number(heightInches.value, 0)) * 2.54).toFixed(1).replace(/\.0$/, '');
        }
        if (weight && weight.value) weight.value = oldUnit === 'metric' ? (number(weight.value) / 0.45359237).toFixed(1).replace(/\.0$/, '') : (number(weight.value) * 0.45359237).toFixed(1).replace(/\.0$/, '');
        syncStanceWidthUnit(nextUnit === 'imperial' ? 'in' : 'cm', true);
        root.setAttribute('data-units', nextUnit);
        setHeightMode(nextUnit);
        root.querySelectorAll('[data-unit]').forEach(function (unitButton) {
          var active = unitButton.getAttribute('data-unit') === nextUnit;
          unitButton.classList.toggle('is-active', active);
          unitButton.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        var weightQuestion = question(root, 'weight');
        if (weightQuestion && !(config.questionOverrides || []).some(function (item) { return item.key === 'weight' && String(item.label || '').trim(); })) weightQuestion.querySelector('[data-question-label]').textContent = nextUnit === 'metric' ? 'Weight (kg)' : 'Weight (lb)';
        syncWeightUnitLabel(nextUnit);
        if (weight) { weight.placeholder = nextUnit === 'metric' ? '78' : '172'; weight.min = nextUnit === 'metric' ? '30' : '66'; weight.max = nextUnit === 'metric' ? '230' : '507'; }
        updateAll();
      });
    });

    root.querySelectorAll('[data-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = button.closest('[data-step]');
        var currentStep = panel ? number(panel.getAttribute('data-step'), step) : step;
        if (validateStep(root, currentStep)) {
          completedSteps[currentStep] = true;
          var completedResult = updateAll();
          publishAnalyticsEvent(root, ANALYTICS_EVENTS.started, completedResult, config, {
            key: root._kcbAnalyticsInstanceKey + ':started',
            persist: false
          });
          publishAnalyticsEvent(root, ANALYTICS_EVENTS.stepCompleted, completedResult, config, {
            key: root._kcbAnalyticsInstanceKey + ':step-' + currentStep,
            persist: false,
            extra: {
              step_name: ANALYTICS_STEP_NAMES[currentStep] || 'unknown',
              step_number: currentStep + 1
            }
          });
          showStep(currentStep + 1, true);
          if (currentStep === 6) {
            publishAnalyticsEvent(root, ANALYTICS_EVENTS.completed, root._kcbCurrentResult, config, {
              key: root._kcbAnalyticsInstanceKey + ':completed',
              persist: false
            });
          }
        }
      });
    });
    root.querySelectorAll('[data-back]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = button.closest('[data-step]');
        showStep((panel ? number(panel.getAttribute('data-step'), step) : step) - 1, true);
      });
    });
    root.querySelectorAll('[data-start-over]').forEach(function (startOver) {
      startOver.addEventListener('click', function () {
        preservePostedBody = false;
        root._kcbWidthTouched = false;
        root._kcbFlexTouched = false;
        root._kcbWasCustomWidth = undefined;
        delete root._kcbConfigurationId;
        Object.keys(completedSteps).forEach(function (key) { delete completedSteps[key]; });
        root.querySelectorAll('input, textarea, select').forEach(function (field) {
          if (field.name && field.name.indexOf('contact[') === 0) return;
          if (field.type === 'radio' || field.type === 'checkbox') field.checked = field.defaultChecked;
          else if (field.tagName === 'SELECT') field.selectedIndex = 0;
          else field.value = field.defaultValue || '';
        });
        root.setAttribute('data-units', 'metric');
        setHeightMode('metric');
        root.querySelectorAll('[data-unit]').forEach(function (unitButton) {
          var active = unitButton.getAttribute('data-unit') === 'metric';
          unitButton.classList.toggle('is-active', active);
          unitButton.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        var resetWeight = childrenByData(root, 'data-field', 'weight')[0];
        var resetWeightQuestion = question(root, 'weight');
        if (resetWeightQuestion && !(config.questionOverrides || []).some(function (item) { return item.key === 'weight' && String(item.label || '').trim(); })) resetWeightQuestion.querySelector('[data-question-label]').textContent = 'Weight (kg)';
        syncWeightUnitLabel('metric');
        if (resetWeight) { resetWeight.placeholder = '78'; resetWeight.min = '30'; resetWeight.max = '230'; }
        syncBootPlaceholder();
        syncStanceWidthUnit('cm', false);
        showStep(0, true);
      });
    });

    root.querySelectorAll('[data-copy-summary]').forEach(function (copyButton) {
      copyButton.addEventListener('click', function () {
        var result = updateAll();
        var status = root.querySelector('[data-copy-status]');
        function success() { if (status) status.textContent = 'Build summary copied.'; }
        if (global.navigator && global.navigator.clipboard && global.navigator.clipboard.writeText) {
          global.navigator.clipboard.writeText(result.summary).then(success).catch(function () { if (status) status.textContent = 'Copy was blocked. Use the consultation form instead.'; });
        } else {
          var temporary = document.createElement('textarea');
          temporary.value = result.summary;
          temporary.setAttribute('readonly', '');
          temporary.style.position = 'fixed';
          temporary.style.opacity = '0';
          document.body.appendChild(temporary);
          temporary.select();
          try { document.execCommand('copy'); success(); }
          catch { if (status) status.textContent = 'Copy was blocked. Select the summary text manually instead.'; }
          temporary.remove();
        }
      });
    });

    showStep(step, false);
    var successMessage = root.querySelector('[data-form-success]');
    if (successMessage) successMessage.focus();
  }

  function mount(scope) {
    if (typeof document === 'undefined') return;
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = [];
    if (context.matches && context.matches('[data-custom-build-intake]')) roots.push(context);
    context.querySelectorAll('[data-custom-build-intake]').forEach(function (root) { roots.push(root); });
    roots.forEach(mountOne);
  }

  var api = {
    version: VERSION,
    recommend: recommend,
    recommendStock: recommendStock,
    collectionShapeNames: collectionShapeNames,
    stockLengthsForShape: stockLengthsForShape,
    stockWaistForShape: stockWaistForShape,
    averageMensBootByHeight: averageMensBootByHeight,
    combinedSizeFitScore: function (input, target) {
      return combinedSizeFitScore(normalizeState(input || {}), target || {});
    },
    boardWidthRecommendation: function (name, length, input) {
      var shape = BOARD_SHAPES[name];
      return shape ? boardWidthRecommendation(shape, normalizeState(input || {}), length) : null;
    },
    waistWidthOptions: function (name, length, input) {
      var shape = BOARD_SHAPES[name] || SKI_SHAPES[name];
      var source = Object.assign({}, input || {});
      if (SKI_SHAPES[name]) {
        source.collection = 'ski';
        source.product_type = 'skis';
      }
      var state = normalizeState(source);
      return shape ? stockWidthOptions(shape, state, length) : [];
    },
    flexPatternRecommendation: function (name, length, input) {
      var shape = BOARD_SHAPES[name] || SKI_SHAPES[name];
      if (!shape) return null;
      var source = Object.assign({}, input || {});
      if (SKI_SHAPES[name]) {
        source.collection = 'ski';
        source.product_type = 'skis';
      }
      var state = normalizeState(source);
      var stockLength = hasValue(length) ? number(length, null) : closestStockLength(shape, state).length;
      var suggestion = flexPatternRecommendation(shape, state, stockLength);
      return Object.assign({}, suggestion, { options: flexPatternOptions(shape, suggestion) });
    },
    skiWidthRecommendation: function (input) {
      var source = Object.assign({}, input || {}, { collection: 'ski', product_type: 'skis' });
      var state = normalizeState(source);
      var shape = SKI_SHAPES[state.shape_choice] || SKI_SHAPES.Tahsis;
      var stockLength = hasValue(source.stock_length)
        ? number(source.stock_length, null)
        : closestStockLength(shape, state).length;
      return skiWidthRecommendation(shape, state, stockLength);
    },
    shapePriorities: function (name) {
      var shape = BOARD_SHAPES[name] || SKI_SHAPES[name];
      return shape ? shape.priorities.slice() : [];
    },
    applyShapePriorityOverrides: applyShapePriorityOverrides,
    rideGoalProfile: function (id) {
      return RIDE_GOAL_PROFILE_OVERRIDES[id] ? JSON.parse(JSON.stringify(RIDE_GOAL_PROFILE_OVERRIDES[id])) : null;
    },
    applyRideGoalProfileOverrides: applyRideGoalProfileOverrides,
    applyCollectionShapeOverrides: applyCollectionShapeOverrides,
    rulesSchemaVersion: RULES_SCHEMA_VERSION,
    validateRulePayload: function (payload) {
      var result = normalizeRulePayload(payload);
      return result.ok ? { ok: true, schemaVersion: RULES_SCHEMA_VERSION } : result;
    },
    applyRulePayload: applyRulePayload,
    questionWeights: function () { return Object.assign({}, QUESTION_WEIGHTS); },
    applyQuestionWeightOverrides: applyQuestionWeightOverrides,
    collectionQuestionWeights: function () { return JSON.parse(JSON.stringify(COLLECTION_QUESTION_WEIGHTS)); },
    applyCollectionQuestionWeightOverrides: applyCollectionQuestionWeightOverrides,
    collectionGoalProfile: collectionGoalProfile,
    constructionOptionsForShape: function (shape, custom, productType) {
      return constructionOptionsForSelection(shape, Boolean(custom), productType);
    },
    recommendComposite: recommendComposite,
    constructionDetails: constructionDetails,
    proofAssets: proofAssets,
    shapePrices: mergeShapePrices(),
    calculatePrice: calculatePrice,
    buildEstimate: calculatePrice,
    buildSummary: buildSummary,
    selectionSummaries: selectionSummaries,
    label: label,
    formatHeight: formatHeight,
    formatWeight: formatWeight,
    formatBootSize: formatBootSize,
    formatMoney: formatMoney,
    analytics: {
      events: ANALYTICS_EVENTS,
      context: analyticsContext,
      sanitize: sanitizeAnalyticsPayload,
      publish: publishAnalyticsEvent,
      wait: waitForAnalytics
    },
    mount: mount
  };

  global.KindredCustomBuildIntake = api;
  global.KindredCustomBuildTest = {
    calculatePrice: function (prices, state) { return calculatePrice(state || {}, prices || {}); },
    buildSummary: function (state, config) { return buildSummary(state || {}, null, null, config || {}, {}); },
    recommend: recommend,
    recommendStock: recommendStock,
    recommendComposite: recommendComposite,
    proofAssets: proofAssets,
    syncGraphicImages: syncGraphicImages
  };

  if (typeof document !== 'undefined') {
    var start = function () {
      var firstRoot = document.querySelector('[data-custom-build-intake]');
      var firstConfig = firstRoot ? readConfig(firstRoot) : {};
      if (firstConfig.publishedRules !== undefined && firstConfig.publishedRules !== null) {
        var publishedResult = applyRulePayload(firstConfig.publishedRules);
        if (!publishedResult.ok && global.console && typeof global.console.warn === 'function') {
          global.console.warn('Kindred custom builder ignored invalid published rules and kept its built-in rules: ' + publishedResult.error);
        }
        mount(document);
        return;
      }
      loadShapePriorityOverrides(firstConfig.shapePrioritiesEndpoint || '').then(function () { mount(document); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
    document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
  }
})(typeof window !== 'undefined' ? window : globalThis);
